/// <reference path="../typings/index.d.ts" />
declare var Timer: any;
declare var mozHidden: any;
declare var chrome: any;
namespace App.Modulos {
  export class SniperExtensao {
    public static inicializar() {
      var sniper = new App.SniperExtensao();
      sniper.inicializarEventos();
    }
  }
}

namespace App {
  export class SniperExtensao {
    private ajax: IAjax;
    public static ehAppDesktop: boolean = false;
    public static versaoDesktop: any = 1;
    public static urlAppFut = 'https://www.ea.com/ea-sports-fc/ultimate-team/web-app/';
    //FORM SNIPER
    public static elFormCompra: JQuery = $("#formCompra");
    private elSniperPage: JQuery = $("#sniperPage");

    private static elBtSnipar: JQuery = $(".botao-snipar");
    private elBtLimparlog: JQuery = $(".limpar-log");
    private elBtnCopiarFiltroWebApp: JQuery = $(".copiar-filtro-webapp");
    private static elSpinner: JQuery = $("#spinnerSniper");
    private static elSpinnerCancelar: JQuery = $(".loading-cancelar");
    private elBtnPararSniper: JQuery = $(".parar-sniper");
    private elCampoMinimo: JQuery = $("input[name=minimo]");
    private elCampoMinFiltro: JQuery = $("input[name=min]");
    private elCampoJogador: JQuery = $("#jogador");
    private elCampoTela: JQuery = $("#tela");
    private elCampoValorMaximo: JQuery = $("input[name=max]");
    private elCampoValorVenda: JQuery = $("input[name=valor_venda]");
    private elCampoValorVendaLista: JQuery = $("input[name=valor_venda_lista]");
    private elCampoValorLanceMinimoVenda: JQuery = $("input[name=valor_lance_minimo]");
    private elCampoValorLanceMinimoVendaLista: JQuery = $("input[name=valor_lance_minimo_lista]");
    private elCampoClube: JQuery = $("select[name=time]");
    private elCampoLiga: JQuery = $("select[name=liga]");
    private elCampoNacionalidade: JQuery = $("select[name=pais]");
    private elCampoQualidade: JQuery = $("select[name=qualidade]");
    private elCampoRaridade: JQuery = $("select[name='raridade[]']");
    private elCampoEstilo: JQuery = $("select[name=estilo]");
    private elCampoEstiloJogo: JQuery = $("select[name=estilo_jogo]");
    private elCampoPosicao: JQuery = $("select[name=posicao]");
    public static elCampoNoUiSliderMaxCompras: any = null;
    public static elCampoNoUiSliderVelocidade: any = null;
    public static selectVelocidade: JQuery = $("select[name='milesegundos']");
    public static elCampoNoUiSliderTentativas: any = null;
    public static elCampoNoUiSliderIntervaloDescanso: any = null;
    public static elCampoNoUiSliderProgramarCompra: any = null;
    public static selectProgramarCompra: JQuery = $("select[name='programarCompra']");
    public static elCampoNoUiSliderTempoLance: any = null;
    public static elCampoNoUiSliderPorcentagemMaisBarato: any = null;
    public static elCampoNoUiSliderPorcentagemVendaMaisBarato: any = null;
    public static elCampoNoUiSliderPorcentagemVendaMaisBaratoListaLance: any = null;
    public static elCampoNoUiSliderPorcentagemVendaMaisBaratoListaTransferencia: any = null;
    public static elCampoNoUiSliderPorcentagemVendaMaisBaratoListaClube: any = null;
    public static elCampoNoUiSliderPrecoInteligente: any = null;
    public static elCampoNoUiSliderPrecoInteligenteLista: any = null;
    private objUiSliderModoPotente: any = null;
    //CONSUMÍVEIS
    private elCampoCategoria: JQuery = $("select[name=categoria]");
    private elConferenciaCategoria: JQuery = $(".conferencia-consumivel");
    //CARRINHO SNIPER
    private elInfoOferta: JQuery = $(".info-oferta");
    private elAtivarVendaAutomatica: JQuery = $("#ativarVendaAutomatica");
    private elConferenciaJogador: JQuery = $(".conferencia-jogador");
    private elConferenciaQualidade: JQuery = $(".conferencia-qualidade");
    private elConferenciaRaridade: JQuery = $(".conferencia-raridade");
    private elConferenciaPosicao: JQuery = $(".conferencia-posicao");
    private elConferenciaEstilo: JQuery = $(".conferencia-estilo");
    private elConferenciaTrocaPosicao: JQuery = $(".conferencia-troca");
    private elConferenciaPais: JQuery = $(".conferencia-nacionalidade");
    private elConferenciaLiga: JQuery = $(".conferencia-liga");
    private elConferenciaTime: JQuery = $(".conferencia-clube");
    private elBtSniperProgramado: JQuery = $(".bt-sniper-programado");
    private elBtIncrement: JQuery = $(".increment");
    private elBtDecrement: JQuery = $(".decrement");

    private elLinkSalvarFiltroIndisponivel: JQuery = $("#linkSalvarFiltroIndisponivel");
    private elLinkFiltrosIndisponiveis: JQuery = $("#linkFiltrosIndisponiveis");
    private elLinkLimparJogadoresElenco: JQuery = $("#linkLimparJogadoresElenco");
    private elBotaoIniciarAtualizacaoJogadoresElenco: JQuery = $("#botaoIniciarInformacaoJogadoresElenco");
    private elBotaoEscanearItensClube: JQuery = $(".botao-escanear-itens-clube");
    private elBotaoAtualizarListagens: JQuery = $(".botao-atualizar-listagens");
    private elBotaoEstimarLucro: JQuery = $(".btn-estimar-lucro");
    private elBotaoCloseAlertCookieBrowser: JQuery = $(".btn-close-alert-cookie-browser");

    private elRadioPreco: JQuery = $("input[name=precoCompra]");

    // Lucro Estimado
    private seletorLucroAtual = document.querySelector("#lucroAtual");
    private seletorEspacoLucro: JQuery = $("#lucroAtual");

    private ehSniperPorPrecoCompra: boolean = true;
    private ehSniperPorLucro: boolean = false;

    public static loopTentativas: any;
    public static loopIntervaloProgramado: any;
    public static loopIntervaloSniparEmTeste: any;
    private loopTelaWebAppInvisivel: any = null;
    private loopBuscarItemTransferenciaCoins: any = null;
    private transferenciaDeCoinsEmExecucao: boolean = false;
    public static tempoParaFinalizarLoopProgramado: any;
    public static tempoParaEstabelecerComunicacao: any;
    public static loopHabilitado: boolean = false;
    public static sniperAtivo: boolean = true;
    public static resolvendoCaptcha: boolean = false;
    public static recarregandoWebApp: boolean = false;
    public static timeoutTempoEsperaRecarregandoWebApp: any = null;
    public static comunicacaoEstabelecidaComWebApp: boolean = true;
    public static sniperProgramado: boolean;
    public static sniperTravado: number;
    public static listaNaoAtribuidosBloqueada: boolean = false;
    public static vendaAutomaticaAtiva: boolean;
    public static ehPadrao: boolean;
    public static ehVendaCoins: boolean;
    public static ehConsumiveis: boolean;
    public static ehJogadorEspecial: boolean;
    public static ehAnaliseClube: boolean;
    public static ehLance: boolean;
    public static ehLanceDinamico: boolean = false;
    public static ehModoCompraDme: boolean;
    public static webAppVisivel: boolean = true;
    public mercadoTranferencia: boolean = true;
    public static valorMinimo: number = 100;
    public static errorsSequencia: any;
    public static errorsCompraSequencia: any;
    public static errorsSequenciaVenda: any;
    public static passoPagina: string = null;
    public static indiceQuantidadePaginas: number = 1;
    public static descansoDeCompra: number = 0;
    public static acionadoPeloUsuario: boolean = false;
    public static movimentandoItens: boolean = false;
    //CONFIGURACOES FILTROS
    public static tempoProgramado: number;
    public static tempoIntervaloEntreTentativas: number;
    public static quantidadeMaximaCompras: number;
    public static quantidadeMaximaTentativasPorVez: number;
    public static cronometro: any;
    public static arrayItensVendaAutomatica: any;
    public static arrayLoopTentativas: any;
    public static arrayLoopLimpezaListaObs: any;
    public static arrayLoopIntervalos: any;
    public static arrayLoopTimeouts: any;
    public static vendaAutomaticaBloqueada: boolean;
    public static valorCoinMin: number = 150;
    public static valorCoinMax: number = 15000000;
    public static itensExpiradosOuComprados: any;
    public static eventoAppLoadStart: number = 1;
    public static eventoAppContextoStart: number = 2;
    public static eventoAppContextoStop: number = 3;
    public static eventoAppEncontrouItens: number = 4;
    public static eventoAppTelaTransferencia: number = 5;
    public static eventoAppHome: number = 6;
    public static dadosContaEa: IContaEa = null;
    public static dadosUserInfoEa: any = {};
    public static dadosListaTransferenciaEa: any = {};
    public static capacidadeListaDeObservacao: number = 0;
    public static capacidadeLimiteListaDeObservacao: number = 0;
    public static capacidadeHumanaListaDeObservacao: number = 5;
    public static quantidadeAtualListaDeObservacao: number = 0;
    public static quantidadeDisponivelListaDeObservacao: number = 0;
    public static capacidadeListaDeTransferencia: number = 0;
    public static quantidadeAtualListaDeTransferencia: number = 0;
    public static quantidadeAtualListaLance: number = 0;
    public static quantidadeDisponivelListaDeTransferencia: number = 0;
    public static tentando: boolean = false;
    public static configuracoesAtuais: any = null;
    private objFiltro: IFiltro = null;
    private dadosForm: any = null;
    private idExtensao: string = null;
    public static maxbInicial: number = 200;
    private tempoAcrescimoTentativa: number = 500;
    private static testeSniper: ITesteSniper = {};
    public static contexto: any = null;
    public static testeSucesso: boolean = false;
    public static messages: ILocateMessages;

    private snipadas: any = [];
    public static players: any = null;
    public static objJogadorDefault: any = { "f": "Não", "id": 0, "l": "Identificado", "r": 0 };
    private tentativaAtual: number = 0;
    private testeAtivo: boolean = false;
    private quantidadeLancesganhosAtuais: number = null;
    private loopTimeoutMontarDme: any = null;

    private alertaErroConexao: boolean = false;

    /**
     * Solucoes de problemas
     */
    private elementoPassoAutenticacao: JQuery = $("#autenticacao");
    private elementoPassoExtensaoInstalada: JQuery = $("#extensaoInstalada");
    private elementoPassoExtensaoAtualizada: JQuery = $("#extensaoAtualizada");
    private elementoPassoBuscaDeItem: JQuery = $("#buscaDeItem");
    private elementoPassoCompraDeItem: JQuery = $("#compraDeItem");
    private elementoBotaoTesteProblemas: JQuery = $("#botaoTesteProblemas");
    private elementoBotaoLimparCache: JQuery = $("#btnFswlimparCache");
    private elementoEspacoLimparCache: JQuery = $("#conteudoLimpezaCompleta");

    /**
     * Processo informação de jogadores do elenco
     */
    private elementoPassoInciadoProcessoInformacaoElenco: JQuery = $("#passoIniciarProcessoInformacaoJogadoresElenco");
    private elementoPassoCarregamentoWebApp: JQuery = $("#passoCarregamentoWebApp");
    private elementoPassoIdentificacaoJogadoresClube: JQuery = $("#passoIdentificacaoJogadoresClube");

    private elBtnAutenticar: JQuery = $(".btn-autenticar-conta");

    public static contasEa: any = [];
    private autenticando: boolean = false;
    public static coinsTotal: number | any = 0;
    private banometro: any = null;

    private idListagemLance: number = 1;
    private idListagemTransferencia: number = 2;
    private idListagemClube: number = 3;

    private static elementoListagemLanceContexto: IContextoListagem;
    private static elementoListagemTransferenciaContexto: IContextoListagem;
    private static elementoListagemClubeContexto: IContextoListagem;

    private elementoBotaoVenderSelecionadosLista: JQuery = $(".btn-vender-selecionados-lista");
    private elementoBotaoBtnVendaRapidaLista: JQuery = $(".btn-venda-rapida");
    private modo_listagem_status: number = 0;

    public static arrayListaLance: IItemListagem[] = [];
    public static arrayListaTransferencia: IItemListagem[] = [];
    public static arrayListaClube: IItemListagem[] = [];

    private keyStorageListagemFutbin: string = "key_storage_listagem_futbin";
    public static keyStorageListagemClube: string = "fsw_array_listagem_jogadores_clube_";
    public static keyStorageUltimaAtualizacaoJogadoresClube: string = "fsw_array_ultima_atualizacao_jogadores_clube_";
    private objStorageListagemFutbin: IStorageLista = { update_at: null, lista: [] };

    private elementoBotaoBuscarPrecosFutbin: JQuery = $(".btn-buscar-precos-futbin");
    private elementoBotaoSelecionarDeselecionarTudoListagem: JQuery = $(".btn-selectall-deselectall");
    private objConfiguracoesConta: ConfiguracoesConta = null;
    private objConfiguracoesGeral: Configuracao = null;

    private static analisePrecoAtiva: boolean = false;
    private loopBuscaPreco: any = null;
    private tentandoEncontrarPreco: boolean = false;
    private arrayLoopAddJogadoresCompraDme: any = [];
    public static totalGastoCompraDme: number = 0;
    // Usando para filtrar no resultado da pagina pelo time do jogador
    private filtroPagina: any = null;

    private typeFiltroConsumivelComissaoItensClube: string = "training";

    public static ultimoEventSubmit: JQueryEventObject = null;
    private vendaCoins: any = null;
    private informandoCaptcha: boolean = false;
    private historicoLucro: any = {};
    private chaveStorageHistoricoDme: string = "";
    private storageLocal: any = null;
    private autoDme: AutoDme = null;

    // calculadora
    private calcValor: JQuery = $("#calcValor");
    private calcValorDesejadoPorCarta: JQuery = $("#calcValorDesejadoPorCarta");

    private arrayJogadoresOfertaCompra: { id: number, oferta: number }[] = [];

    private chaveStorageEstatisticasPrefix: string = "fsw_stcs_";
    private estatisticasRequests: any = null;
    private estatisticaTempoUso: any = null;
    private ultimaAtualizacaoTempoExecucao: any = null;
    private ultimoUpdateEstatisticaDaConta: any = null;
    private gerenciamentoRiscoInfos: { vitoriasRivals: number, vitoriasWl: number, limiteUsoEmHoras: number, limiteRequests: number, limiteUsoEmMinutos: number } = { vitoriasRivals: 0, vitoriasWl: 0, limiteUsoEmHoras: 2, limiteUsoEmMinutos: 120, limiteRequests: 1000 };
    private partidas: { won: number, draw: number, loss: number } = { won: 0, draw: 0, loss: 0 }
    private salvandoEstatisticas: boolean = false;

    private static EVENTO_BUSCA = 1;
    private static EVENTO_COMPRA = 2;
    private static EVENTO_CAPTCHA = 3;
    private static EVENTO_SOFTBAN = 4;

    private static objSelect2: ISelect2 = null;

    private elBtnFormElencoDme: JQuery = $("#formObterElencoDme");
    private esperandoEscanearElenco: boolean = false;

    private static idsLigasFemininas: any = [
      2215, // GPFBL (Frauen-Bundesliga, Alemanha)
      2216, // Barclays WSL (Inglaterra)
      2218, // Arkema PL (França)
      2221, // NWSL (EUA)
      2222, // Liga F (Espanha)
      2228, // Liga Portugal Feminino (Portugal)
      2229, // Nederland Vrouwen Liga (Holanda)
      2230, // Ceska Liga Žen (República Tcheca)
      2231, // Schweizer Damen Liga (Suíça)
      2232, // Sverige Liga (Suécia)
      2233, // Scottish Women's League (Escócia)
      2236  // Calcio A Femminile (Itália)
    ];

    static dadosExportados: { exportados: { raridades: any[], paises: any[], ligas: any[], clubes: any[] } } = null;

    private monitorarSniperAtivoInterval: any = null;
    private ultimoSniperAtivo: boolean = null;

    public inicializarEventos() {
      if ($('body').data('contexto') == 'site') {
        return;
      }

      if (!App.Util.ehChromeConfigurado()) {
        $(".alert-versao-background").show();
        $(".alerta-manter-aba-webapp").show();
      }

      let ehNavegadorMobileFuncionando = isMobile.any && !App.Util.strContains(navigator.userAgent, $('#sniperPage').data('navegadoresMobile').split(','));
      App.SniperExtensao.elBtSnipar.prop('disabled', true);
      var bloquearDebug = new BloquearDebug();
      bloquearDebug.bloquearDepuracao((App.Util.isset(App.Util.config) && !App.Util.empty(App.Util.config) && App.Util.config.hasOwnProperty('habilitarConsoleDebug') ? App.Util.config.habilitarConsoleDebug : false));
      // if (ehNavegadorMobileFuncionando) {
      //     window.location.href = '/ajuda/usar-no-celular';
      //     return;
      // }

      App.SniperExtensao.elBtSnipar.on('click', () => {
        this.limparInfoTentativasEcompras();
        App.SniperExtensao.elFormCompra.submit();
        this.aoAtivarVendaLucroEstimado(false);
      });
      if (App.Util.config.naoValidarPlano) {
        App.SniperExtensao.elFormCompra.on('submit', (e) => { e.preventDefault(); this.aoSnipar(e); });
      } else {
        App.SniperExtensao.elFormCompra.on('submit', (e) => { this.validarPlano(e); });
      }

      this.elBtnFormElencoDme.on('submit', (e) => { e.preventDefault(); this.aoEnviarUrlElencoFutbin(e); });

      this.elBtnPararSniper.on('click', (e) => { this.aoPararCompra(e); });
      this.elBtLimparlog.on('click', (e) => { this.aoLimparLog(e); });
      this.elBtnCopiarFiltroWebApp.on('click', (e) => { this.copiarFiltroWebApp(e); });
      this.elBotaoEscanearItensClube.on('click', (e) => { this.aoEscanearItensClube(e); });
      this.elBotaoAtualizarListagens.on('click', (e) => { this.aoAtualizarListagens(e); });
      this.elBotaoEstimarLucro.on('click', (e) => { this.estimarLucro(); });
      this.elBotaoCloseAlertCookieBrowser.on('click', (e) => { this.closeAlertCookieBrowser(); });

      var timer: any = 0;
      this.elBtIncrement.on('click', (e) => { this.aoIncrementarValor(e); });
      this.elBtDecrement.on('click', (e) => { this.aoDecrementarValor(e); });
      this.elBtIncrement.on("mousedown", (e) => {
        timer = setInterval(() => {
          this.aoIncrementarValor(e);
        }, 120);
      }).on("mouseup mouseleave", () => {
        clearInterval(timer);
      });
      this.elBtDecrement.on("mousedown", (e) => {
        timer = setInterval(() => {
          this.aoDecrementarValor(e);
        }, 120);
      }).on("mouseup mouseleave", () => {
        clearInterval(timer);
      });
      this.elLinkSalvarFiltroIndisponivel.on('click', () => { this.aoClicarLinkFiltrosIndisponiveis(); });
      this.elLinkFiltrosIndisponiveis.on('click', () => { this.aoClicarLinkFiltrosIndisponiveis(); });

      this.elCampoJogador.on('change keyup', (e) => { this.aoInformarJogador(e); });
      this.elCampoClube.on('change keyup', (e) => { this.aoAlterarCampoSelect(e, this.elConferenciaTime); });
      this.elCampoLiga.on('change keyup', (e) => { this.aoAlterarLiga(e, this.elConferenciaLiga); });
      this.elCampoNacionalidade.on('change keyup', (e) => { this.aoAlterarCampoSelect(e, this.elConferenciaPais); });
      this.elCampoQualidade.on('change keyup', (e) => { this.aoAlterarCampoSelect(e, this.elConferenciaQualidade); });
      this.elCampoRaridade.on('change keyup', (e) => { this.aoAlterarCampoSelect(e, this.elConferenciaRaridade); });

      this.elCampoQualidade.on("select2:select", (e) => { this.aoSelecionarCampoQualidade(e); });
      this.elCampoQualidade.on("select2:unselect", (e) => { this.aoSelecionarCampoQualidade(e); });

      this.elCampoRaridade.on("select2:select", (e) => { this.aoSelecionarCampoRaridade(e); });
      this.elCampoRaridade.on("select2:unselect", (e) => { this.aoSelecionarCampoRaridade(e); });

      this.elCampoEstilo.on('change keyup', (e) => { this.aoAlterarCampoSelect(e, this.elConferenciaEstilo); });
      this.elCampoPosicao.on('change keyup', (e) => { this.aoAlterarCampoSelect(e, this.elConferenciaPosicao); });
      this.elCampoValorMaximo.on('change keyup', (e) => { this.aoInformarValor(e); });
      this.elCampoValorVenda.on('change keyup', (e) => { this.aoInformarValorVenda(e); });
      this.elCampoValorMaximo.on('focusout', (e) => { this.aoPerderFocoCampoValor(e); });
      this.elCampoValorVenda.on('focusout', (e) => { this.aoPerderFocoCampoValor(e); });
      this.elCampoValorVendaLista.on('focusout', (e) => { this.aoPerderFocoCampoValor(e); });
      this.elCampoValorLanceMinimoVenda.on('focusout', (e) => { this.aoPerderFocoCampoValor(e); });
      this.elCampoValorLanceMinimoVendaLista.on('focusout', (e) => { this.aoPerderFocoCampoValor(e); });
      this.elCampoMinFiltro.on('focusout', (e) => { this.aoPerderFocoCampoValor(e); });
      this.elAtivarVendaAutomatica.on('change', (e) => { this.aoSelecionarVendaAutomatica(e); });
      $("#corrigirBugEa").on('change', (e) => { this.aoSelecionarCorrigirBugEA(e); });
      $("#ativarPrecoVendaFutbin").on('change', (e) => { this.aoSelecionarVendaPrecoFutbin(e); });
      $(".ativar-preco-venda-futbin-lista").on('change', (e) => { this.aoSelecionarVendaPrecoFutbinLista(e); });
      $("#ativarPrecoVendaInteligente").on('change', (e) => { this.aoSelecionarVendaPrecoInteligente(e); });
      $("#ativarPrecoVendaInteligenteLista").on('change', (e) => { this.aoSelecionarVendaPrecoInteligenteLista(e); });
      this.elCampoCategoria.on('change keyup', (e) => { this.aoAlterarCategoria(e); });
      $("#collapseOne").on('show.bs.collapse', (e) => { this.aoExibirModoCompraElenco(e) });
      $("#collapseOne").on('hide.bs.collapse', (e) => { this.aoOcultarModoCompraElenco(e) });
      $("#modalInfoAntiBan").on('show.bs.modal', (e) => { this.aoAbrirModalUso(e) });
      $("input[name=modo_lance]").on('change', (e) => { this.aoSelecionarModoLance(e); });
      $("#botaoMontarDme").on('click', (e) => { this.montarElencoDme() });
      $("#botaoMontarDmeConceito").on('click', (e) => { this.montarElencoDme() });

      $("input[name='quantidadesMaxCompras']").on('change keyup', (e) => { this.aoAlterarLimiteCompra(e); });

      this.elBtnAutenticar.on('click', (e) => { this.aoClicarEmAutenticarConta(e) });

      this.elRadioPreco.on('change', (e) => { this.aoSelecionarTipoPrecoCompra(e); });

      $('input[name=valor_oferta_jogador]').on('change keyup', (e) => { this.aoAlterarIputOfertaCompraJogador(e); });
      $('input[name=valor_oferta_jogador]').on('focusout', (e) => { this.aoPerderFocoCampoValor(e); });

      App.SniperExtensao.sniperTravado = 0;
      App.SniperExtensao.sniperProgramado = false;
      App.SniperExtensao.vendaAutomaticaAtiva = false;
      App.SniperExtensao.vendaAutomaticaBloqueada = false;
      App.SniperExtensao.ehPadrao = this.elCampoTela.val() == 1;
      App.SniperExtensao.ehConsumiveis = this.elCampoTela.val() == 2;
      App.SniperExtensao.ehJogadorEspecial = this.elCampoTela.val() == 3;
      App.SniperExtensao.ehAnaliseClube = this.elCampoTela.val() == 4;
      App.SniperExtensao.ehVendaCoins = this.elCampoTela.val() == 5;
      App.SniperExtensao.ehLance = this.elCampoTela.val() == 6;
      App.SniperExtensao.ehModoCompraDme = $("input[name=modo_compra_dme]").val() == 1;
      App.SniperExtensao.errorsSequencia = 0;
      App.SniperExtensao.errorsCompraSequencia = 0;
      App.SniperExtensao.errorsSequenciaVenda = 0;
      App.SniperExtensao.sniperAtivo = false;
      App.SniperExtensao.arrayItensVendaAutomatica = [];
      App.SniperExtensao.arrayLoopTentativas = [];
      App.SniperExtensao.arrayLoopLimpezaListaObs = [];
      App.SniperExtensao.arrayLoopIntervalos = [];
      App.SniperExtensao.itensExpiradosOuComprados = [];
      if (App.SniperExtensao.ehPadrao && !App.Util.elencoDme) {
        App.Util.editarPrecoJogadoresSelecionados = true;
      }

      var locateMessages = new Locate();
      App.SniperExtensao.messages = locateMessages.getMessages(App.Util.locate);
      App.Util.exibirModalPaginaCarregando();

      App.SniperExtensao.cronometro = new Timer();
      this.ajustarCabecalho();
      this.ajax = new App.Ajax();
      this.inicializarCamposNoUiSlider();
      var salvarFiltro = new SalvarFiltro();
      salvarFiltro.inicializarEventos(App.SniperExtensao);
      var notificacoes = new Notificacao();
      this.storageLocal = new StorageLocal();

      setTimeout(() => {
        if ($('#idExtensao').val() != "") {
          this.idExtensao = $('#idExtensao').val();
        }

        if (this.idExtensao == "kdbmbhhnccbifmaenknmocpeijmojbfj") {
          App.Util.ocultarModalPaginaCarregando();
          this.exibirMensagemAlertaSwal("Remova a Extensão", "Por Favor, remova a extensão <b>FutSniperWeb</b> de seu navegador para não causar problemas com a Extensão <b><a>FutSniperExtension</a></b>", "", "Extensão Correta", "ok", '#172b4d', true, App.Util.config.urlExtensaoChromeFse, null, null, "/img/exemplos/remover-extensao.png");
          return;
        }

        try {
          chrome.runtime.sendMessage("kdbmbhhnccbifmaenknmocpeijmojbfj", { evento: "inst" },
            (resposta: any) => {
              if (resposta) {
                App.Util.ocultarModalPaginaCarregando();
                this.exibirMensagemAlertaSwal("Remova a Extensão", "Por Favor, remova a extensão <b>FutSniperWeb</b> de seu navegador para não causar problemas com a Extensão <b><a>FutSniperExtension</a></b>", "", "Extensão Correta", "ok", '#172b4d', true, App.Util.config.urlExtensaoChromeFse, null, null, "/img/exemplos/remover-extensao.png");
                return;
              }
            });
        } catch (e) {
        }

        this.corrigirDuplicacaoWebApp();
        this.eliminarDuplicacaoPaginaFSW();
        /**
        * TEMP
        */
        $("#corrigirBugEa").prop("checked", localStorage.getItem('bugcheckedEa') == '1').trigger('change');

        try {
          chrome.runtime.sendMessage(this.idExtensao, { evento: "inst" },
            (resposta: any) => {
              if (resposta) {
                try {
                  if (!App.Util.ehIframe && !App.Util.ehChromeConfigurado() && !$(".sniper-page").hasClass('sniper-mobile')) {
                    this.openPopUpChromeExtension()
                  } else {
                    this.inicializarSniper();
                  }
                } catch (e) {
                  App.Util.ocultarModalPaginaCarregando();
                  this.exibirMensagemAlertaSwal("Carregamento Incompleto!", "Siga os Passos do Video na Home, instale a extensão FutSniperExtension, Faça login em sua conta EA e só depois disso acesse essa Página, se o problema persistir, mande um e-mail para contato@futsniperweb.com.br com o print de desse ERRO:" + e, "error", "OK", "Fechar", "#2dce89", false);
                }
              } else {
                App.Util.ocultarModalPaginaCarregando();
                if (ehNavegadorMobileFuncionando) {
                  setTimeout(() => {
                    window.location.href = '/ajuda/usar-no-celular';
                  }, 2700);
                }
                this.exibirMensagemAlertaSwal("Extensão não instalada!", "A extensão FutSniperExtension não está instalada no seu navegador ou está desatualizada ou não foi instalada corretamente.", "warning", "Instalar extensão", "Fechar", '#3740FF', true, App.Util.config.urlExtensaoChromeFse);
              }
            });
        } catch (err) {
          if (ehNavegadorMobileFuncionando) {
            setTimeout(() => {
              window.location.href = '/ajuda/usar-no-celular';
            }, 2700);
          }
          this.exibirMensagemAlertaSwal("Extensão não instalada ou desatualizada!", "A extensão FutSniperExtension não está instalada no seu navegador ou pode estar desatualizada, instale a extensão ou reinstale se já tiver instalado anteriormente.", "warning", "Instalar extensão", "Fechar", '#3740FF', true, App.Util.config.urlExtensaoChromeFse);
          App.Util.ocultarModalPaginaCarregando();
          return false;
        }
      }, 3500);

      window.addEventListener("fswAtualizarDadosWebApp", (evt: any) => {
        this.atualizarDadosWebApp(evt.detail);
      }, false);

      window.addEventListener("message", (e: any) => {
        // toDo desabilitar Verificação Extensão temporariamente
        // if (App.Util.inArray(e.origin, App.Util.config.origensExtensaoChrome)) {
        this.atualizarDadosWebApp(e.data);
        // }
      }, false);

      this.inicializarSolucoesDeProblemas();
      this.inicializarEventosDataTables();

      App.SniperExtensao.elementoListagemLanceContexto = { el: null, elTabela: null, tipo: null, dataTable: null, arrayListagem: null };
      App.SniperExtensao.elementoListagemLanceContexto = this.getObjListagemContexto(null, this.idListagemLance);
      App.SniperExtensao.elementoListagemLanceContexto.dataTable = this.inicializarLista(App.SniperExtensao.elementoListagemLanceContexto, this);

      App.SniperExtensao.elementoListagemTransferenciaContexto = { el: null, elTabela: null, tipo: null, dataTable: null, arrayListagem: null };
      App.SniperExtensao.elementoListagemTransferenciaContexto = this.getObjListagemContexto(null, this.idListagemTransferencia);
      App.SniperExtensao.elementoListagemTransferenciaContexto.dataTable = this.inicializarLista(App.SniperExtensao.elementoListagemTransferenciaContexto, this);

      App.SniperExtensao.elementoListagemClubeContexto = { el: null, elTabela: null, tipo: null, dataTable: null, arrayListagem: null };
      App.SniperExtensao.elementoListagemClubeContexto = this.getObjListagemContexto(null, this.idListagemClube);
      App.SniperExtensao.elementoListagemClubeContexto.dataTable = this.inicializarLista(App.SniperExtensao.elementoListagemClubeContexto, this);

      SniperExtensao.processarAlertaTelaMinimizada();

      this.calcValor.on('change keyup', (e) => { this.calculadora(e); });
      this.calcValorDesejadoPorCarta.on('change keyup', (e) => { this.calculadora(e); });

      App.SniperExtensao.objSelect2 = new Select2();
      App.SniperExtensao.objSelect2.inicializarCampo($('.select-tag'), Util.getOptionsSelectTag());
      this.inicializarMetodosEnvioCromprovante()
    }

    private inicializarMetodosEnvioCromprovante() {
      setTimeout(() => {
        Util.exibirNotificacaoPlanoExpirando()
      }, 4000);
    }

    public static ajustarParaVersaoDesktop(rotaApp: string = "/app", versao: any = 1) {
      SniperExtensao.ehAppDesktop = true;
      SniperExtensao.versaoDesktop = versao;
      $('#btnRotaApp').attr('href', rotaApp);
    }

    public static processarAlertaTelaMinimizada() {
      if (SniperExtensao.ehAppDesktop) {
        $('.aviso-tela-minimizada').hide();
      } else {
        $('.aviso-tela-minimizada').show();
      }
    }

    private iniciarconfiguracao() {
      this.objConfiguracoesGeral = new App.Configuracao();
      this.objConfiguracoesGeral.executarCallbackChange = (obj: IConfiguracaoUsuario) => {
        if (App.Util.isset(obj.modo_silencioso)) {
          App.Util.usuario.configuracao.modo_silencioso = obj.modo_silencioso;
        }
        if (App.Util.isset(obj.modo_humano)) {
          App.Util.usuario.configuracao.modo_humano = obj.modo_humano;
        }
      }
    }

    private iniciarConfiguracoesDeConta() {
      this.objConfiguracoesConta = new App.ConfiguracoesConta($("#modalConfigExtensao"));
      this.objConfiguracoesConta.executarCallbackChange = (obj: IConfiguracoesConta) => {
        if (App.Util.isset(obj.modo_potente)) {
          App.Util.usuario.configuracaoConta.modo_potente = obj.modo_potente;
        }
        if (App.Util.isset(obj.manter_no_cemiterio)) {
          App.Util.usuario.configuracaoConta.manter_no_cemiterio = obj.manter_no_cemiterio;
        }
        if (App.Util.isset(obj.lance_infinito)) {
          App.Util.usuario.configuracaoConta.lance_infinito = false;
          // App.Util.usuario.configuracaoConta.lance_infinito = obj.lance_infinito;
        }
        if (App.Util.isset(obj.aumentar_capacidade_venda_ativa)) {
          App.Util.usuario.configuracaoConta.aumentar_capacidade_venda_ativa = obj.aumentar_capacidade_venda_ativa;
        }
        if (App.Util.isset(obj.resolver_captcha_automaticamente)) {
          App.Util.usuario.configuracaoConta.resolver_captcha_automaticamente = obj.resolver_captcha_automaticamente;
        }
        if (App.Util.isset(obj.relistar)) {
          App.Util.usuario.configuracaoConta.relistar = $.isNumeric(obj.relistar) ? parseInt(obj.relistar) : obj.relistar;
        }
        if (App.Util.isset(obj.retirar_vendidos)) {
          App.Util.usuario.configuracaoConta.retirar_vendidos = obj.retirar_vendidos;
        }
        if (App.Util.isset(obj.pular_animacao_abertura_pacote)) {
          App.Util.usuario.configuracaoConta.pular_animacao_abertura_pacote = obj.pular_animacao_abertura_pacote;
        }
        if (App.Util.isset(obj.evitar_prejuizo_venda)) {
          App.Util.usuario.configuracaoConta.evitar_prejuizo_venda = obj.evitar_prejuizo_venda;
        }
        if (App.Util.isset(obj.modo_background)) {
          App.Util.usuario.configuracaoConta.modo_background = obj.modo_background;
        }
        /**
        * Salvar configurações no storage da extensao
        */
        this.setConfiguracoesStorageExtensao();

        return;
      }

      this.objConfiguracoesConta.idContaEa = App.SniperExtensao.dadosContaEa.id
    }

    private setConfiguracoesStorageExtensao() {
      App.Util.usuario.configuracaoConta.economizar_memoria = false;
      App.Util.usuario.configuracaoConta.lance_infinito = false;
      chrome.runtime.sendMessage(this.idExtensao, { evento: "setconfig", configuracoes: App.Util.usuario.configuracaoConta }, (respostaSetConfig: any) => {
      });
    }

    private atualizarConfiguracoesDeConta(callback: any = null) {
      this.ajax.get(App.Util.config.urlConfiguracaoConta, { id: App.SniperExtensao.dadosContaEa.id }, (dadosSucesso: IRespostaSucessoAjx) => {
        this.objConfiguracoesConta.idContaEa = App.SniperExtensao.dadosContaEa.id
        App.Util.usuario.configuracaoConta = dadosSucesso.dadosRetornados;
        this.objConfiguracoesConta.setConfiguracoes(App.Util.usuario.configuracaoConta)
        App.Util.usuario.configuracaoConta.correcao_bug_ea = localStorage.getItem('bugcheckedEa') == '1';
        App.Util.usuario.configuracaoConta.modo_lance = App.SniperExtensao.ehLance;
        App.Util.usuario.configuracaoConta.transferencia_coins = App.SniperExtensao.ehVendaCoins;
        if (callback) {
          callback(App.Util.usuario.configuracaoConta);
        }
      }, (dadosErro: IRespostaErroAjx) => {
      }, null, false);
    }


    private inicializarSniper() {
      /**
      * Se extensao desatualizada
      */
      if (App.SniperExtensao.ehVersaoDesatualizadaExtensao()) {
        App.Util.ocultarModalPaginaCarregando();
        this.exibirMensagemExtensaoDesatualizada();
        return;
      }

      if (App.SniperExtensao.ehModoCompraDme) {
        this.autoDme = new AutoDme(this.idExtensao, this.exibirLog);
        /**
         * Ao abrir /app?modo_elenco_dme=1, pede à extensão para acessar o menu de DME no WebApp
         * (se ele já estiver aberto e carregado). Assim a lista de DMEs desta tela chega
         * atualizada sozinha. O pequeno atraso evita competir com a inicialização da página; a
         * extensão ignora o comando se houver execução de DME ou captcha em andamento.
         */
        var autoDmeParaMenu = this.autoDme;
        setTimeout(function () {
          if (autoDmeParaMenu) autoDmeParaMenu.abrirMenuDmeNoWebApp();
        }, 1500);
      }

      this.getPlayers(() => {
        this.obterDadosContaAtualAutenticada(() => {

          /**
          * Se não autenticou
          */
          if (!App.SniperExtensao.dadosContaEa || (App.SniperExtensao.dadosContaEa && !App.SniperExtensao.dadosContaEa.autenticada)) {
            App.Util.ocultarModalPaginaCarregando();
            App.SniperExtensao.sniperTravado = 1;
            App.SniperExtensao.exibirMensagemSnipeTravado("Sistema não autenticado, você precisa fazer login no WEB APP da sua conta do FIFA e recarregar novamente essa página");
            return;
          }

          this.salvarContaEa();

          if (!App.Util.config.naoValidarPlano) {
            this.validarPlano(null);
          } else {
            App.Util.ocultarModalPaginaCarregando();
          }

          this.iniciarconfiguracao();
          this.iniciarConfiguracoesDeConta()
          this.atualizarConfiguracoesDeConta(() => {
            App.SniperExtensao.registrarDadosDaContaEa()
            this.registrarChavesStorage()
            /**
             * Salvar configurações no storage da extensao
            */
            this.setConfiguracoesStorageExtensao();
            $("#inputhiddenIdPlataforma").val(App.Util.usuario.id_plataforma.toString());
            App.SniperExtensao.elBtSnipar.prop('disabled', false);
            this.elementoEspacoLimparCache.show();
            this.inicializarBanometro();
            this.inicializarArrayListaClube();
            this.inicializarLimpezaCache();
            this.removerLinkCarregamentoIncompletoScripts();
            this.inicializarAnaliseDeClube();
            this.inicializarQuantidadeCompraDiaria();
            this.aoExibirModoCompraElenco(null);
            this.atualizarListagens();
            this.iniciarFuncionalidadeLucro();
            // toDo Lance App.SniperExtensao.ehLanceDinamico = App.SniperExtensao.ehLance;
            App.SniperExtensao.ehLanceDinamico = false;
            this.ajustarVendaAutomaticaConsumivel();

            this.sincronizarEstatisticasContaComBaseDados(() => {
              this.inicializarEstatisticas();
            })
          });
        });
      });

      this.monitorarSniperAtivo()
    }

    private registrarChavesStorage() {
      this.chaveStorageHistoricoDme = `historico_dmes_importados_${App.SniperExtensao.dadosContaEa.id}`;
    }

    private ajustarVendaAutomaticaConsumivel() {
      if (App.SniperExtensao.ehConsumiveis) {
        $("#corpoVendaAutomatica").find('hr').remove();
        $("#corpoVendaAutomatica").find('.espaco-preco-venda-inteligente').hide();
        $("#corpoVendaAutomatica").find('.espaco-preco-venda-futbin').hide();
      }
    }

    private obterDadosContaAtualAutenticada(metodoCallback: any) {
      chrome.runtime.sendMessage(this.idExtensao, { evento: "ctaut" }, (resultado: any) => {
        const err = chrome.runtime.lastError;
        if (err) {
          console.log("ctaut lastError:", err.message);
          // aqui você já sabe o motivo (muito comum: receiver não existe / não permitido)
          return;
        }

        console.log("AQUIIII ctaut", resultado);

        if (!resultado || !Object.prototype.hasOwnProperty.call(resultado, "conta")) {
          App.Util.ocultarModalPaginaCarregando();
          this.exibirMensagemAlertaSwal(
            "Conta EA não Autenticada!",
            "Faça login em sua conta EA, carregue totalmente a pagina do WebApp e só depois disso acesse essa Página",
            "error",
            "OK",
            "Fechar",
            "#2dce89",
            false
          );
          return;
        }

        App.SniperExtensao.dadosContaEa = resultado.conta;
        App.SniperExtensao.dadosContaEa.ptf = App.Util.getNomePlataforma(App.SniperExtensao.dadosContaEa.ptf);
        App.SniperExtensao.dadosUserInfoEa = null;

        metodoCallback();
        this.atualizarExibicaoClubeAtual();

        this.tratarRespostPartidas({ partidas: resultado.conta.partidas });
      });

    }

    private inicializarBanometro() {
      if (App.Util.existeElementoNaPagina($("#gauge"))) {
        this.banometro = new TermometroJustGage().inicializarCampo("gauge", 1);
        this.atualizarBanometro();
      }
    }

    private atualizarBanometro() {
      try {
        this.ajax = new Ajax();
        this.ajax.get(App.Util.config.urlDadosUso, { idContaEa: App.SniperExtensao.dadosContaEa.id }, (dadosSucesso: IRespostaSucessoAjx) => {
          var uso: IUso = dadosSucesso.dadosRetornados;
          this.banometro.refresh(uso.risco);
          this.atualizarViewModalBanometro(uso);
        }, (dadosErro: IRespostaErroAjx) => {
        }, null, false);
      } catch (e) {
      }
    }

    private atualizarViewModalBanometro(uso: IUso) {
      var modalInfoBan = $("#modalInfoAntiBan");
      modalInfoBan.find('.info-uso-sequencia-maior').html(uso.horasEmSequencia.maior.toString());
      modalInfoBan.find('.info-uso-sequencia-acumulada').html(uso.horasEmSequencia.acumulada.toString());
      modalInfoBan.find('.info-uso-sequencia-quantidade').html(uso.horasEmSequencia.repetiu.toString());
      modalInfoBan.find('.info-uso-compras').html(uso.quantidadeComprasNasUltimasHoras.toString());
      if (uso.risco < 5) {
        modalInfoBan.find('.icon-shape').removeClass('bg-gradient-red').removeClass('bg-gradient-green').removeClass('bg-gradient-yellow').addClass('bg-gradient-green');
      } else if (uso.risco <= 8) {
        modalInfoBan.find('.icon-shape').removeClass('bg-gradient-red').removeClass('bg-gradient-green').removeClass('bg-gradient-yellow').addClass('bg-gradient-yellow');
      } else {
        modalInfoBan.find('.icon-shape').removeClass('bg-gradient-red').removeClass('bg-gradient-green').removeClass('bg-gradient-yellow').addClass('bg-gradient-red');
      }
    }

    private inicializarCamposNoUiSlider() {
      if (App.SniperExtensao.ehVendaCoins) {
        return;
      }

      if (!App.SniperExtensao.ehLance) {
        //   App.SniperExtensao.elCampoNoUiSliderVelocidade = new CampoNoUiSlider().inicializarCampo('sliderVelocidade', $("input[name=milesegundos]"),
        //     { 'min': 1000, '35%': 1400, '60%': 2000, '80%': 4000, 'max': 7000 }, 'rtl');
        //   App.SniperExtensao.elCampoNoUiSliderVelocidade.noUiSlider.on('set', function (values: any, handle: any) {
        //     var valor = parseInt(values[handle]);
        //     var showSliderLabelAlert = $("input[name=milesegundos]").data('showSliderLabelAlert');
        //     if (showSliderLabelAlert) {
        //       if (App.Util.inArray(valor.toString(), App.Util.stringParseJsonObject(showSliderLabelAlert))) {
        //         $("input[name=milesegundos]").parent('.espaco-slider').find('.slider-label-alert').show();
        //       } else {
        //         $("input[name=milesegundos]").parent('.espaco-slider').find('.slider-label-alert').hide();
        //       }
        //     }
        //     $('input[name=milesegundos]').val(valor);
        //   });
      }
      if (!App.SniperExtensao.ehLance) {
        if (this.modoHumanoAtivo()) {
          App.SniperExtensao.elCampoNoUiSliderTentativas = new CampoNoUiSlider().inicializarCampo('sliderQuantidadesTentativa', $('input[name=quantidadesMaxTentativas]'),
            { 'min': 10, '20%': 15, '35%': 20, '50%': 25, '65%': 30, '80%': 40, 'max': 50 });
        } else {
          App.SniperExtensao.elCampoNoUiSliderTentativas = new CampoNoUiSlider().inicializarCampo('sliderQuantidadesTentativa', $('input[name=quantidadesMaxTentativas]'),
            { 'min': 10, '15%': 15, '30%': 20, '45%': 25, '60%': 30, '75%': 40, '90%': 50, 'max': 100 });
        }

        App.SniperExtensao.elCampoNoUiSliderTentativas.noUiSlider.on('set', function (values: any, handle: any) {
          $('input[name=quantidadesMaxTentativas]').val(parseInt(values[handle]));
        });
      }

      if (this.modoHumanoAtivo()) {
        App.SniperExtensao.elCampoNoUiSliderIntervaloDescanso = new CampoNoUiSlider().inicializarCampo('sliderIntervaloDescanso', $("input[name=programarIntervalo]"),
          { 'min': 0, '25%': 1, '55%': 2, '80%': 3, 'max': 4 });
      } else {
        App.SniperExtensao.elCampoNoUiSliderIntervaloDescanso = new CampoNoUiSlider().inicializarCampo('sliderIntervaloDescanso', $("input[name=programarIntervalo]"),
          { 'min': 0, '20%': 1, '40%': 2, '60%': 4, '80%': 6, 'max': 8 });
      }


      App.SniperExtensao.elCampoNoUiSliderIntervaloDescanso.noUiSlider.on('set', function (values: any, handle: any) {
        var valor = parseInt(values[handle]);
        var showSliderLabelAlert = $("input[name=programarIntervalo]").data('showSliderLabelAlert');
        if (showSliderLabelAlert) {
          if (App.Util.inArray(valor.toString(), App.Util.stringParseJsonObject(showSliderLabelAlert))) {
            $("input[name=programarIntervalo]").parent('.espaco-slider').find('.slider-label-alert').show();
          } else {
            $("input[name=programarIntervalo]").parent('.espaco-slider').find('.slider-label-alert').hide();
          }
        }
        $('input[name=programarIntervalo]').val(valor);
      });

      if (App.SniperExtensao.ehLance) {
        App.SniperExtensao.elCampoNoUiSliderTempoLance = new CampoNoUiSlider().inicializarCampo('sliderTempoEpiracaoLance', $("input[name=tempoExpiracaoLance]"),
          { 'min': 6, '33%': 15, '66%': 30, 'max': 60 });

        App.SniperExtensao.elCampoNoUiSliderTempoLance.noUiSlider.on('set', (values: any, handle: any) => {
          $('input[name=tempoExpiracaoLance]').val(parseInt(values[handle]));
          this.aoProgramarSniper(parseInt(values[handle]));
        });
      }


      // if (this.uso3HorasHabilitado()) {
      //   App.SniperExtensao.elCampoNoUiSliderProgramarCompra = new CampoNoUiSlider().inicializarCampo('sliderTempoProgamado', $("input[name=programarCompra]"),
      //     { 'min': 10, '20%': 30, '40%': 60, '60%': 90, '80%': 120, 'max': 180 });
      // } else {
      //   App.SniperExtensao.elCampoNoUiSliderProgramarCompra = new CampoNoUiSlider().inicializarCampo('sliderTempoProgamado', $("input[name=programarCompra]"),
      //     { 'min': 10, '20%': 30, '40%': 60, '60%': 90, 'max': 120 });
      // }

      // App.SniperExtensao.elCampoNoUiSliderProgramarCompra.noUiSlider.on('set', (values: any, handle: any) => {
      //   $('input[name=programarCompra]').val(parseInt(values[handle]));
      //   this.aoProgramarSniper(parseInt(values[handle]));
      // });

      if (App.SniperExtensao.ehModoCompraDme) {
        App.SniperExtensao.elCampoNoUiSliderPorcentagemMaisBarato = new CampoNoUiSlider().inicializarCampo('sliderPorcentagemMaisBarato', $("input[name=porcentagem_mais_barato]"),
          { 'min': 0, '10%': 5, '20%': 10, '30%': 15, '40%': 20, '50%': 25, '60%': 30, '70%': 35, '80%': 40, '90%': 45, 'max': 50 });
        App.SniperExtensao.elCampoNoUiSliderPorcentagemMaisBarato.noUiSlider.on('set', (values: any, handle: any) => {
          $('#slideporcentagemMaisBaratoLabel').html(parseInt(values[handle]).toString())
          $("input[name=porcentagem_mais_barato]").val(parseInt(values[handle]));
          if (!App.Util.empty($("#formObterElencoDme").find("input[name=url_elenco_futbin]").val())) {
            this.addInfoPrecoSelectJogadores(App.Util.elencoDme.elenco);
          }
        });
      }

      if (App.Util.existeElementoNaPagina($("#inputSlideporcentagemVendaMaisBarato"))) {
        App.SniperExtensao.elCampoNoUiSliderPorcentagemVendaMaisBarato = new CampoNoUiSlider().inicializarCampo('sliderPorcentagemVendaMaisBarato', $("input[name=porcentagem_venda_mais_barato]"),
          { 'min': 0, '20%': 2, '40%': 5, '60%': 10, '80%': 15, 'max': 20 });
        App.SniperExtensao.elCampoNoUiSliderPorcentagemVendaMaisBarato.noUiSlider.on('set', function (values: any, handle: any) {
          $('#slideporcentagemVendaMaisBaratoLabel').html(parseInt(values[handle]).toString())
          $("input[name=porcentagem_venda_mais_barato]").val(parseInt(values[handle]));
        });
      }

      if (App.Util.existeElementoNaPagina($("#porcentagemVendaMaisBaratoLista" + this.idListagemLance.toString()))) {
        App.SniperExtensao.elCampoNoUiSliderPorcentagemVendaMaisBaratoListaLance = new CampoNoUiSlider().inicializarCampo("slidePorcentagemVendaMaisBaratoLista" + this.idListagemLance.toString(), $("input[name=porcentagem_venda_mais_barato_lista]"),
          { 'min': 0, '20%': 2, '40%': 5, '60%': 10, '80%': 15, 'max': 20 });
        App.SniperExtensao.elCampoNoUiSliderPorcentagemVendaMaisBaratoListaLance.noUiSlider.on('change', function (values: any, handle: any) {
          $("input[name=porcentagem_venda_mais_barato_lista]").val(parseInt(values[handle]));
          App.SniperExtensao.elCampoNoUiSliderPorcentagemVendaMaisBaratoListaTransferencia.noUiSlider.set(parseInt(values[handle]));
          App.SniperExtensao.elCampoNoUiSliderPorcentagemVendaMaisBaratoListaClube.noUiSlider.set(parseInt(values[handle]));
        });
      }

      if (App.Util.existeElementoNaPagina($("#porcentagemVendaMaisBaratoLista" + this.idListagemTransferencia.toString()))) {
        App.SniperExtensao.elCampoNoUiSliderPorcentagemVendaMaisBaratoListaTransferencia = new CampoNoUiSlider().inicializarCampo("slidePorcentagemVendaMaisBaratoLista" + this.idListagemTransferencia.toString(), $("input[name=porcentagem_venda_mais_barato_lista]"),
          { 'min': 0, '20%': 2, '40%': 5, '60%': 10, '80%': 15, 'max': 20 });
        App.SniperExtensao.elCampoNoUiSliderPorcentagemVendaMaisBaratoListaTransferencia.noUiSlider.on('change', function (values: any, handle: any) {
          $("input[name=porcentagem_venda_mais_barato_lista]").val(parseInt(values[handle]));
          App.SniperExtensao.elCampoNoUiSliderPorcentagemVendaMaisBaratoListaLance.noUiSlider.set(parseInt(values[handle]));
          App.SniperExtensao.elCampoNoUiSliderPorcentagemVendaMaisBaratoListaClube.noUiSlider.set(parseInt(values[handle]));
        });
      }

      if (App.Util.existeElementoNaPagina($("#porcentagemVendaMaisBaratoLista" + this.idListagemClube.toString()))) {
        App.SniperExtensao.elCampoNoUiSliderPorcentagemVendaMaisBaratoListaClube = new CampoNoUiSlider().inicializarCampo("slidePorcentagemVendaMaisBaratoLista" + this.idListagemClube.toString(), $("input[name=porcentagem_venda_mais_barato_lista]"),
          { 'min': 0, '20%': 2, '40%': 5, '60%': 10, '80%': 15, 'max': 20 });
        App.SniperExtensao.elCampoNoUiSliderPorcentagemVendaMaisBaratoListaClube.noUiSlider.on('change', function (values: any, handle: any) {
          $("input[name=porcentagem_venda_mais_barato_lista]").val(parseInt(values[handle]));
          App.SniperExtensao.elCampoNoUiSliderPorcentagemVendaMaisBaratoListaLance.noUiSlider.set(parseInt(values[handle]));
          App.SniperExtensao.elCampoNoUiSliderPorcentagemVendaMaisBaratoListaTransferencia.noUiSlider.set(parseInt(values[handle]));
        });
      }

      if (App.Util.existeElementoNaPagina($("#inputSlidePrecoInteligente"))) {
        App.SniperExtensao.elCampoNoUiSliderPrecoInteligente = new CampoNoUiSlider().inicializarCampo('sliderPrecoInteligente', $("input[name=preco_inteligente]"),
          { 'min': 5, '50%': 10, 'max': 20 });
        App.SniperExtensao.elCampoNoUiSliderPrecoInteligente.noUiSlider.on('set', function (values: any, handle: any) {
          $('#slidePrecoInteligenteLabel').html(parseInt(values[handle]).toString())
          $("input[name=preco_inteligente]").val(parseInt(values[handle]));
        });
      }
      //Habilitar quando tiver preço inteligente na lista
      //            if (App.Util.existeElementoNaPagina($("#inputSlidePrecoInteligenteLista"))) {
      //                App.SniperExtensao.elCampoNoUiSliderPrecoInteligenteLista = new CampoNoUiSlider().inicializarCampo('sliderPrecoInteligenteLista', $("input[name=preco_inteligente_lista]"),
      //                    { 'min': 5, '50%': 10, 'max': 20 });
      //                App.SniperExtensao.elCampoNoUiSliderPrecoInteligenteLista.noUiSlider.on('set', function(values: any, handle: any) {
      //                    $("input[name=preco_inteligente_lista]").val(parseInt(values[handle]));
      //                });
      //            }
    }

    private inicializarAnaliseDeClube() {
      if (App.SniperExtensao.ehAnaliseClube) {
        var analiseClube = new App.AnaliseClube();
        analiseClube.inicializarEventos(this.idExtensao);
      }
    }

    private inicializarModoCompraElencoDme(inicializacao: boolean = true) {
      App.SniperExtensao.keyStorageUltimaAtualizacaoJogadoresClube = App.SniperExtensao.keyStorageUltimaAtualizacaoJogadoresClube + App.SniperExtensao.dadosContaEa.id;
      var ultimaInformacaojogadores = localStorage.getItem(App.SniperExtensao.keyStorageUltimaAtualizacaoJogadoresClube);
      if (ultimaInformacaojogadores) {
        var datahora = new Date(ultimaInformacaojogadores);
        $(".espaco-ultima-informacao-jogadores").show();
        $(".espaco-ultima-informacao-jogadores .datahora-info-jogadores").html(datahora.toLocaleDateString() + " " + datahora.toLocaleTimeString());
        // $("#botaoProcessarUrlDmeFutbin").attr('type', 'submit').removeAttr('href').removeAttr('data-toggle').removeAttr('data-target');
      } else {
        $(".espaco-ultima-informacao-jogadores").hide();
        // $("#botaoProcessarUrlDmeFutbin").attr('type', 'button').attr('href', '#informarJogadoresElenco').attr('data-toggle', 'modal').attr('data-target', '#informarJogadoresElenco');
        $(".espaco-ultima-informacao-jogadores .datahora-info-jogadores").html();
        if (inicializacao && App.Util.elencoDme) {
          this.escanearItensDoClube();
        }
      }

      if (App.Util.elencoDme) {
        if (App.Util.elencoDme.idSbc) {
          let { idSbc, nomeSbc, imgSbc, url } = App.Util.elencoDme;
          this.addItemHistoricoDmesImportados({ idSbc, nomeSbc, imgSbc, url })
        }
        if (App.Util.elencoDme.toltalPrice) {
          $('#gastoPrevisto').show();
          $('#gastoPrevisto').find('.valor-elenco').html(App.Util.elencoDme.toltalPrice.toString());
        } else {
          $('#gastoPrevisto').hide();
          $('#gastoPrevisto').find('.valor-elenco').html('');
        }
        this.adicionarInfoElencoDeDme(App.Util.elencoDme);
        App.SniperExtensao.exibirLoadingSniperApp('<i class="fas fa-file-download" style="color: #cecce4;"></i>', false, "Importando Jogadores...");
        this.adicionarElencoDeDme(App.Util.elencoDme.elenco);
        $('#jogador').on('select2:unselecting', (e) => {
          this.addInfoPrecoSelectJogadores(App.Util.elencoDme.elenco);
          this.objFiltro = this.getObjetoFiltros(e);
        });

        $("#formCompra input[name=quantidadesMaxCompras]").val(11).trigger('change')
        $("#formCompra input[name=quantidadesMaxCompras]").prop('disabled', true)
        App.SniperExtensao.elCampoNoUiSliderTentativas.noUiSlider.set(10);
        App.SniperExtensao.elCampoNoUiSliderIntervaloDescanso.noUiSlider.set(0);

        App.SniperExtensao.objSelect2.setSelectTag(App.SniperExtensao.selectVelocidade, { id: '2000', text: `2000 ${App.SniperExtensao.selectVelocidade.data('sufixDesc')}` })
        // App.SniperExtensao.elCampoNoUiSliderVelocidade.noUiSlider.set(2000);

        App.SniperExtensao.objSelect2.setSelectTag(App.SniperExtensao.selectProgramarCompra, { id: '60', text: `60 ${App.SniperExtensao.selectProgramarCompra.data('sufixDesc')}` })
        // App.SniperExtensao.elCampoNoUiSliderProgramarCompra.noUiSlider.set(60);

        $('#conteudoOfertaCompra').hide();
        $('#conteudoSalvarFiltro').hide();
        $('#conteudoGeralVendaAutomatica').hide();

        $('#conteudoDescansoEntreTentativas').hide();
        $('#espacoConteudoComposFiltros').hide();
        App.SniperExtensao.elBtSnipar.html('Snipar Elenco');
      } else {
        toastr.success("Não foi possível encontrar um elenco, tente com outra url.", "elenco não encontrado!");
      }
      this.carregarListaHistoricoImportacaoDme();
      this.delay(5000).then(() => { App.Util.ocultarModalPaginaCarregando(); });
    }


    private inicializarArrayListaClube() {
      try {
        if (!App.Util.empty(App.Util.getArrayStorage(App.SniperExtensao.keyStorageListagemClube))) {
          App.SniperExtensao.arrayListaClube = this.atualizarArrayListagemComCacheFutbin(App.Util.getArrayStorage(App.SniperExtensao.keyStorageListagemClube));
        }
        $('.info-quantidade-lista-clube').html(App.SniperExtensao.arrayListaClube.length.toString());

        let elementoListagemContexto: IContextoListagem = this.getObjListagemContexto(null, this.idListagemClube);
        this.atualizarDadosDataTable(elementoListagemContexto, this.inicializarLista);
        App.SniperExtensao.desabilitarBotaoItensSelecionadosListagem(elementoListagemContexto);
      } catch (e) {
      }
    }

    public static ehVersaoDesatualizadaExtensao() {
      var versaoExtensaoInstalada = parseInt($('#versaoExtensao').val().replaceAll('.', ''))
      var versaoExtensaoAtual = parseInt((App.Util.config.versaoAtualExtensaoChromeFse as any).replaceAll('.', ''))
      return versaoExtensaoAtual > versaoExtensaoInstalada;
    }

    private static iniciarCronometro(tempo: number) {
      App.SniperExtensao.cronometro.start({ countdown: true, startValues: { seconds: tempo } });
      $('.cronometro .values').html(App.SniperExtensao.cronometro.getTimeValues().toString());
      App.SniperExtensao.cronometro.addEventListener('secondsUpdated', function (e: JQueryEventObject) {
        $('.cronometro .values').html(App.SniperExtensao.cronometro.getTimeValues().toString());
      });
      App.SniperExtensao.cronometro.addEventListener('started', function (e: JQueryEventObject) {
        $('.cronometro').show();
      });
      App.SniperExtensao.cronometro.addEventListener('stopped', function (e: JQueryEventObject) {
        $('.cronometro .values').html('00:00:00');
      });
      App.SniperExtensao.cronometro.addEventListener('targetAchieved', function (e: JQueryEventObject) {
        $('.cronometro .values').html('00:00:00');
      });
    }

    private ajustarCabecalho() {
      $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll > 50) {
          $('#navbar-main').hide();
        } else {
          $('#navbar-main').show();
        }
      });
    }
    private exibirMensagemAlertaSwal(title: string, mensagem: string, tipo: string = "error", confirmButtonText: string = "OK", cancelButtonText: string = "Fechar", confirmButtonColor: string = "#FB6340", showCancelButton: boolean = true, urlRedirectClickConfirm: string = null, footer: string = null, contaEaJaVinculada: any = null, imageUrl: string = null) {
      var objSwal: any = {
        title: title,
        html: mensagem,
        type: tipo,
        confirmButtonText: confirmButtonText,
        confirmButtonColor: confirmButtonColor,
        showCancelButton: showCancelButton,
        cancelButtonText: cancelButtonText
      }

      if (imageUrl) {
        objSwal.icon = null;
        objSwal.imageUrl = imageUrl;
      }

      if (footer) {
        objSwal.footer = footer;
      }

      swal(objSwal).then((result: any) => {
        if (result.hasOwnProperty('value') && result.value && urlRedirectClickConfirm) {
          window.location.href = urlRedirectClickConfirm;
          return;
        }
        if (result.hasOwnProperty('value') && result.value && contaEaJaVinculada) {
          this.revincularContaEa(contaEaJaVinculada);
          return;
        }
      });
    }

    public static exibirMensagemSnipeTravado(mensagem: string = "Sistema travado por segurança, você precisa fazer uma nova autenticação ou o seu mercado pode estar bloqueado temporariamente ou então pode ser um pedido de captcha, verifique no seu WEB APP.") {
      swal({
        title: "Atenção!",
        text: mensagem,
        type: "error",
        showCancelButton: true,
        confirmButtonText: "Autenticar",
        confirmButtonColor: '#FB6340',
        cancelButtonText: "Fechar"
      }).then(function (result: any) {
        if (result.hasOwnProperty('value') && result.value) {
          window.location.href = App.SniperExtensao.urlAppFut;
          return;
        }
      });
    }
    private exibirMensagemExtensaoDesatualizada() {
      swal({
        title: "Extensão desatualizada!",
        text: "Existe uma versão mais nova da extensão FutSniperExtension, é importante que você remova e instale novamente a versão " + App.Util.config.versaoAtualExtensaoChromeFse,
        type: "info",
        showCancelButton: false,
        confirmButtonText: "Atualizar",
        confirmButtonColor: '#3740FF'
      }).then(function (result: any) {
        if (result.hasOwnProperty('value') && result.value) {
          window.open(
            App.Util.config.urlExtensaoChromeFse,
            '_blank'
          );
          return;
        }
      });
    }
    private exibirMensagemManutensao() {
      swal({
        title: "Desculpa, Estamos em manutenção!",
        text: "Por favor aguarde um pouco até que as nossas atualizações sejam concluídas para você voltar a snipar com segurança",
        type: "info",
        showCancelButton: false,
        confirmButtonText: "Ok",
        confirmButtonColor: '#3740FF'
      }).then(function (result: any) {

      });
    }
    private exibirMensagemItensInegociaveisOcupandoLista() {
      swal({
        title: "Lista de não atribuídos cheia!",
        text: "Você precisa liberar itens inegociáveis que estão tomando conta do espaço em sua lista de itens não atribuídos e sincronizar novamente o WebApp com o FutSniperExtension",
        type: "warning",
        showCancelButton: false,
        confirmButtonText: "Ok",
        confirmButtonColor: '#f89500'
      }).then(function (result: any) {

      });
    }
    private exibirMensagemVersaoNavegadorIncompativel(versao: number) {
      swal({
        title: "Versão incompatível do navegador!",
        text: "A ferramenta não está funcionando corretamente com a versão " + versao + " do chrome que você está usando, por favor remova essa versão e instale uma versão anterior do chrome, de preferência a versão 75, estamos trabalhando para fazer funcionar na versao " + versao,
        type: "error",
        showCancelButton: false,
        confirmButtonText: "Ver outras versões do chrome",
        confirmButtonColor: '#3740FF'
      }).then(function (result: any) {
        if (result.hasOwnProperty('value') && result.value) {
          window.location.href = "https://www.slimjet.com/chrome/google-chrome-old-version.php";
          return;
        }

      });
    }
    private exibirMensagemSemCapacidadeNasListasDeTranferencia() {
      swal({
        title: "Atenção!",
        text: "Não há espaço em sua lista de itens não atribuidos e nem na lista de transferência, libere espaço nas suas listas e atualize as páginas do WEB APP e FUTSNIPERWEB novamente",
        type: "error",
        showCancelButton: true,
        confirmButtonText: "Ok, vou liberar espaço",
        confirmButtonColor: '#FB6340',
        cancelButtonText: "Fechar"
      });
    }
    private variarFiltro(minimo: number) {
      minimo += 50;
      var valorMaximo = App.Util.obterInteiroDaString(this.elCampoValorMaximo.val());
      var valorAserSubtraido = 50;

      if (valorMaximo == 200) {
        valorAserSubtraido = 0;
      }

      if (minimo > (valorMaximo - valorAserSubtraido) || minimo > 400) {
        minimo = 150;
      }
      return minimo;
    }

    private variarFiltroAvancado(minimo: number, valorOferta: number = null) {
      minimo = App.Util.incrementarValorDeFiltro(minimo);
      var valorMaximo = App.Util.obterInteiroDaString(valorOferta ? valorOferta.toString() : this.elCampoValorMaximo.val());
      var valorMinimoParaFiltro = this.getValorMinimoFiltro();
      var valorAserSubtraido = App.Util.obterIncrementoValorFiltro(minimo);

      if (valorMaximo == 200) {
        valorAserSubtraido = 0;
      }

      if (minimo > (valorMaximo - valorAserSubtraido) || (valorMinimoParaFiltro && minimo >= valorMinimoParaFiltro) || minimo >= App.Util.obterLimiteVariacaoFiltroPorValorCompra(valorMaximo)) {
        minimo = 150;
      }
      return minimo;
    }

    private inicializarConfiguracoes() {
      App.SniperExtensao.tempoProgramado = App.SniperExtensao.getTempoProgramadoSniper();
      App.SniperExtensao.tempoIntervaloEntreTentativas = App.SniperExtensao.getTempoIntervaloEntreTentativas();
      App.SniperExtensao.quantidadeMaximaCompras = App.SniperExtensao.getQuantidadeMaxCompras();
      App.SniperExtensao.quantidadeMaximaTentativasPorVez = App.SniperExtensao.getQuantidadeMaxTentativasPorVez();
      App.SniperExtensao.configuracoesAtuais = $('#conteudoConfiguracoes input[type=hidden]').serializeArray();
    }

    private getQuantidadeCompras(): number {
      return App.Util.obterInteiroDaString($('.quantidade-compras').html());
    }
    private getQuantidadeTentativas(): number {
      return this.tentativaAtual;
    }
    private static getQuantidadeMaxTentativasPorVez(): number {
      if (App.SniperExtensao.ehLance) {
        return 30;
      }
      let resultado = parseInt($("input[name='quantidadesMaxTentativas']").val());
      if (App.Util.empty(resultado)) {
        return 0;
      }
      return resultado;
    }
    public static getTempoIntervaloEntreTentativas(): number {
      let resultado = parseInt($("input[name='programarIntervalo']").val());
      if (App.Util.empty(resultado)) {
        return 0;
      }
      return resultado;
    }
    public static getTempoProgramadoSniper(): number {
      let resultado = parseInt($("select[name='programarCompra']").val());
      if (App.Util.empty(resultado)) {
        return 0;
      }
      return resultado;
    }
    public static getTempoExpiracaoLance(): number {
      let resultado = parseInt($("input[name='tempoExpiracaoLance']").val());
      if (App.Util.empty(resultado)) {
        return 0;
      }
      return resultado;
    }
    private static getQuantidadeMaxCompras(): number {
      let resultado = parseInt($("input[name='quantidadesMaxCompras']").val());
      if (App.Util.empty(resultado)) {
        return 1;
      }
      return resultado;
    }
    private static getValorMaximoOfertaDme(): number {
      let resultado = parseInt(App.Util.obterSomenteNumerosDaString($("input[name=max_oferta_dme]").val()));
      return App.Util.empty(resultado) ? null : resultado;
    }
    private getMilesegundos(): number {
      if (App.SniperExtensao.ehLance) {
        return 4000;
      }
      let resultado = parseInt($("select[name='milesegundos']").val());
      if (App.Util.empty(resultado)) {
        return 4000;
      }
      return resultado;
    }
    private getValorMinimoFiltro(): number {
      let resultado = App.Util.empty(this.elCampoMinFiltro.val()) ? null : parseInt(this.elCampoMinFiltro.val());
      if (App.Util.empty(resultado)) {
        return null;
      }
      return resultado;
    }

    public static runAudio(idAudio: number = 1) {
      if (!$("#formCompra").data('audio') || App.Util.usuario.configuracao.modo_silencioso) {
        return;
      }

      switch (idAudio) {
        case 1:
          App.Util.playAudioCompra();
          break;
        case 2:
          App.Util.playAudioParouCompra();
          break;
        case 3:
          App.Util.playAudioCaptcha();
          break;
        case 4:
          App.Util.playAudioGanhouLance();
          break;
        case 5:
          App.Util.playAudioOutroMotivos();
          break;
        case 6:
          App.Util.playAudioEncontrado();
          break;
      }

    }

    public static habilitarPossibilidadeDeSnipar() {
      $(".loading").hide();
      App.SniperExtensao.elBtSnipar.prop('disabled', false);
      App.SniperExtensao.ocultarLoadingSniperApp();
    }

    private incrementarTentativa(somenteVisual = false, lance = false) {
      if (somenteVisual) {
        if (lance) {
          this.atualizarIconeLoadingTentativasSniper("fas fa-hand-holding-usd");
        } else {
          var tentativa = App.Util.obterInteiroDaString($('.tentativas').html());
          $('.tentativas').html((($.isNumeric(tentativa) ? tentativa : 0) + 1).toString());
        }
      } else {
        this.tentativaAtual += 1;
        $('.tentativas').html(($.isNumeric(this.tentativaAtual) ? this.tentativaAtual : 0).toString());
      }

      if (!App.SniperExtensao.cronometroVisivel() && App.SniperExtensao.sniperAtivo) {
        $(".info-text-loading").hide()
        $('.cronometro').show()
        $('.info-text-loading').html('')
      }

      this.salvarTempoExecucao()
      this.salvarEstatisticasDaConta()
    }

    private addQuantidadeCompras(itemComprado: any) {
      App.SniperExtensao.runAudio();
      let modoCompraDme = this.autoDme && this.autoDme.resolvendo && !App.SniperExtensao.sniperAtivo;
      if (!modoCompraDme) {
        toastr.success("Snipado por: " + itemComprado.buyNowPrice, "Parabéns!");
        if (App.SniperExtensao.ehConsumiveis) {
          $("#espacoLogs").prepend(App.SniperExtensao.getConteudoLogSnipou(itemComprado));
        } else {
          App.SniperExtensao.salvarLogSnipouJogador($("#espacoLogs"), itemComprado);
        }
      }
      if (App.Util.existeElementoNaPagina($('.quantidade-compras'))) {
        $('.quantidade-compras').html((App.Util.obterInteiroDaString($('.quantidade-compras').html()) + 1).toString());
        $('.progress-compras').css('width', ((App.Util.obterInteiroDaString($('.quantidade-compras').html()) / App.SniperExtensao.quantidadeMaximaCompras) * 100).toString() + '%');
      }
      this.incrementarQuantidadeCompraDiaria();
    }

    private addQuantidadeComprasLance(quantidadeNovosLancesGanhos: any) {
      console.log("ADD LANCES GANHOS::", quantidadeNovosLancesGanhos)
      App.SniperExtensao.runAudio(4);
      if (App.Util.existeElementoNaPagina($('.quantidade-compras'))) {
        $('.quantidade-compras').html((App.Util.obterInteiroDaString($('.quantidade-compras').html()) + quantidadeNovosLancesGanhos).toString());
        $('.progress-compras').css('width', ((App.Util.obterInteiroDaString($('.quantidade-compras').html()) / App.SniperExtensao.quantidadeMaximaCompras) * 100).toString() + '%');
      }
      this.quantidadeLancesganhosAtuais += quantidadeNovosLancesGanhos;
      this.incrementarQuantidadeCompraDiaria();
    }
    private processarDisponibilidadesDeListas(quantidadeListaTransferencia: number, quantidadeListaObservacao: number) {
      App.SniperExtensao.quantidadeDisponivelListaDeObservacao = App.SniperExtensao.capacidadeListaDeObservacao - quantidadeListaObservacao;
      App.SniperExtensao.quantidadeDisponivelListaDeTransferencia = App.SniperExtensao.capacidadeListaDeTransferencia - quantidadeListaTransferencia;
      //            this.decrementarQuantidadeDisponivelListaDeObservacao();
      //            var quantidadeMinimaParaLiberarEspacoNaListaDeObservacao = (App.SniperExtensao.vendaAutomaticaAtiva && App.SniperExtensao.arrayItensVendaAutomatica.length > 0) ? 3 : 0;
      //            if (App.SniperExtensao.quantidadeDisponivelListaDeObservacao <= quantidadeMinimaParaLiberarEspacoNaListaDeObservacao) {
      //                toastr.info("Liberando espaço na lista de itens não atribuídos");
      ////                this.liberarListaDeObservacao();
      //            }
    }

    public pararTudo(naoLiberarListaobservacao: boolean = false) {
      //Salvar as snipadas acumuladas
      this.enviarComandoDeParadaImediata();

      if (this.loopTimeoutMontarDme) {
        clearTimeout(this.loopTimeoutMontarDme)
        App.SniperExtensao.ocultarLoadingSniperApp();
      }

      if (this.snipadas.length > 0) {
        this.ajax.postAcaoSemResposta(App.Util.config.urlSalvarSniper, { array_snipadas: this.snipadas });
        this.snipadas = [];
        try {
          this.atualizarBanometro();
        } catch (e) {
        }
      }

      this.atualizarEstatisticas();
      this.salvarEstatisticasDaConta(true)
      this.ultimaAtualizacaoTempoExecucao = null
      App.SniperExtensao.sniperAtivo = false;
      this.modo_listagem_status = 0;
      this.tentativaAtual = 0;
      if (App.SniperExtensao.sniperProgramado) {
        App.SniperExtensao.finalizarSniperProgramado(false);
        return;
      }

      App.SniperExtensao.finalizarLoopsAutomaticos();

      try {
        if (App.SniperExtensao.ehLoadListaVisivel()) {
          App.Util.ocultarLoadingProcessamento($(".loading-processamento-sniper"));
        }
      } catch (e) {
        console.log("erro ocultar load list")
      }
    }

    public static finalizarLoopsAutomaticos() {
      clearInterval(App.SniperExtensao.loopIntervaloSniparEmTeste);
      clearTimeout(App.SniperExtensao.loopIntervaloProgramado);
      clearTimeout(App.SniperExtensao.tempoParaFinalizarLoopProgramado);
      clearTimeout(App.SniperExtensao.tempoParaEstabelecerComunicacao);
      clearInterval(App.SniperExtensao.loopTentativas);
      App.SniperExtensao.finalizarTentativasSniper();
      App.SniperExtensao.finalizarLoopIntervalo();
      App.SniperExtensao.finalizarLoopTimeouts();
      App.SniperExtensao.habilitarPossibilidadeDeSnipar();
      App.SniperExtensao.exibirLogSniperParado();
    };

    public static finalizarSniperProgramado(exibirLogTempo: boolean = true) {
      clearInterval(App.SniperExtensao.loopIntervaloSniparEmTeste);
      clearTimeout(App.SniperExtensao.loopIntervaloProgramado);
      clearTimeout(App.SniperExtensao.tempoParaFinalizarLoopProgramado);
      clearTimeout(App.SniperExtensao.tempoParaEstabelecerComunicacao);
      App.SniperExtensao.sniperAtivo = false;
      App.SniperExtensao.sniperProgramado = false;
      if (exibirLogTempo) {
        $("#espacoLogs").prepend(App.SniperExtensao.getConteudoLogLimiteTempoProgramado());
      }
      App.SniperExtensao.cronometro.stop();
      App.SniperExtensao.finalizarLoopsAutomaticos();
    }
    private static finalizarTentativasSniper() {
      $.each(App.SniperExtensao.arrayLoopTentativas, function (index, value) {
        window.clearInterval(value);
      });
      App.SniperExtensao.arrayLoopTentativas = [];
    }

    public static finalizarLoopIntervalo() {
      $.each(App.SniperExtensao.arrayLoopIntervalos, function (index, value) {
        window.clearInterval(value);
      });
      App.SniperExtensao.arrayLoopIntervalos = [];
    }
    private static finalizarLoopTimeouts() {
      $.each(App.SniperExtensao.arrayLoopTimeouts, function (index, value) {
        window.clearTimeout(value);
      });
      App.SniperExtensao.arrayLoopTimeouts = [];
    }

    private pararProcessoDeListagem() {
      this.modo_listagem_status = 0;
      App.SniperExtensao.elBtSnipar.prop('disabled', false);
      App.SniperExtensao.ocultarLoadingSniperApp();
      App.Util.ocultarLoadingProcessamento($(".loading-processamento-sniper"));
    }

    private aoPararCompra(e: JQueryEventObject) {
      if (this.ehSniperPorLucro) {
        this.ocultarPrecoCompraEncontradoBotaoSniperLucro()
      }
      clearTimeout(App.SniperExtensao.tempoParaEstabelecerComunicacao);
      App.SniperExtensao.comunicacaoEstabelecidaComWebApp = true;
      this.pararCompra();
      if (this.modo_listagem_status > 0) {
        this.pararProcessoDeListagem();
        setTimeout(() => {
          this.exibirLog("danger", "Processo Interrompido", "Processo de listagem em andamento foi Interrompido");
        }, 4000);
      }
      this.enviarComandoDeParadaImediata();
    }

    private pararCompra(acionadoPeloUsuario: boolean = true) {
      if (App.SniperExtensao.sniperAtivo) {
        App.SniperExtensao.elSpinnerCancelar.show();
        App.SniperExtensao.acionadoPeloUsuario = acionadoPeloUsuario;
        this.pararTudo();
        App.SniperExtensao.habilitarPossibilidadeDeSnipar();

        App.SniperExtensao.elSpinnerCancelar.hide();
      }
    }

    private aoLimparLog(e: JQueryEventObject) {
      $("#espacoLogs").html('');
    }

    private aoEscanearItensClube(e: JQueryEventObject) {
      if ($(e.currentTarget).data('idModalParent')) {
        $("#" + $(e.currentTarget).data('idModalParent')).modal('hide');
      }

      this.escanearItensDoClube();
    }

    private aoAtualizarListagens(e: JQueryEventObject) {
      this.atualizarListagens();
    }

    private desabilitarCampoOfertaMaxima(resetar: boolean = true) {
      if (resetar) {
        $('#formCompra .campo-oferta-preco-max input[name=max]').val(200)
      }
      $('#formCompra .campo-oferta-preco-max .input-group').css('opacity', '0.4');
      $('#formCompra .campo-oferta-preco-max input').css('cursor', 'not-allowed');
      $('#formCompra .campo-oferta-preco-max input').css('display', 'none');
      $('#formCompra .campo-oferta-preco-max input[name=max]').prop('disabled', true)
      $('#formCompra .campo-oferta-preco-max .increment').prop('disabled', true)
      $('#formCompra .campo-oferta-preco-max .decrement').prop('disabled', true)
    }

    private habilitarCampoOfertaMaxima(resetar: boolean = false) {
      if (resetar) {
        $('#formCompra .campo-oferta-preco-max input[name=max]').val(200)
      }
      $('#formCompra .campo-oferta-preco-max .input-group').css('opacity', 'inherit');
      $('#formCompra .campo-oferta-preco-max input').css('cursor', 'inherit');
      $('#formCompra .campo-oferta-preco-max input').css('display', 'block');
      $('#formCompra .campo-oferta-preco-max input[name=max]').prop('disabled', false)
      $('#formCompra .campo-oferta-preco-max .increment').prop('disabled', false)
      $('#formCompra .campo-oferta-preco-max .decrement').prop('disabled', false)
    }

    private jogadorComPrecoIncompativel(): { status: boolean, player: any, precoJogador: number } {
      let jogadoresSelecionado = this.elCampoJogador.val() || []
      if (jogadoresSelecionado.length > 0) {
        try {
          for (let jogadorId of jogadoresSelecionado) {
            let precoJogador = this.getValorOfertaPersonalizadoDoJogador(jogadorId, 200);
            var player = App.Util.getItemArrayById(App.SniperExtensao.players, jogadorId);
            if (player.r >= 75 && precoJogador < 350) {
              return { status: true, player: player, precoJogador: precoJogador };
            }
          }
        } catch (e) {
        }
      }

      return { status: false, player: null, precoJogador: null };
    }

    private aoInformarJogador(e: JQueryEventObject) {
      var jogadores = $(e.target).val() || [];
      if (this.ehSniperPorPrecoCompra && App.Util.editarPrecoJogadoresSelecionados && jogadores.length > 0) {
        $(".campo-oferta-preco-max").show()
        $("#alertInformarPrecoNoJogador").show()
        this.desabilitarCampoOfertaMaxima()
        $("#botaoSnipar").find('.info-oferta').hide()
        $("#botaoSnipar").find('.bt-text-coins').hide()
        $("#botaoSnipar").find('.bt-text-jogador').show()
      } else if (this.ehSniperPorLucro) {
        $("#alertInformarPrecoNoJogador").hide()
        $(".campo-oferta-preco-max").hide()
        this.habilitarCampoOfertaMaxima()
        $('#botaoSnipar .bt-text-coins').hide();
        $('#botaoSnipar .info-oferta').hide();
        $("#botaoSnipar .bt-text-jogador").hide()
      } else {
        $("#alertInformarPrecoNoJogador").hide()
        $(".campo-oferta-preco-max").show()
        this.habilitarCampoOfertaMaxima()
        $("#botaoSnipar").find('.info-oferta').show()
        $("#botaoSnipar").find('.bt-text-coins').show()
        $("#botaoSnipar").find('.bt-text-jogador').hide()
      }

    }

    private aoAlterarCampoSelect(e: JQueryEventObject, elConferencia: JQuery) {
      var id = $(e.target).val();
      var texto: any = $(e.target).find(':selected').text();
      var img = elConferencia.find('img');
      var span = elConferencia.find('span');
      img.attr('src', "");
      span.html(" - ");
      if (App.Util.empty(id)) {
        return;
      }
      span.html(texto);
      img.attr('src', $(e.target).find(':selected').data('imgSrc'));
    }

    private aoSelecionarCampoRaridade(e: any) {
      let raridadesIds: number[] = $(e.target).val();
      if (raridadesIds.length) {
        $(e.target).addClass('raridade-selecionada')
      } else {
        $(e.target).removeClass('raridade-selecionada')
      }

      if (raridadesIds.length > 1 || raridadesIds.filter(value => App.Util.config.idsRaridadesComRisco.includes(value)).length) {
        $("#alertRaridadeRisco").show()
      } else {
        $("#alertRaridadeRisco").hide()
      }
    }

    private aoAlterarLiga(e: JQueryEventObject, elConferencia: JQuery) {
      var id = $(e.target).val();
      var texto: any = $(e.target).find(':selected').text();
      if (!App.Util.config.naoValidarPlano && App.Util.inArray(parseInt(id), App.Util.usuario.plano.configuracoes.ligasIndisponiveis)) {
        $('#liga').val('').trigger('change').trigger('select2:select');
        this.exibirMensagemAlertaSwal("Liga indisponível", "A Liga <b>" + texto + "</b> não está disponível no <b>" + this.elSniperPage.data('nomePlano') + "</b>, Essa liga está disponível para assinantes do <b>Plano Ouro</b>.", "warning", "Ver Planos", "Fechar", '#2dce89', true, this.elSniperPage.data('urlPlanos'));
        return;
      }
      var img = elConferencia.find('img');
      var span = elConferencia.find('span');
      img.attr('src', "");
      span.html(" - ");
      if (App.Util.empty(id)) {
        return;
      }
      span.html(texto);
      img.attr('src', $(e.target).find(':selected').data('imgSrc'));
    }
    private aoAlterarCategoria(e: JQueryEventObject) {
      var consumivel = $(e.target).val();
      var texto: any = $(e.target).find(':selected').text();
      var img = this.elConferenciaCategoria.find('img');
      var span = this.elConferenciaCategoria.find('span');
      img.attr('src', "");
      span.html(" - ");
      if (!App.Util.empty(consumivel)) {
        span.html(texto);
        img.attr('src', $(e.target).find(':selected').data('imgSrc'));
      }

      if (consumivel == "fitness") {
        this.typeFiltroConsumivelComissaoItensClube = "training";
        this.elCampoQualidade.val("").trigger('change');
        this.elCampoQualidade.prop('disabled', true);
        this.elCampoQualidade.attr('disabled', 'disabled');
        this.elCampoEstilo.val("").trigger('change');
        this.elCampoEstilo.prop('disabled', true)
        this.elCampoEstilo.attr('disabled', 'disabled');
        $('[aria-labelledby="select2-qualidade-container"]').attr("style", "");
        $('[aria-labelledby="select2-estilo-container"]').attr("style", "");
        $('[aria-labelledby="select2-trocaPosicao-container"]').attr("style", "");
        $('<input>').attr({
          type: 'hidden',
          id: 'tipo',
          name: 'tipo',
          value: 'development'
        }).prependTo('form');

        $('<input>').attr({
          type: 'hidden',
          id: 'definitionId',
          name: 'definitionId',
          value: '5002006'
        }).prependTo('form');
      } else if (consumivel == "position") {
        this.typeFiltroConsumivelComissaoItensClube = "training";
        this.elCampoQualidade.val("").trigger('change');
        $('[aria-labelledby="select2-qualidade-container"]').attr("style", "");
        $('[aria-labelledby="select2-estilo-container"]').attr("style", "");
        this.elCampoEstilo.val("").trigger('change');
        this.elCampoEstilo.prop('disabled', true)
        this.elCampoEstilo.attr('disabled', 'disabled');

        this.elCampoNacionalidade.val("").trigger('change');
        this.elCampoNacionalidade.prop('disabled', true)
        this.elCampoNacionalidade.attr('disabled', 'disabled');

        this.elCampoLiga.val("").trigger('change');
        this.elCampoLiga.prop('disabled', true)
        this.elCampoLiga.attr('disabled', 'disabled');

        $('#tipo').remove();
        $('#definitionId').remove();
      } else if (consumivel == "manager") {
        this.typeFiltroConsumivelComissaoItensClube = "staff";

        this.elCampoQualidade.prop('disabled', false);
        this.elCampoQualidade.removeAttr('disabled');
        this.elCampoQualidade.val("").trigger('change');
        $('[aria-labelledby="select2-qualidade-container"]').attr("style", "");
        $('[aria-labelledby="select2-estilo-container"]').attr("style", "");

        this.elCampoNacionalidade.prop('disabled', false);
        this.elCampoNacionalidade.removeAttr('disabled');
        this.elCampoLiga.prop('disabled', false);
        this.elCampoLiga.removeAttr('disabled');

        this.elCampoEstilo.val("").trigger('change');
        this.elCampoEstilo.prop('disabled', true)
        this.elCampoEstilo.attr('disabled', 'disabled');
        $('#tipo').remove();
        $('#definitionId').remove();
      } else {
        this.typeFiltroConsumivelComissaoItensClube = "training";
        this.elCampoQualidade.prop('disabled', false);
        this.elCampoQualidade.removeAttr('disabled');
        this.elCampoEstilo.prop('disabled', false)
        this.elCampoEstilo.removeAttr('disabled');

        this.elCampoNacionalidade.val("").trigger('change');
        this.elCampoNacionalidade.prop('disabled', true)
        this.elCampoNacionalidade.attr('disabled', 'disabled');

        this.elCampoLiga.val("").trigger('change');
        this.elCampoLiga.prop('disabled', true)
        this.elCampoLiga.attr('disabled', 'disabled');

        $('[aria-labelledby="select2-trocaPosicao-container"]').attr("style", "");
        $('#tipo').remove();
        $('#definitionId').remove();
      }
    }

    private aoPerderFocoCampoValor(e: JQueryEventObject) {
      var campoName = $(e.target).attr('name');
      var campoContextoValorMin = $(e.target).data('min');

      var valorInformado = App.Util.obterInteiroDaString($(e.target).val());
      valorInformado = valorInformado ? valorInformado : 0;
      switch (campoName) {
        case 'min':
          valorInformado = valorInformado > App.SniperExtensao.valorCoinMax ? App.SniperExtensao.valorCoinMax : valorInformado;
          var valorCampoMax = App.Util.obterInteiroDaString(this.elCampoValorMaximo.val());
          if (valorInformado >= valorCampoMax) {
            this.elCampoValorMaximo.val(valorInformado < App.SniperExtensao.valorCoinMax ? App.Util.incrementarValorDeFiltro(valorInformado) : App.SniperExtensao.valorCoinMax).trigger('input').trigger('change');
          }
          break;
        case 'valor_lance_minimo':
          valorInformado = valorInformado > App.SniperExtensao.valorCoinMax ? App.SniperExtensao.valorCoinMax : valorInformado;
          var valorCampoMax = App.Util.obterInteiroDaString(this.elCampoValorVenda.val());
          if (valorInformado >= valorCampoMax) {
            this.elCampoValorVenda.val(valorInformado < App.SniperExtensao.valorCoinMax ? App.Util.incrementarValorDeFiltro(valorInformado) : App.SniperExtensao.valorCoinMax).trigger('input').trigger('change');
          }
          valorInformado = valorInformado ? valorInformado : 0;
          break;
        case 'max':
          var valorCampoMin = App.Util.obterInteiroDaString(this.elCampoMinFiltro.val());
          if (valorInformado <= valorCampoMin) {
            var valorCalculado = App.Util.decrementarValorDeFiltro(valorInformado);
            var valorMinCampo = this.elCampoMinFiltro.data('min');
            this.elCampoMinFiltro.val(valorCalculado < valorMinCampo ? '' : valorCalculado).trigger('input');
          }
          valorInformado = valorInformado && valorInformado >= campoContextoValorMin ? (valorInformado > App.SniperExtensao.valorCoinMax ? App.SniperExtensao.valorCoinMax : valorInformado) : campoContextoValorMin;
          break;
        case 'valor_venda':
          var valorCampoMin = App.Util.obterInteiroDaString(this.elCampoValorLanceMinimoVenda.val());
          if (valorInformado <= valorCampoMin) {
            var valorCalculado = App.Util.decrementarValorDeFiltro(valorInformado);
            this.elCampoValorLanceMinimoVenda.val(valorCalculado <= 0 ? '' : valorCalculado).trigger('input');
          }
          valorInformado = valorInformado ? (valorInformado > App.SniperExtensao.valorCoinMax ? App.SniperExtensao.valorCoinMax : valorInformado) : 0;
          break;
        case 'valor_venda_lista':
          var valorCampoMin = App.Util.obterInteiroDaString(this.elCampoValorLanceMinimoVendaLista.val());
          if (valorInformado <= valorCampoMin) {
            var valorCalculado = App.Util.decrementarValorDeFiltro(valorInformado);
            this.elCampoValorLanceMinimoVendaLista.val(valorCalculado <= 0 ? '' : valorCalculado).trigger('input');
          }
          valorInformado = valorInformado ? (valorInformado > App.SniperExtensao.valorCoinMax ? App.SniperExtensao.valorCoinMax : valorInformado) : 0;
          break;
        case 'valor_lance_minimo_lista':
          valorInformado = valorInformado > App.SniperExtensao.valorCoinMax ? App.SniperExtensao.valorCoinMax : valorInformado;
          var valorCampoMax = App.Util.obterInteiroDaString(this.elCampoValorVendaLista.val());
          if (valorInformado >= valorCampoMax) {
            this.elCampoValorVendaLista.val(valorInformado < App.SniperExtensao.valorCoinMax ? App.Util.incrementarValorDeFiltro(valorInformado) : App.SniperExtensao.valorCoinMax).trigger('input').trigger('change');
          }
          valorInformado = valorInformado ? valorInformado : 0;
          break;
        case 'valor_oferta_jogador':
          var valorCampoMin = App.Util.obterInteiroDaString(this.elCampoMinFiltro.val());
          if (valorInformado <= valorCampoMin) {
            var valorCalculado = App.Util.decrementarValorDeFiltro(valorInformado);
            var valorMinCampo = this.elCampoMinFiltro.data('min');
            this.elCampoMinFiltro.val(valorCalculado < valorMinCampo ? '' : valorCalculado).trigger('input');
          }
          valorInformado = valorInformado && valorInformado >= campoContextoValorMin ? (valorInformado > App.SniperExtensao.valorCoinMax ? App.SniperExtensao.valorCoinMax : valorInformado) : campoContextoValorMin;
          break;
      }

      valorInformado = App.Util.tratarValorDeFiltro(valorInformado);
      $(e.target).val(valorInformado ? valorInformado.toString() : '').trigger('input').trigger('change');
    }

    private aoInformarValor(e: JQueryEventObject) {
      var valorInformado = App.Util.obterInteiroDaString($(e.target).val());

      if (valorInformado > 100000) {
        $(e.target).css({ 'background-color': '#ffffff' }).css({ 'color': '#bbc60c' });
        $(e.target).parents('.input-group').find('.input-group-text').css({ 'background-color': '#ffffff' });
        $("#alertValor").show();
      } else {
        $(e.target).css({ 'background-color': '#ffffff' }).css({ 'color': '#38a378' });
        $(e.target).parents('.input-group').find('.input-group-text').css({ 'background-color': '#ffffff' });
        $("#alertValor").hide();
      }

      this.elInfoOferta.html($(e.target).val());
    }

    private aoInformarValorVenda(e: JQueryEventObject) {
      $("#infoVendaAutomaticaLig").attr('data-original-title', 'Vendendo automaticamente por ' + $(e.target).val() + ' coins');
      $('.info-valor-venda-automatica').html($(e.target).val());
    }

    private aoSelecionarVendaAutomatica(e: JQueryEventObject) {
      App.SniperExtensao.vendaAutomaticaBloqueada = false;
      if ($(e.target).is(':checked')) {
        this.habilitarVendaAutomatica();
        this.aoAtivarVendaLucroEstimado(true);
        if (this.modoManterNoCemiterio()) {
          swal("Permitido somente quando ìtens são enviados para transferência!", "A venda automática atualmente só é permitida quando os itens são enviados para lista de transferência, desabilite a opção (Manter ítens na lista de não atribuídos) em configurações.", "warning");
          this.elAtivarVendaAutomatica.prop("checked", false).trigger('change');
        }
      } else {
        this.desabilitarVendaAutomatica();
        $("#areaLucroEstimado").hide();
      }
    }

    private aoSelecionarModoLance(e: JQueryEventObject) {
      App.SniperExtensao.ehLanceDinamico = $(e.target).val() == "1";
    }

    private aoSelecionarCorrigirBugEA(e: JQueryEventObject) {
      let selecionado = $(e.target).is(':checked');
      localStorage.setItem('bugcheckedEa', selecionado ? '1' : '0');
      App.Util.usuario.configuracaoConta.correcao_bug_ea = Boolean(selecionado);
    }
    private aoSelecionarVendaPrecoFutbin(e: JQueryEventObject) {
      if ($(e.target).is(':checked')) {
        $('.espaco-preco-venda-futbin').removeClass('opcao-venda-desativada');
      } else {
        $('.espaco-preco-venda-futbin').addClass('opcao-venda-desativada');
      }
    }
    private aoSelecionarVendaPrecoFutbinLista(e: JQueryEventObject) {
      $('.ativar-preco-venda-futbin-lista').prop("checked", $(e.target).is(':checked'));
      if ($(e.target).is(':checked')) {
        $('.espaco-preco-venda-futbin-lista').removeClass('opcao-venda-desativada');
        $('.espaco-preco-venda-futbin-lista .complemento').show();
      } else {
        $('.espaco-preco-venda-futbin-lista').addClass('opcao-venda-desativada');
        $('.espaco-preco-venda-futbin-lista .complemento').hide();
      }
    }
    private aoSelecionarVendaPrecoInteligente(e: JQueryEventObject) {
      if ($(e.target).is(':checked')) {
        $('.espaco-preco-venda-inteligente').removeClass('opcao-venda-desativada');
      } else {
        $('.espaco-preco-venda-inteligente').addClass('opcao-venda-desativada');
      }
    }
    private aoSelecionarVendaPrecoInteligenteLista(e: JQueryEventObject) {
      if ($(e.target).is(':checked')) {
        $('.espaco-preco-venda-inteligente-lista').removeClass('opcao-venda-desativada');
      } else {
        $('.espaco-preco-venda-inteligente-lista').addClass('opcao-venda-desativada');
      }
    }

    private habilitarVendaAutomatica() {
      this.elSniperPage.find('#conteudoVendaAutomatica :input').prop("disabled", false).val("");
      this.elSniperPage.find('#conteudoVendaAutomatica .input-group-prepend').removeClass("disabled");
      $("#infoVendaAutomaticaLig").show();
      $("#infoVendaAutomaticaDeslig").hide();
      App.SniperExtensao.vendaAutomaticaAtiva = true;
      $("#corpoVendaAutomatica").show();
      $("#labelVendaAutomatica").removeClass('text-muted').addClass('text-primary');
    }

    private desabilitarVendaAutomatica() {
      $("#infoVendaAutomaticaLig").hide();
      this.elSniperPage.find('#conteudoVendaAutomatica :input').prop("disabled", true).val("");
      this.elSniperPage.find('#conteudoVendaAutomatica .input-group-prepend').addClass("disabled");
      $("#infoVendaAutomaticaLig").hide();
      $("#infoVendaAutomaticaDeslig").show();
      $('.info-valor-venda-automatica').html('');
      App.SniperExtensao.vendaAutomaticaAtiva = false;
      App.SniperExtensao.arrayItensVendaAutomatica = [];
      $("#corpoVendaAutomatica").hide();
      $("#labelVendaAutomatica").removeClass('text-primary').addClass('text-muted');
    }

    private aoProgramarSniper(valorProgramado: number) {
      App.SniperExtensao.tempoProgramado = valorProgramado;
      if (App.SniperExtensao.tempoProgramado <= 0) {
        this.elBtSniperProgramado.hide();
      } else {
        this.elBtSniperProgramado.show();
      }
    }

    private limparInfoTentativasEcompras() {
      $('.tentativas').html('0');
      $('.quantidade-compras').html('0');
      $('.quantidade-lances').html('0');
      $('.progress-compras').css('width', '0%');
    }

    public static getConteudoLogSniperIniciado(): string {
      if (App.SniperExtensao.ehLance) {
        return '<span class="badge badge-pill badge-primary text-uppercase">Lance iniciado</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Começou a dar lances.</p>';
      } else {
        return '<span class="badge badge-pill badge-primary text-uppercase">Sniper iniciado</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Começou a snipar.</p>';
      }
    }
    public static getConteudoLogSniperParado(): string {
      if (App.SniperExtensao.ehLance) {
        return '<span class="sniper-parado"><span class="badge badge-pill badge-danger text-uppercase">Lance parado</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Parou de dar lances.</p></span>';
      } else {
        return '<span class="sniper-parado"><span class="badge badge-pill badge-danger text-uppercase">Sniper parado</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Parou de snipar.</p></span>';
      }
    }
    public static salvarLogSnipouJogador(elementoLog: any, itemComprado: any) {
      var player = App.Util.getItemArrayById(App.SniperExtensao.players, itemComprado.itemData.assetId, App.SniperExtensao.objJogadorDefault);
      var nomeJogador = (player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l);
      elementoLog.prepend('<span id="conteudoLogSnipou">\n\
                    <span class="badge badge-pill badge-success text-uppercase">Snipado</span>\n\
                    <span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span>\n\
                    <p class="description border-bottom">Você snipou <b>'+ nomeJogador + ' (' + itemComprado.itemData.rating + ')' + '</b> por <strong>' + itemComprado.buyNowPrice + ' coins</strong>.</p></span>');
    }
    public static getConteudoLogSnipou(itemComprado: any): string {
      var nomeConsumivel = "";
      switch (itemComprado.itemData.itemType) {
        case "manager":
          nomeConsumivel = `<b>${itemComprado.itemData.firstName} (${itemComprado.itemData.rating})</b>`;
          break;

        default:
          nomeConsumivel = "";
          break;
      }
      return '<span id="conteudoLogSnipou">\n\
<span class="badge badge-pill badge-success text-uppercase">Snipado</span>\n\
<span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span>\n\
<p class="description border-bottom">Você snipou '+ nomeConsumivel + ' por <strong>' + itemComprado.buyNowPrice + ' coins</strong>.</p></span>';
    }
    public static getConteudoLogBloqueado(): string {
      $('.log-conteudo-bloqueado').remove();
      return '<span class="log-conteudo-bloqueado"><span class="badge badge-pill badge-danger text-uppercase">Bloqueado</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description"><strong>Por segurança</strong> interrompemos o sniper, <strong>conexão falhou</strong>, o motivo pode ser perda de conexão com internet, Captcha ou seu mercado está bloqueado temporariamente.</p><a class="btn btn-1 btn-warning mt-1" target="_blank" href="' + App.SniperExtensao.urlAppFut + '">Autenticar novamente</a><p class="border-bottom mt-0 height-10">&nbsp;</p></span>';
    }
    public static getConteudoLogLimiteCompraAtingido(valor: string | number): string {
      if (App.SniperExtensao.ehLance) {
        return '<span class="badge badge-pill badge-warning text-uppercase">Limite de compra atingido</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Você atingiu a quantidade limite mínima de lances ganhos.</p>';
      } else {
        return '<span class="badge badge-pill badge-warning text-uppercase">Limite de compra atingido</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Você atingiu o limite de compra de ' + valor + ' jogadore(s).</p>';
      }
    }
    public static getConteudoLogLimiteTempoProgramado(): string {
      return '<span class="badge badge-pill badge-info text-uppercase">Tempo acabando</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Finalizando sniper programado.</p>';
    }
    public static salvarLogDisputaPerdida(elementoLog: any, item: any) {
      if (App.SniperExtensao.ehConsumiveis) {
        elementoLog.prepend('<span class="badge badge-pill badge-default text-uppercase">Disputa perdida</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Disputa perdida pelo valor de <b>' + item.buyNowPrice + ' coins</b>, mas isso é comum, alguém conseguiu snipar antes que você.</p>');
      } else {
        var player = App.Util.getItemArrayById(App.SniperExtensao.players, item.itemData.assetId, App.SniperExtensao.objJogadorDefault);
        var nomeJogador = (player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l);
        elementoLog.prepend('<span class="badge badge-pill badge-default text-uppercase">Disputa perdida</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Disputa perdida do jogador <b>' + nomeJogador + ' (' + item.itemData.rating + ')' + '</b> pelo valor de <b>' + item.buyNowPrice + ' coins</b>, mas isso é comum, alguém conseguiu snipar antes que você.</p>');

      }
    }
    public static salvarLogColocouaVenda(elementoLog: any, item: any, venda: IVenda) {
      var player = App.Util.getItemArrayById(App.SniperExtensao.players, item.itemData.assetId, App.SniperExtensao.objJogadorDefault);
      var nomeJogador = item.itemData.hasOwnProperty('itemType') && item.itemData.itemType != "player" ? "Item" : (player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l);
      elementoLog.prepend('<span class="badge badge-pill badge-info text-uppercase">Colocou à venda</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom"><b>' + nomeJogador + '</b> colocado à venda automaticamente por <b>' + venda.valorVenda.toString() + ' coins</b>.</p>');
    }

    public static getConteudoLogListaCheia(): string {
      return '<span class="badge badge-pill badge-danger text-uppercase">Venda bloqueada</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Algo deu errado, sua lista de transferência pode estar cheia.</p>';
    }
    public static getConteudoLogSemEspacoNasListas(): string {
      return '<span class="badge badge-pill badge-danger text-uppercase">Compra bloqueada</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Suas listas podem estar cheias, libere espaço e carregue as telas do Web App e Futsniperweb novamente.</p>';
    }
    public static getConteudoLogSemEspacoNaListaPorItensInegociaveis(): string {
      return '<span class="badge badge-pill badge-danger text-uppercase" style="color: #f89500;background-color: rgba(242, 252, 89, 0.5);">Sniper bloqueado</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Você precisa liberar itens inegociáveis que estão tomando conta do espaço em sua lista de itens não atribuídos.</p>';
    }
    public static getConteudoLogNaoColocadoAVenda(): string {
      return '<span class="badge badge-pill badge-danger text-uppercase">Venda bloqueada</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Suas listas podem estar cheias, libere espaço e carregue as telas do Web App e Futsniperweb novamente.</p>';
    }
    public static getConteudoLogMovidoParaTransferencia(quantidadeMovimentada: number): string {
      return '<span class="badge badge-pill badge-info text-uppercase">Espaço liberado</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom"><b>' + quantidadeMovimentada + ' Item(s) movido(s)</b> para lista de transferência para liberar espaço na lista de itens não atribuídos.</p>';
    }
    public static getConteudoLogQuantidadeComprasDiariasAtingida(): string {
      return '<span class="badge badge-pill badge-warning text-uppercase">Limite compras/dia atingido</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Você atingiu o limite diário de compras, aguarde o dia de amanhã para poder voltar a snipar ou adquira um plano melhor.</p>';
    }
    public static getConteudoLogTerminouComprasItensDme(): string {
      return '<span class="badge badge-pill badge-primary badge-comprou-itens-dme text-uppercase">Compra de elenco concluída</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Você gastou <b>' + App.SniperExtensao.totalGastoCompraDme + ' coins</b> na compra desse elenco de DME, os jogadores permanecem em suas listas de transferencias ou observação.</p>';
    }
    public static getConteudoLogCaptcha(): string {
      return '<span class="badge badge-pill badge-warning text-uppercase">Captcha</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Você precisa resolver o captcha em sua conta.<br /><a class="btn btn-1 btn-warning mt-1 mb-1" target="_blank" href="' + App.SniperExtensao.urlAppFut + '">Resolver Captcha</a></p>';
    }
    public static salvarLogJogadorJaExiste(elementoLog: any, item: any) {
      var player = App.Util.getItemArrayById(App.SniperExtensao.players, parseInt(item.assetId), App.SniperExtensao.objJogadorDefault);
      var nomeJogador = (player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l);
      elementoLog.prepend('<span class="badge badge-pill badge-info badge-jogador-existente">Jogador existente</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Você já tem o jogador <b>' + nomeJogador + '</b> em seu clube.</p>');
    }

    public static salvarLogJogadorEspecialObservar(elementoLog: any, item: any) {
      var player = App.Util.getItemArrayById(App.SniperExtensao.players, parseInt(item.assetId), App.SniperExtensao.objJogadorDefault);
      var nomeJogador = (player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l);
      elementoLog.prepend('<span class="badge badge-pill badge-primary">Observar Jogador</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom"><b>' + nomeJogador + '</b> pode ser uma carta <b>especial ou de variação</b> do jogador, o sistema tentará compra-la, caso demore muito, remova a carta da lista e compre direto no WebApp.</p>');
    }

    public static salvarLogJogadorEspecialNaoCompramos(elementoLog: any, item: any) {
      var player = App.Util.getItemArrayById(App.SniperExtensao.players, parseInt(item.assetId), App.SniperExtensao.objJogadorDefault);
      var nomeJogador = (player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l);
      elementoLog.prepend('<span class="badge badge-pill badge-info badge-jogador-especial">Jogador Variado</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom"><b>' + nomeJogador + '</b> é uma carta <b>especial ou de variação</b> do jogador, o sistema ainda não foi preparado para encontrar esse tipo de carta, <b>sugerimos que você compre direto no WebApp</b>, um jogador de conceito dessa carta será adicionado ao montar o DME/SBC.</p>');
    }

    public static salvarLogJogadorNaoTemNoMercado(elementoLog: any, item: any) {
      var player = App.Util.getItemArrayById(App.SniperExtensao.players, parseInt(item.assetId), App.SniperExtensao.objJogadorDefault);
      var nomeJogador = (player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l);
      elementoLog.prepend('<span class="badge badge-pill badge-info badge-jogador-especial">Jogador Extinto</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom"><b>' + nomeJogador + '</b> extinto, <b>sugerimos que você compre direto no WebApp se encontra-lo ou compre uma outra carta que sirva</b>, um jogador de conceito dessa carta será adicionado ao montar o DME/SBC.</p>');
    }

    private temEspacoDisponivelNasListasDaEa(): boolean {
      return (App.SniperExtensao.quantidadeDisponivelListaDeObservacao + App.SniperExtensao.quantidadeDisponivelListaDeTransferencia) > 0;
    }

    private getChromeVersion(): number | any {
      var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);

      return raw ? parseInt(raw[2], 10) : false;
    }

    private validarPlano(e: JQueryEventObject | any) {
      if (e) {
        e.preventDefault();
      }

      if (this.autoDme) {
        this.autoDme.resolvendo = false;
      }

      $.ajax({
        url: App.Util.config.urlStatus,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(
          {
            dados_ea: App.SniperExtensao.dadosContaEa,
            nome_conta_ea: App.SniperExtensao.dadosContaEa.clube,
            quantidade_max_compras_por_vez: App.SniperExtensao.getQuantidadeMaxCompras(),
            velocidade_max: this.getMilesegundos(),
            tempo_max_programado: App.SniperExtensao.getTempoProgramadoSniper(),
            id_liga: App.Util.empty($('#liga').val()) ? 0 : parseInt($('#liga').val()),
            nome_liga: App.Util.empty($('.conferencia-liga span').html()) ? null : $('.conferencia-liga span').html(),
            eh_venda_coins: App.SniperExtensao.ehVendaCoins
          }),
        beforeSend: function (jqXHR, settings) {
          jqXHR.setRequestHeader('X-CSRF-TOKEN', $('meta[name=csrf-token]').attr("content"));
        },
        success: (resposta) => {
          if (App.SniperExtensao.ehVendaCoins && resposta.status) {
            this.inicializarVendaDeCoins();
          }
          if (!App.SniperExtensao.ehAnaliseClube) {
            App.Util.ocultarModalPaginaCarregando();
          }
          if (resposta.status && !e) {
            return;
          } else if (resposta.status) {
            this.aoSnipar(e);
          } else {
            this.exibirMensagemAlertaSwal(resposta.tituloMensagem, resposta.mensagem, resposta.tipo, resposta.textoBotaoConfirma, resposta.textoBotaoCancela, '#2dce89', resposta.exibirBotaoCancelar, resposta.urlRedirecionamentoBotaoConfirma, null, resposta.contaEaJaVinculada);
          }
        },
        error: (jqXHR, textStatus, errorThrown) => {
          if (!App.SniperExtensao.ehAnaliseClube) {
            App.Util.ocultarModalPaginaCarregando();
          }
        }
      });

    }
    private aoSnipar(e: JQueryEventObject) {
      this.inicializarConfiguracoes();
      if (this.ehSniperPorPrecoCompra) {
        this.limparViewLogLucroEstimado()
      }
      if (App.SniperExtensao.ehVersaoDesatualizadaExtensao()) {
        this.exibirMensagemExtensaoDesatualizada();
        return;
      } else if (App.SniperExtensao.sniperTravado) {
        App.SniperExtensao.exibirMensagemSnipeTravado();
        return;
      } else if (App.SniperExtensao.listaNaoAtribuidosBloqueada) {
        this.exibirMensagemItensInegociaveisOcupandoLista();
        return;
      } else if (!this.temEspacoDisponivelNasListasDaEa()) {
        this.exibirMensagemSemCapacidadeNasListasDeTranferencia();
        return;
      } else {
        if (!App.SniperExtensao.ehConsumiveis && !App.SniperExtensao.ehJogadorEspecial && App.Util.ehCampoTextoVazio(this.elCampoQualidade) && App.Util.ehCampoTextoVazio(this.elCampoRaridade) && App.Util.ehCampoTextoVazio(this.elCampoPosicao) && App.Util.ehCampoTextoVazio(this.elCampoEstilo) && App.Util.ehCampoTextoVazio(this.elCampoEstiloJogo) && App.Util.ehCampoTextoVazio(this.elCampoJogador) && App.Util.ehCampoTextoVazio(this.elCampoClube) && App.Util.ehCampoTextoVazio(this.elCampoLiga) && App.Util.ehCampoTextoVazio(this.elCampoNacionalidade)) {
          swal("Obrigatório!", "Informe pelo menos um filtro para iniciar o sniper.", "error");
          return;
        }
        // Validação para venda automática ativa
        if (this.elAtivarVendaAutomatica.is(':checked') && this.modoManterNoCemiterio()) {
          swal("Obrigatório!", "Atualmente a venda automática só funciona quando os ítens são enviados para lista de transferência.", "error");
          return;
        }
        if (App.SniperExtensao.ehJogadorEspecial && !this.modoHumanoAtivo()) {
          swal("Obrigatório!", "Atualmente a busca por jogador especial só funciona quando os ítens são enviados para lista de transferência.", "error");
          return;
        }
        if (App.SniperExtensao.ehJogadorEspecial && App.Util.ehCampoTextoVazio(this.elCampoJogador)) {
          swal("Obrigatório!", "Informe o jogador especial", "error");
          return;
        }
        // Validação para valor máximo
        if (App.Util.ehCampoTextoVazio(this.elCampoValorMaximo)) {
          swal("Obrigatório!", "Informe o valor de oferta", "error");
          return;
        }

        if (this.ehSniperPorLucro && !App.Util.ehCampoTextoVazio(this.elCampoJogador) && $.isArray(this.elCampoJogador.val()) && this.elCampoJogador.val().length > 1) {
          swal("Obrigatório!", "No filtro por lucro por enquanto é permitido no máximo 1 jogador no campo de jogadores.", "warning");
          return;
        }

        if (App.SniperExtensao.ehPadrao && this.ehSniperPorPrecoCompra && App.Util.editarPrecoJogadoresSelecionados) {
          let conferenciaPrecoIncompativelJogadores = this.jogadorComPrecoIncompativel();
          if (conferenciaPrecoIncompativelJogadores.status && !App.SniperExtensao.ehModoCompraDme) {
            let nomeJogador = (conferenciaPrecoIncompativelJogadores.player.hasOwnProperty('c') ? conferenciaPrecoIncompativelJogadores.player.c : conferenciaPrecoIncompativelJogadores.player.f + ' ' + conferenciaPrecoIncompativelJogadores.player.l);
            swal.fire({
              title: 'Atenção!',
              html: `<b>Confira o preço de compra dos jogadore(s)!</b> <br /><br />Você precisa editar o valor no campo do jogador <b>${nomeJogador}</b> , o valor de compra está imcompatível com o valor mínimo de mercado.`,
              imageUrl: '/img/exemplos/editar-preco-jogador.png',
              imageWidth: 800,
              imageAlt: 'editar preco jogador',
              imageClass: 'image-max-width',
            })
            return;
          }
        }

        toastr.success("Fique tranquilo, o sistema fará tudo automático para você.", "Sniper iniciado!");
        $("#espacoLogs").prepend(App.SniperExtensao.getConteudoLogSniperIniciado());

        //Se sniper foi programado
        App.SniperExtensao.sniperProgramado = App.SniperExtensao.tempoProgramado > 0;

        if (App.SniperExtensao.sniperProgramado) {
          App.SniperExtensao.finalizarLoopIntervalo();
          App.SniperExtensao.finalizarLoopTimeouts();


          App.SniperExtensao.tempoParaFinalizarLoopProgramado = setTimeout(() => { App.SniperExtensao.finalizarSniperProgramado(); }, App.Util.parseMinutosParaMilisegundos(App.SniperExtensao.tempoProgramado));
          App.SniperExtensao.iniciarCronometro(App.SniperExtensao.tempoProgramado * 60);
        }

        if (App.SniperExtensao.ehConsumiveis) {
          this.objFiltro = this.getObjetoFiltrosConsumiveis(e);
        } else if (App.SniperExtensao.ehJogadorEspecial) {
          App.SniperExtensao.passoPagina = null;
          this.objFiltro = this.getObjetoFiltrosJogadorEspecial(e);
        } else {
          this.objFiltro = this.getObjetoFiltros(e);
        }
        App.SniperExtensao.errorsCompraSequencia = 0;
        App.SniperExtensao.errorsSequenciaVenda = 0;
        $('#abaLog').click();
        this.quantidadeLancesganhosAtuais = null;
        this.snipar(e);
      }
    }

    private obterTempoDescansoAleatorioPorOpcaoEscolhida(opcaoEscolhida: number | string) {
      switch (opcaoEscolhida) {
        case 0:
          return App.Util.getRandomInt(30000, 60000);
        case 1:
          return App.Util.getRandomInt(30000, 120000);
        case 2:
          return App.Util.getRandomInt(60000, 120000);
        case 3:
          return App.Util.getRandomInt(60000, 180000);
        case 4:
          return App.Util.getRandomInt(120000, 240000);
        default:
          return App.Util.getRandomInt(30000, 120000);
      }

    }

    private fecharWebApp() {
      chrome.runtime.sendMessage(this.idExtensao, { evento: "fchwpp" }, (resposta: any) => { });
    }

    private eliminarDuplicacaoPaginaFSW() {
      try {
        chrome.runtime.sendMessage(this.idExtensao, { evento: "ewdup" }, (resp: any) => { });
      } catch (e) {
      }

    }

    private openPopUpChromeExtension() {
      chrome.runtime.sendMessage(this.idExtensao, { evento: "oppopupchr" }, (resposta: any) => {
      });
    }
    private alterarParaAbaWebApp() {
      chrome.runtime.sendMessage(this.idExtensao, { evento: "irwp" }, (resposta: any) => {
      });
    }

    private atualizarStatusCheckboxConfiguracoes() {
      $("#modoSilencioso").prop("checked", App.Util.usuario.configuracao.modo_silencioso);
      $("#ativarManterNoCemiterio").prop("checked", App.Util.usuario.configuracaoConta.manter_no_cemiterio);
      $("#ativarLanceInfinito").prop("checked", App.Util.usuario.configuracaoConta.lance_infinito);
      $("#resolverCaptchaAutomaticamente").prop("checked", App.Util.usuario.configuracaoConta.resolver_captcha_automaticamente).trigger('change');;
    }


    private snipar(e: JQueryEventObject, tentativaProgramada = false, teste = false) {
      App.SniperExtensao.ultimoEventSubmit = e;
      if (teste) {
        App.SniperExtensao.quantidadeMaximaTentativasPorVez = 1;
        this.objFiltro = this.getObjetoFiltrosTeste(e);
      }

      App.SniperExtensao.itensExpiradosOuComprados = [];
      if (!this.temEspacoDisponivelNasListasDaEa()) {
        $("#espacoLogs").prepend(App.SniperExtensao.getConteudoLogSemEspacoNasListas());
        this.pararTudo();
        return;
      }

      if (this.getQuantidadeCompras() >= App.SniperExtensao.quantidadeMaximaCompras) {
        this.pararTudo();
        return;
      }

      this.atualizarIconeLoadingTentativasSniper("fas fa-plug", 'Estabelecendo comunicação com WEBAPP...');
      if (!tentativaProgramada) {
        $(".loading").show();
        App.SniperExtensao.comunicacaoEstabelecidaComWebApp = false;
        App.SniperExtensao.sniperAtivo = true;
        App.SniperExtensao.acionadoPeloUsuario = false;
        App.SniperExtensao.elBtSnipar.prop('disabled', true);
        App.SniperExtensao.exibirLoadingSniperApp();
        App.SniperExtensao.tempoParaEstabelecerComunicacao = setTimeout(() => {
          if (!App.SniperExtensao.comunicacaoEstabelecidaComWebApp && App.SniperExtensao.sniperAtivo) {
            this.exibirMensagemAlertaSwal("WebApp não respondeu!", "Carregue o WebApp por completo e acesse novamente a extensão", "error", "OK", "Fechar", "#2dce89", false);
            this.pararTudo();
          }
        }, 15000);
      }
      var acrecimoTentativas: number = this.modoHumanoAtivo() ? this.tempoAcrescimoTentativa : 0;
      App.SniperExtensao.finalizarTentativasSniper();
      App.SniperExtensao.descansoDeCompra = 0;
      let decrescimoQuantTentativaRand = App.SniperExtensao.quantidadeMaximaTentativasPorVez <= 30 ? 5 : 10;
      let quantidadeTentativasRand = this.modoHumanoAtivo() ? App.Util.getRandomInt(App.SniperExtensao.quantidadeMaximaTentativasPorVez - decrescimoQuantTentativaRand, App.SniperExtensao.quantidadeMaximaTentativasPorVez) : App.SniperExtensao.quantidadeMaximaTentativasPorVez;

      if (App.SniperExtensao.ehModoCompraDme) {
        this.atualizarFiltroModoDmePorRodada()
      } else {
        this.filtroPagina = null;
      }

      App.SniperExtensao.loopTentativas = setInterval(() => {
        if (App.SniperExtensao.movimentandoItens) {
          return;
        }

        var comprasNoLimite = this.getQuantidadeCompras() >= App.SniperExtensao.quantidadeMaximaCompras;
        var tentativasNoLimite = this.getQuantidadeTentativas() >= quantidadeTentativasRand;
        if (!App.SniperExtensao.sniperAtivo || comprasNoLimite || tentativasNoLimite) {
          if (comprasNoLimite) {
            if (!App.SniperExtensao.acionadoPeloUsuario) {
              $("#espacoLogs").prepend(App.SniperExtensao.getConteudoLogLimiteCompraAtingido(App.SniperExtensao.quantidadeMaximaCompras));
            }
            this.pararTudo();
          }

          if (!App.SniperExtensao.sniperProgramado) {
            App.SniperExtensao.habilitarPossibilidadeDeSnipar();
            if (!comprasNoLimite) {
              App.SniperExtensao.exibirLogSniperParado();
            }
          }

          if (!App.SniperExtensao.sniperAtivo) {
            if (App.SniperExtensao.sniperProgramado) {
              App.SniperExtensao.habilitarPossibilidadeDeSnipar();
              App.SniperExtensao.finalizarSniperProgramado(!App.SniperExtensao.acionadoPeloUsuario);
            }
            App.SniperExtensao.finalizarTentativasSniper();
          }

          if (tentativasNoLimite) {
            this.tentativaAtual = 0;
            App.SniperExtensao.finalizarTentativasSniper();
          }

          if (!App.SniperExtensao.sniperProgramado) {
            App.SniperExtensao.sniperAtivo = false;
          }

          clearInterval(App.SniperExtensao.loopTentativas);
          App.SniperExtensao.elSpinnerCancelar.hide();
          App.SniperExtensao.acionadoPeloUsuario = false;

          /**
           * Aqui é onde o descanso funciona
           */
          this.iniciarDescansoSniperProgramado(e);
          this.intercalarTelaWebAppSniper();
          return;
        }
        if (!teste) {
          this.atualizarFiltro();
        }
        this.processarTentativa(e, teste);
        App.SniperExtensao.acionadoPeloUsuario = false;
      }, App.Util.getRandomInt(this.getMilesegundos(), this.getMilesegundos() + acrecimoTentativas));
      App.SniperExtensao.arrayLoopTentativas.push(App.SniperExtensao.loopTentativas);
    }

    private static exibirLogSniperParado() {
      $("#espacoLogs").find(`.sniper-parado`).remove();
      $("#espacoLogs").prepend(App.SniperExtensao.getConteudoLogSniperParado());
    }

    private iniciarDescansoSniperProgramado(e: JQueryEventObject, descansoPosCompra: number = null) {
      this.atualizarEstatisticas();
      var milisegundosDescanso = 0;
      if (App.SniperExtensao.sniperProgramado) {
        App.SniperExtensao.finalizarLoopIntervalo();
        App.SniperExtensao.finalizarLoopTimeouts();
        if (App.SniperExtensao.ehModoCompraDme) {
          //Aleatório entre 30 segundo e 1 min
          milisegundosDescanso = descansoPosCompra ? descansoPosCompra : App.Util.getRandomInt(30000, 60000);
          // console.log("Iniciar novo descanso", App.Util.formatDuration(milisegundosDescanso))
        } else if (this.modoHumanoAtivo()) {
          //Aleatório dependendo da escolha do usuário
          milisegundosDescanso = this.obterTempoDescansoAleatorioPorOpcaoEscolhida(App.SniperExtensao.tempoIntervaloEntreTentativas);
        } else if (App.SniperExtensao.tempoIntervaloEntreTentativas > 0) {
          milisegundosDescanso = App.Util.parseMinutosParaMilisegundos(App.SniperExtensao.tempoIntervaloEntreTentativas);
        } else {
          milisegundosDescanso = 30000;
        }
        // Atualizando loop com novo intervalo de descanso caso esteja no modo humano
        //Aqui onde inicio as tentativas com intervalo de descanso
        setTimeout(() => {
          this.atualizarIconeLoadingTentativasSniper("fas fa-hourglass-half", (milisegundosDescanso / 1000).toString() + ' segundos de descanso');
        }, 4000);
        App.SniperExtensao.loopIntervaloProgramado = setTimeout(() => this.snipar(e, true), App.SniperExtensao.ehLanceDinamico ? 0 : milisegundosDescanso);
        App.SniperExtensao.arrayLoopTimeouts.push(App.SniperExtensao.loopIntervaloProgramado);
      }
    }

    private atualizarFiltroModoDmePorRodada() {
      let valorCampoPorcentageMaisBarato = parseInt(App.SniperExtensao.elCampoNoUiSliderPorcentagemMaisBarato.noUiSlider.get());
      this.objFiltro.maskedDefId = this.dadosForm.jogador[Math.floor(Math.random() * this.dadosForm.jogador.length)];
      let valorOfertaMaximaDme = App.SniperExtensao.getValorMaximoOfertaDme();

      var itemElencoDme: IElencoDme = App.Util.getItemArrayByAssetId(App.Util.elencoDme.elenco, this.objFiltro.maskedDefId);
      valorCampoPorcentageMaisBarato = valorCampoPorcentageMaisBarato ? valorCampoPorcentageMaisBarato : itemElencoDme.porcentagemMaisBarato;
      this.filtroPagina = {}
      this.filtroPagina.teamIdFiltro = parseInt(itemElencoDme.teamId.toString());
      this.filtroPagina.ratingFiltro = parseInt(itemElencoDme.rating.toString());

      this.objFiltro.rarityIds = itemElencoDme.rarityId as any;
      // this.objFiltro.pos = itemElencoDme.pos;

      if (App.Util.empty(itemElencoDme.preco) || itemElencoDme.preco <= 0) {
        itemElencoDme.preco = itemElencoDme.precoMin < 200 ? 200 : itemElencoDme.precoMin;
        itemElencoDme.precoInicial = itemElencoDme.preco;
      } else if (valorCampoPorcentageMaisBarato > 0 && itemElencoDme.preco > 200) {
        if (App.Util.empty(itemElencoDme.precoInicial)) {
          itemElencoDme.preco = this.obterValorMaisBaratoPorPorcentagem(itemElencoDme, valorCampoPorcentageMaisBarato);
          itemElencoDme.precoInicial = itemElencoDme.preco;
        }
      }

      itemElencoDme.precoInicial = itemElencoDme.hasOwnProperty("precoInicial") ? itemElencoDme.precoInicial : itemElencoDme.preco;

      let eParaIncrementarPreco = itemElencoDme.precoAnterior == itemElencoDme.preco;
      if (eParaIncrementarPreco) {
        itemElencoDme.preco = App.Util.incrementarValorDeFiltro(itemElencoDme.preco)
      }

      if (valorOfertaMaximaDme && valorOfertaMaximaDme < itemElencoDme.preco) {
        itemElencoDme.preco = valorOfertaMaximaDme;
        if (itemElencoDme.precoInicial > itemElencoDme.preco) {
          itemElencoDme.precoInicial = valorOfertaMaximaDme;
        }
      }

      itemElencoDme.preco = itemElencoDme.preco <= itemElencoDme.precoMax ? itemElencoDme.preco : itemElencoDme.precoMax;
      itemElencoDme.preco = $.isNumeric(itemElencoDme.precoMin) && itemElencoDme.precoMin > 0 && itemElencoDme.preco < itemElencoDme.precoMin ? itemElencoDme.precoMin : itemElencoDme.preco;
      this.objFiltro.maxb = itemElencoDme.preco;
      itemElencoDme.precoAnterior = itemElencoDme.preco;

      // console.log("JOGADOR::",
      //     `NOME:: ${itemElencoDme.nome}`,
      //     `PRECO:: ${itemElencoDme.preco}`,
      //     `ANTERIOR:: ${itemElencoDme.precoAnterior}`,
      //     `INICIAL:: ${itemElencoDme.precoInicial}`, eParaIncrementarPreco)

      App.Util.elencoDme.elenco = App.Util.updateOrCreateItemArrayAssetId(App.Util.elencoDme.elenco, this.objFiltro.maskedDefId, itemElencoDme)
      this.exibirDetalhesLoadJogador(itemElencoDme);
    }

    private atualizarFiltro() {
      if (!App.SniperExtensao.ehModoCompraDme) {
        //  variar filtro
        if (!App.SniperExtensao.ehLance) {
          var variarPrecoCompraPrecoAbaixo = App.Util.getRandomInt(1, 5) == 3 && App.SniperExtensao.maxbInicial > 350
          this.objFiltro.maxb = variarPrecoCompraPrecoAbaixo ? App.Util.decrementarValorDeFiltro(App.SniperExtensao.maxbInicial) : App.SniperExtensao.maxbInicial;
        }
        //                    this.objFiltro.maxb = App.SniperExtensao.maxbInicial;
      }

      if ((App.SniperExtensao.ehPadrao || App.SniperExtensao.ehLance) && this.dadosForm.hasOwnProperty("jogador") && this.dadosForm.jogador.length > 0) {
        if (!App.SniperExtensao.ehModoCompraDme) {
          this.objFiltro.maskedDefId = this.dadosForm.jogador[Math.floor(Math.random() * this.dadosForm.jogador.length)];
        }
      }

      /**
       * Modifico o valor de compra quando editado pelo usuário em cada jogador selecionado
       */
      if (this.objFiltro.maxb) {
        let valorOfertaPersonalizadoDoJogador: number = this.getValorOfertaPersonalizadoDoJogador(this.objFiltro.maskedDefId, this.objFiltro.maxb)
        if (!App.SniperExtensao.ehModoCompraDme) {
          this.objFiltro.maxb = valorOfertaPersonalizadoDoJogador;
        } else if (valorOfertaPersonalizadoDoJogador > 200 && this.objFiltro.maxb < valorOfertaPersonalizadoDoJogador) {
          this.objFiltro.maxb = valorOfertaPersonalizadoDoJogador;
        }
        App.SniperExtensao.valorMinimo = this.variarFiltroAvancado(App.SniperExtensao.valorMinimo, this.objFiltro.maxb);
        this.elCampoMinimo.val(App.SniperExtensao.valorMinimo);
      } else {
        App.SniperExtensao.valorMinimo = this.variarFiltroAvancado(App.SniperExtensao.valorMinimo);
        this.elCampoMinimo.val(App.SniperExtensao.valorMinimo);
      }


      /**
       * Variando para nao ter valor lance minimo as vezes
       */
      if (App.Util.getRandomInt(1, 8) == 3 && this.objFiltro.maxb <= 20000) {
        delete this.objFiltro.micr;
      } else {
        this.objFiltro.micr = App.SniperExtensao.valorMinimo;
      }


      /**
       * Variando para ter valor lance maximo as vezes
       */
      //                var decrementValoMaxb = App.Util.decrementarValorDeFiltro(this.objFiltro.maxb);
      //                if (App.SniperExtensao.valorMinimo >= decrementValoMaxb) {
      //                    delete this.objFiltro.macr;
      //                } else if (App.Util.getRandomInt(1, 10) == 3 && this.objFiltro.maxb <= 20000) {
      //                    this.objFiltro.macr = decrementValoMaxb;
      //                } else if (App.Util.getRandomInt(1, 20) == 3) {
      //                    this.objFiltro.macr = decrementValoMaxb;
      //                } else {
      //                    delete this.objFiltro.macr;
      //                }


      if (App.SniperExtensao.ehPadrao || App.SniperExtensao.ehLance) {
        this.objFiltro = this.ordenarObjetoFiltros(this.objFiltro);
      }

      if (App.SniperExtensao.ehConsumiveis) {
        this.objFiltro = this.ordenarObjetoFiltrosConsumiveis(this.objFiltro);
      }
    }

    public obterValorMaisBaratoPorPorcentagem(itemElencoDme: IElencoDme, iPorcentagem: number) {
      var precoFinal = itemElencoDme.preco;
      var precoMaisBarato = itemElencoDme.preco - ((iPorcentagem / 100) * itemElencoDme.preco);
      if (precoMaisBarato >= 200 && precoMaisBarato <= itemElencoDme.precoMax) {
        precoFinal = App.Util.tratarValorDeFiltro(precoMaisBarato);
      }
      precoFinal = $.isNumeric(itemElencoDme.precoMin) && itemElencoDme.precoMin > 0 && precoFinal < itemElencoDme.precoMin ? itemElencoDme.precoMin : precoFinal
      return precoFinal;
    }

    public static processarTrava() {
      this.runAudio(2);
      App.SniperExtensao.sniperTravado = 1;
      $("#espacoLogs").prepend(App.SniperExtensao.getConteudoLogBloqueado());
    }

    private getObjetoFiltrosJogadorEspecial(e: JQueryEventObject): IFiltro {
      this.ajax = new App.Ajax();
      this.dadosForm = this.ajax.convertFormToJSON($(e.target));
      App.SniperExtensao.maxbInicial = App.Util.ehVariavelValidaNaoVazia(this.dadosForm.max) ? this.dadosForm.max : 200;
      var filtro: IFiltro = {
        start: 0,
        num: 21,
        type: "player"
      }
      if (this.dadosForm.hasOwnProperty("jogador") && this.dadosForm.jogador.length > 0) {
        filtro.definitionId = this.dadosForm.jogador[Math.floor(Math.random() * this.dadosForm.jogador.length)];
      } else {
        swal("Erro!", "Um erro ocorreu, por segurança a página será recarregada", "error");
        setTimeout(() => {
          document.location.reload();
        }, 4000);
        return;
      }

      return filtro;
    }

    private getObjetoFiltrosJogadorEspecialForcado(e: JQueryEventObject): IFiltro {
      this.ajax = new App.Ajax();
      this.dadosForm = this.ajax.convertFormToJSON($(e.target));
      App.SniperExtensao.maxbInicial = this.dadosForm.hasOwnProperty("max") && App.Util.ehVariavelValidaNaoVazia(this.dadosForm.max) ? this.dadosForm.max : 200;
      var filtro: IFiltro = {
        start: 0,
        num: 21,
        type: "player",
        micr: App.SniperExtensao.valorMinimo,
        maxb: App.SniperExtensao.maxbInicial
      }
      if (this.dadosForm.hasOwnProperty("jogador") && this.dadosForm.jogador.length > 0) {
        filtro.definitionId = this.dadosForm.jogador[Math.floor(Math.random() * this.dadosForm.jogador.length)];
      } else {
        swal("Erro!", "Um erro ocorreu, por segurança a página será recarregada", "error");
        setTimeout(() => {
          document.location.reload();
        }, 4000);
        return;
      }

      return filtro;
    }

    private ordenarObjetoFiltros(filtroAtual: IFiltro): IFiltro {
      var filtroOrdenado: IFiltro = {
        num: 21,
        start: 0,
        type: "player"
      }

      if (filtroAtual.hasOwnProperty("maskedDefId")) {
        filtroOrdenado.maskedDefId = filtroAtual.maskedDefId;
      }
      if (filtroAtual.hasOwnProperty("zone")) {
        filtroOrdenado.zone = filtroAtual.zone;
      }
      if (filtroAtual.hasOwnProperty("pos")) {
        filtroOrdenado.pos = filtroAtual.pos;
      }
      if (filtroAtual.hasOwnProperty("rare")) {
        filtroOrdenado.rare = filtroAtual.rare;
      }
      if (filtroAtual.hasOwnProperty("lev")) {
        filtroOrdenado.lev = filtroAtual.lev;
      }
      if (filtroAtual.hasOwnProperty("nat")) {
        filtroOrdenado.nat = filtroAtual.nat;
      }
      if (filtroAtual.hasOwnProperty("leag")) {
        filtroOrdenado.leag = filtroAtual.leag;
      }
      if (filtroAtual.hasOwnProperty("team")) {
        filtroOrdenado.team = filtroAtual.team;
      }
      if (filtroAtual.hasOwnProperty("playStyle")) {
        filtroOrdenado.playStyle = filtroAtual.playStyle;
      }
      if (filtroAtual.hasOwnProperty("micr")) {
        filtroOrdenado.micr = filtroAtual.micr;
      }
      if (filtroAtual.hasOwnProperty("macr")) {
        filtroOrdenado.macr = filtroAtual.macr;
      }
      if (filtroAtual.hasOwnProperty("minb")) {
        filtroOrdenado.minb = filtroAtual.minb;
      }
      if (filtroAtual.hasOwnProperty("maxb")) {
        filtroOrdenado.maxb = filtroAtual.maxb;
      }
      if (filtroAtual.hasOwnProperty("rarityIds")) {
        filtroOrdenado.rarityIds = filtroAtual.rarityIds;
      }
      if (filtroAtual.hasOwnProperty("icontraits")) {
        filtroOrdenado.icontraits = filtroAtual.icontraits;
      }

      return filtroOrdenado;
    }
    private ordenarObjetoFiltrosConsumiveis(filtroAtual: IFiltroConsumivel): IFiltro {
      var filtroOrdenado: IFiltroConsumivel = {
        num: 21,
        start: 0,
        type: "training"
      }

      if (filtroAtual.hasOwnProperty("type")) {
        filtroOrdenado.type = filtroAtual.type;
      }

      if (filtroAtual.hasOwnProperty("cat")) {
        filtroOrdenado.cat = filtroAtual.cat;
      }

      if (filtroAtual.hasOwnProperty("pos")) {
        filtroOrdenado.pos = filtroAtual.pos;
      }

      if (filtroAtual.hasOwnProperty("lev")) {
        filtroOrdenado.lev = filtroAtual.lev;
      }
      if (filtroAtual.hasOwnProperty("nat")) {
        filtroOrdenado.nat = filtroAtual.nat;
      }
      if (filtroAtual.hasOwnProperty("leag")) {
        filtroOrdenado.leag = filtroAtual.leag;
      }

      if (filtroAtual.hasOwnProperty("playStyle")) {
        filtroOrdenado.playStyle = filtroAtual.playStyle;
      }
      if (filtroAtual.hasOwnProperty("micr")) {
        filtroOrdenado.micr = filtroAtual.micr;
      }
      if (filtroAtual.hasOwnProperty("macr")) {
        filtroOrdenado.macr = filtroAtual.macr;
      }
      if (filtroAtual.hasOwnProperty("minb")) {
        filtroOrdenado.minb = filtroAtual.minb;
      }
      if (filtroAtual.hasOwnProperty("maxb")) {
        filtroOrdenado.maxb = filtroAtual.maxb;
      }

      return filtroOrdenado;
    }

    private getObjetoFiltros(e: JQueryEventObject, form: JQuery = null): IFiltro {
      this.ajax = new App.Ajax();
      let elForm = form ? form : $(e.target)
      this.dadosForm = this.ajax.convertFormToJSON(elForm);
      App.SniperExtensao.maxbInicial = this.dadosForm.hasOwnProperty("max") && App.Util.ehVariavelValidaNaoVazia(this.dadosForm.max) ? this.dadosForm.max : 200;

      var filtro: IFiltro = {
        num: 21,
        start: 0,
        type: "player"
      }

      if (this.dadosForm.hasOwnProperty("jogador") && this.dadosForm.jogador.length > 0) {
        if (App.SniperExtensao.ehModoCompraDme) {
          filtro.maskedDefId = this.dadosForm.jogador[0];
        } else {
          filtro.maskedDefId = this.dadosForm.jogador[Math.floor(Math.random() * this.dadosForm.jogador.length)];
        }
      }

      if (this.dadosForm.hasOwnProperty('posicao') && this.dadosForm.posicao) {
        if (this.dadosForm.posicao == 'defense' || this.dadosForm.posicao == 'midfield' || this.dadosForm.posicao == 'attacker') {
          filtro.zone = this.dadosForm.posicao;
        } else {
          filtro.pos = this.dadosForm.posicao;
        }
      }

      if (this.dadosForm.hasOwnProperty("qualidade") && this.dadosForm.qualidade) {
        if (this.dadosForm.qualidade == 'SP') {
          filtro.rare = this.dadosForm.qualidade;
        } else {
          filtro.lev = this.dadosForm.qualidade;
        }
      }

      if (this.dadosForm.hasOwnProperty("pais") && this.dadosForm.pais) {
        filtro.nat = this.dadosForm.pais;
      }
      if (this.dadosForm.hasOwnProperty("liga") && this.dadosForm.liga) {
        filtro.leag = this.dadosForm.liga;
      }
      if (this.dadosForm.hasOwnProperty("time") && this.dadosForm.time) {
        filtro.team = this.dadosForm.time;
      }
      if (this.dadosForm.hasOwnProperty("estilo") && this.dadosForm.estilo) {
        filtro.playStyle = this.dadosForm.estilo;
      }

      if (this.dadosForm.hasOwnProperty("estilo_jogo") && this.dadosForm.estilo_jogo) {
        filtro.icontraits = this.dadosForm.estilo_jogo;
      }

      //            filtro.micr = App.SniperExtensao.valorMinimo;

      if (this.dadosForm.hasOwnProperty("min") && this.dadosForm.min) {
        filtro.minb = this.dadosForm.min;
      }

      filtro.maxb = App.SniperExtensao.maxbInicial;
      filtro.maxb = this.getValorOfertaPersonalizadoDoJogador(filtro.maskedDefId, filtro.maxb);

      if (this.dadosForm.hasOwnProperty("raridade") && this.dadosForm.raridade) {
        filtro.rarityIds = this.dadosForm.raridade;
      }

      return filtro;
    }
    private getObjetoFiltrosTeste(e: JQueryEventObject): IFiltro {
      var filtro: IFiltro = {
        start: 0,
        num: 21,
        type: "player",
        maxb: 200
      }

      return filtro;
    }


    private getObjetoFiltrosConsumiveis(e: JQueryEventObject): IFiltro {
      this.ajax = new App.Ajax();
      this.dadosForm = this.ajax.convertFormToJSON($(e.target));
      App.SniperExtensao.maxbInicial = this.dadosForm.hasOwnProperty("max") && App.Util.ehVariavelValidaNaoVazia(this.dadosForm.max) ? this.dadosForm.max : 200;

      var filtro: IFiltroConsumivel = {
        num: 21,
        start: 0,
        type: this.typeFiltroConsumivelComissaoItensClube
      }

      if (this.dadosForm.hasOwnProperty("tipo") && this.dadosForm.tipo) {
        filtro.type = this.dadosForm.tipo;
      }
      if (this.dadosForm.hasOwnProperty("categoria") && this.dadosForm.categoria && !this.dadosForm.hasOwnProperty("tipo")) {
        filtro.cat = this.dadosForm.categoria;
        if (this.dadosForm.categoria == "position" && this.dadosForm.troca_posicao != "") {
          filtro.pos = this.dadosForm.troca_posicao;
        }
      }

      if (this.dadosForm.hasOwnProperty("pais") && this.dadosForm.pais) {
        filtro.nat = this.dadosForm.pais;
      }

      if (this.dadosForm.hasOwnProperty("liga") && this.dadosForm.liga) {
        filtro.leag = this.dadosForm.liga;
      }

      if (this.dadosForm.hasOwnProperty("qualidade") && this.dadosForm.qualidade) {
        filtro.lev = this.dadosForm.qualidade;
      }
      if (this.dadosForm.hasOwnProperty("estilo") && this.dadosForm.estilo) {
        filtro.playStyle = this.dadosForm.estilo;
      }
      if (this.dadosForm.hasOwnProperty("definitionId") && this.dadosForm.definitionId) {
        filtro.definitionId = this.dadosForm.definitionId;
      }

      //            filtro.micr = App.SniperExtensao.valorMinimo;

      if (this.dadosForm.hasOwnProperty("min") && this.dadosForm.min) {
        filtro.minb = this.dadosForm.min;
      }

      filtro.maxb = App.SniperExtensao.maxbInicial;

      return filtro;
    }

    private getObjetoFiltroTransferenciaCoins(item: any): IFiltro {
      this.ajax = new App.Ajax();

      let filtro: IFiltro = {
        start: 0,
        num: 21,
        type: "player",
        maskedDefId: item.assetID,
        // pos: item.position,
        micr: item.startPrice,
        //macr: App.Util.incrementarValorDeFiltro(item.startPrice),
        minb: App.Util.decrementarValorDeFiltro(item.hasOwnProperty('coinAmount') ? item.coinAmount : item.buyNowPrice),
        maxb: item.hasOwnProperty('coinAmount') ? item.coinAmount : item.buyNowPrice,
      }


      return filtro;
    }
    private getObjetoFiltroTransferenciaCoinsTeste(item: IItemTransferenciaCoins): IFiltro {
      this.ajax = new App.Ajax();

      let filtro: IFiltro = {
        start: 0,
        num: 21,
        type: "player",
        maskedDefId: 230666, // gabriel Jesus
        // pos: item.position,
        micr: 61000,
        macr: 61500,
        maxb: 62500
      }


      return filtro;
    }

    private finalizarListagemNaVendaAutomatica(venda: any, indexVenda: any) {
      App.SniperExtensao.arrayItensVendaAutomatica.splice(indexVenda, 1);
      App.SniperExtensao.salvarLogColocouaVenda($("#espacoLogs"), venda, this.getVenda());
    }
    private processarMovimentoDeLista(quantidadeMovimentada: number) {
      var i = 0;
      if (quantidadeMovimentada) {
        $("#espacoLogs").prepend(App.SniperExtensao.getConteudoLogMovidoParaTransferencia(quantidadeMovimentada));
      }
    }

    private processarTentativa(e: JQueryEventObject, teste: boolean = false): any {
      if (!this.temEspacoDisponivelNasListasDaEa()) {
        $("#espacoLogs").prepend(App.SniperExtensao.getConteudoLogSemEspacoNasListas());
        this.pararTudo();
        return;
      }

      //            this.incrementarTentativa();

      /**
       * Se tiver resolvendo Captcha
       */
      if (App.SniperExtensao.resolvendoCaptcha || App.SniperExtensao.recarregandoWebApp) {
        return;
      }

      /**
       * Se ainda tiver na tentativa anterior
       */
      if (App.SniperExtensao.tentando) {
        App.SniperExtensao.tentando = false;
        return;
      }

      /**
       * Se é pra descançar após uma compra
       */
      if (App.SniperExtensao.descansoDeCompra > 0) {
        // console.log("DESCANSANDO...")
        App.SniperExtensao.descansoDeCompra--;
        return;
      }


      // Snipando pela extensão
      App.SniperExtensao.tentando = true;
      var rand = Math.floor(Math.random() * (0 - 3000 + 1) + 3000);
      // console.log("FILTRO", this.objFiltro)
      setTimeout(() => {
        chrome.runtime.sendMessage(this.idExtensao, {
          evento: "spr",
          filtro: this.objFiltro,
          sniperPorLucroVariarAbaixo: this.ehSniperPorLucro ? parseInt(App.SniperExtensao.elFormCompra.find('input[name=lucro_variar_abaixo]').val()) : 0,
          sniperPorLucro: this.ehSniperPorLucro ? parseInt(App.SniperExtensao.elFormCompra.find('input[name=lucro]').val()) : 0,
          sniperPorLucroVariarAcima: this.ehSniperPorLucro ? parseInt(App.SniperExtensao.elFormCompra.find('input[name=lucro_variar_acima]').val()) : 0,
          configuracoes: this.getConfiguracoes(),
          venda: this.getVenda(),
          quantidadeLimiteCompraAtual: (App.SniperExtensao.quantidadeMaximaCompras - this.getQuantidadeCompras()),
          tradeId: null,
          filtroPagina: this.filtroPagina,
          modoCompraElenco: App.SniperExtensao.ehModoCompraDme,
          modoHumano: this.modoHumanoAtivo(),
          tempoMaximoParaLance: App.SniperExtensao.getTempoExpiracaoLance(),
          lanceDinamico: App.SniperExtensao.ehLanceDinamico,
          descansoLance: this.obterTempoDescansoAleatorioPorOpcaoEscolhida(App.SniperExtensao.getTempoIntervaloEntreTentativas())
        },
          (resultado: any) => {
            if (App.SniperExtensao.itensExpiradosOuComprados.length >= 10) {
              App.SniperExtensao.itensExpiradosOuComprados = [];
            }
            //Agora esperamos Uma resposta do WebApp
          });
      }, rand);
    }

    private salvarSnipada(resultado: any) {
      var dados: any = {
        id: App.Util.usuario.id,
        filtro: this.objFiltro,
        configuracoes: App.SniperExtensao.configuracoesAtuais,
        modo_humano: this.modoHumanoAtivo(),
        manter_no_cemiterio: this.modoManterNoCemiterio(),
        lance_infinito: App.Util.usuario.configuracaoConta.lance_infinito,
        modo_potente: App.Util.usuario.configuracaoConta.modo_potente,
        asset_id: resultado.item.itemData.assetId,
        resource_id: resultado.item.itemData.resourceId,
        nation_id: resultado.item.itemData.nation,
        team_id: resultado.item.itemData.hasOwnProperty('teamid') ? resultado.item.itemData.teamid : resultado.item.itemData.teamId,
        league_id: resultado.item.itemData.leagueId,
        rating: resultado.item.itemData.rating,
        rareflag: resultado.item.itemData.rareflag,
        type: resultado.item.itemData.itemType,
        name: resultado.item.itemData.name,
        valor: resultado.item.buyNowPrice,
        conta_id: App.SniperExtensao.dadosContaEa.id,
        conta_ptf: App.SniperExtensao.dadosContaEa.ptf,
        status: true,
        versao: 1,
        created_at: new Date().toISOString().slice(0, 19).replace('T', ' ')
      };
      this.snipadas.push(dados);
      if (this.snipadas.length >= App.Util.config.quantidadeSnipadasAntesSalvar || !App.SniperExtensao.sniperAtivo) {
        this.ajax.postAcaoSemResposta(App.Util.config.urlSalvarSniper, { array_snipadas: this.snipadas });
        this.snipadas = [];
        try {
          this.atualizarBanometro();
        } catch (e) {
          // console.log("Erro ao atualizar Banômetro", e);
        }
      }

      this.salvarEstatisticasDaConta()
    }

    private atualizarDadosAposCompraModoCompraDme(resultado: any) {
      if (App.SniperExtensao.ehModoCompraDme) {
        App.SniperExtensao.finalizarTentativasSniper();
        this.tentativaAtual = 0;
        App.SniperExtensao.totalGastoCompraDme += parseInt(resultado.item.buyNowPrice);
        this.dadosForm.jogador = App.Util.arrayRemove(this.dadosForm.jogador, resultado.item.itemData.assetId);
        $("#jogador option[value='" + resultado.item.itemData.assetId + "']").remove();
        this.addInfoPrecoSelectJogadores(App.Util.elencoDme.elenco);
        var indexItemElencoDme = App.Util.getIndiceArrayByAssetId(App.Util.elencoDme.elenco, resultado.item.itemData.assetId);
        this.objFiltro.maskedDefId = this.dadosForm.jogador[0];
        if ($("#jogador").select2('data').length <= 0) {
          $("#cardLoadDetalhesJogador").hide()
          this.pararTudo();
          setTimeout(() => {
            if (App.Util.elencoDme.idCategoriaSbc) {
              this.montarElencoDme();
            }
            $("#espacoLogs").prepend(App.SniperExtensao.getConteudoLogTerminouComprasItensDme());
          }, 2000);
        } else {
          /**
           * Aqui é onde o descanso funciona
           */
          // console.log("TENTATIVAS FINALIZADAS MODO DME")
          this.iniciarDescansoSniperProgramado(App.SniperExtensao.ultimoEventSubmit, 5000);
        }
      }
    }
    private getVenda(): IVenda {
      if (!App.SniperExtensao.vendaAutomaticaAtiva) {
        return;
      }
      var valorLanceMinimo = App.Util.obterInteiroDaString(this.elCampoValorLanceMinimoVenda.val());
      var valorVenda = App.Util.obterInteiroDaString(this.elCampoValorVenda.val());
      valorLanceMinimo = $.isNumeric(valorLanceMinimo) ? valorLanceMinimo : null;
      valorVenda = $.isNumeric(valorVenda) ? valorVenda : null;

      return {
        duracao: 3600,
        valorLanceMinimo: valorLanceMinimo,
        valorVenda: valorVenda,
        precoFutbin: $("#ativarPrecoVendaFutbin").is(':checked'),
        porcentagemMaisBarato: App.Util.obterInteiroDaString($("#inputSlideporcentagemVendaMaisBarato").val()),
        precoInteligente: $("#ativarPrecoVendaInteligente").is(':checked') ? App.Util.obterInteiroDaString($("#inputSlidePrecoInteligente").val()) : null
      };
    }

    private getObjListagemContexto(e: JQueryEventObject, tipo: number = null): IContextoListagem {
      let fTipo: number = tipo ? tipo : $(e.currentTarget).parents('.contexto-listagem').data('id-listagem');
      switch (fTipo) {
        case 1:
          return { el: $("#modalListaLance"), elTabela: $('#tabelaItensListagemLance'), tipo: fTipo, dataTable: App.SniperExtensao.elementoListagemLanceContexto.dataTable, arrayListagem: App.SniperExtensao.arrayListaLance };
        case 2:
          return { el: $("#modalListaTransferencia"), elTabela: $('#tabelaItensListagemTransferencia'), tipo: fTipo, dataTable: App.SniperExtensao.elementoListagemTransferenciaContexto.dataTable, arrayListagem: App.SniperExtensao.arrayListaTransferencia };
        case 3:
          return { el: $("#modalListaClube"), elTabela: $('#tabelaItensListagemClube'), tipo: fTipo, dataTable: App.SniperExtensao.elementoListagemClubeContexto.dataTable, arrayListagem: App.SniperExtensao.arrayListaClube };
      }
    }

    private getVendaLista(elementoListagemContexto: JQuery): IVenda {

      var valorLanceMinimo = App.Util.obterInteiroDaString(elementoListagemContexto.find('input[name=valor_lance_minimo_lista]').val());
      var valorVenda = App.Util.obterInteiroDaString(elementoListagemContexto.find('input[name=valor_venda_lista]').val());
      valorLanceMinimo = $.isNumeric(valorLanceMinimo) ? valorLanceMinimo : null;
      valorVenda = $.isNumeric(valorVenda) ? valorVenda : null;

      return {
        duracao: 3600,
        valorLanceMinimo: valorLanceMinimo,
        valorVenda: valorVenda,
        precoFutbin: elementoListagemContexto.find(".ativar-preco-venda-futbin-lista").is(':checked'),
        porcentagemMaisBarato: App.Util.obterInteiroDaString(elementoListagemContexto.find("input[name=porcentagem_venda_mais_barato_lista]").val()),
        precoInteligente: elementoListagemContexto.find(".ativar-preco-venda-ea").is(':checked') ? 10 : null, // quantidade de tentativas maxima busca preco
        forcarVendaNoLance: true,
        vendaAutomatica: false,
        ignorarPosicao: false
      };
    }

    private getItensListagemVenda(dataTable: any): IItemListagem[] {
      let itensSelecionados: IItemListagem[] = dataTable.rows('.selected').data().toArray();
      return itensSelecionados;
    }

    private aoIncrementarValor(e: JQueryEventObject) {
      var campoValor = $(e.currentTarget).parents('.input-group').find('input');
      var campoValorMin = $(e.currentTarget).parents('.input-group').find('input').data('min')
      if (App.Util.ehCampoTextoVazio(campoValor)) {
        campoValor.val(campoValorMin).trigger('input').trigger('focusout').trigger('change');
        return;
      }

      var valor = App.Util.obterInteiroDaString(campoValor.val());
      if (!$.isNumeric(valor)) {
        return;
      }
      var campoValorIncrementado = App.Util.incrementarValorDeFiltro(valor);
      campoValor.val(campoValorIncrementado).trigger('input').trigger('focusout').trigger('change');
    }

    private aoDecrementarValor(e: JQueryEventObject) {
      var campoValor = $(e.currentTarget).parents('.input-group').find('input');
      var campoValorMin = $(e.currentTarget).parents('.input-group').find('input').data('min');
      var valor = App.Util.obterInteiroDaString(campoValor.val());
      if (!$.isNumeric(valor)) {
        return;
      }

      if (valor <= campoValorMin) {
        campoValor.val('').trigger('input').trigger('focusout').trigger('change');;
        return;
      }

      var campoValorDecrementado = App.Util.decrementarValorDeFiltro(valor);
      campoValor.val(campoValorDecrementado).trigger('input').trigger('focusout').trigger('change');;
    }

    private registrarEvento(id: number, nome: string) {
      // Snipando pela extensão
      chrome.runtime.sendMessage(this.idExtensao, { evento: id, nome: nome },
        (resultado: any) => {
        });
    }

    private salvarContaEa() {
      var obj: any = App.SniperExtensao.dadosContaEa;
      obj.clube = App.SniperExtensao.dadosContaEa.clube;
      this.ajax.postAcaoSemResposta(App.Util.config.urlSalvarContaEa, obj);
    }

    /**
     * Identifica se o usuario está com a aba da pagina visivel ou não
     */
    private handleVisibilityChange() {
      var hidden: string, visibilityState: string, visibilityChange: string;

      if (typeof document.hidden !== "undefined") {
        hidden = "hidden", visibilityChange = "visibilitychange", visibilityState = "visibilityState";
      }
      else if (typeof document.mozHidden !== "undefined") {
        hidden = "mozHidden", visibilityChange = "mozvisibilitychange", visibilityState = "mozVisibilityState";
      }
      else if (typeof document.msHidden !== "undefined") {
        hidden = "msHidden", visibilityChange = "msvisibilitychange", visibilityState = "msVisibilityState";
      }
      else if (typeof document.webkitHidden !== "undefined") {
        hidden = "webkitHidden", visibilityChange = "webkitvisibilitychange", visibilityState = "webkitVisibilityState";
      }

      document.addEventListener(visibilityChange, () => {
        switch (document.visibilityState) {
          case "visible":
            this.registrarEvento(App.SniperExtensao.eventoAppContextoStart, 'view_context_app');
            break;
          case "hidden":
            this.registrarEvento(App.SniperExtensao.eventoAppContextoStop, 'view_context_app');
            break;
        }
      });
    }

    public static registrarDadosDaContaEa() {
      $('#modalConfigExtensao').find('input[name=id_conta_ea]').val(App.SniperExtensao.dadosContaEa.id)
      $('#imgEscudoClube').attr('src', (App.SniperExtensao.dadosContaEa.url_img_clube ? App.SniperExtensao.dadosContaEa.url_img_clube.toString() : "/img/escudo-default.png"));
      $('#infoClube').html(App.SniperExtensao.dadosContaEa.clube);
      $('#infoCoins, .info-coins').html(App.SniperExtensao.dadosContaEa.coins ? App.SniperExtensao.dadosContaEa.coins.toLocaleString('pt-BR') : 0);
      App.SniperExtensao.capacidadeLimiteListaDeObservacao = 100;
      App.SniperExtensao.capacidadeListaDeObservacao = App.Util.usuario.configuracaoConta.manter_no_cemiterio ? App.SniperExtensao.capacidadeLimiteListaDeObservacao : App.SniperExtensao.capacidadeHumanaListaDeObservacao;
      //            App.SniperExtensao.quantidadeAtualListaDeTransferencia = App.SniperExtensao.dadosListaTransferenciaEa.auctionInfo.length;
      App.SniperExtensao.quantidadeAtualListaDeTransferencia = 0;
      //            App.SniperExtensao.quantidadeAtualListaDeObservacao = App.SniperExtensao.dadosUserInfoEa.usermassinfo.purchasedItems.itemData.length;
      App.SniperExtensao.quantidadeAtualListaDeObservacao = 0;
      App.SniperExtensao.capacidadeListaDeTransferencia = 100;
      $('#infoListaObservacao, .info-lista-observacao').html(App.SniperExtensao.quantidadeAtualListaDeObservacao + "/" + App.SniperExtensao.capacidadeListaDeObservacao);
      $('#infoListaTransferencia, .info-lista-transferencia').html(App.SniperExtensao.quantidadeAtualListaDeTransferencia + "/" + App.SniperExtensao.capacidadeListaDeTransferencia);
      App.SniperExtensao.quantidadeDisponivelListaDeObservacao = App.SniperExtensao.capacidadeListaDeObservacao - App.SniperExtensao.quantidadeAtualListaDeObservacao;
      App.SniperExtensao.quantidadeDisponivelListaDeTransferencia = App.SniperExtensao.capacidadeListaDeTransferencia - App.SniperExtensao.quantidadeAtualListaDeTransferencia;
      App.SniperExtensao.keyStorageListagemClube = App.SniperExtensao.keyStorageListagemClube + App.SniperExtensao.dadosContaEa.id;
    }

    private incrementarQuantidadeDisponivelListaDeObservacao() {
      if (App.SniperExtensao.quantidadeDisponivelListaDeObservacao >= App.SniperExtensao.capacidadeListaDeObservacao) {
        return;
      }

      App.SniperExtensao.quantidadeDisponivelListaDeObservacao++;
      $('#infoListaObservacao, .info-lista-observacao').html((App.SniperExtensao.capacidadeListaDeObservacao - App.SniperExtensao.quantidadeDisponivelListaDeObservacao).toString() + "/" + App.SniperExtensao.capacidadeListaDeObservacao);
    }
    private decrementarQuantidadeDisponivelListaDeObservacao() {
      if (App.SniperExtensao.quantidadeDisponivelListaDeObservacao == 0) {
        return;
      }

      App.SniperExtensao.quantidadeDisponivelListaDeObservacao--;
      $('#infoListaObservacao, .info-lista-observacao').html((App.SniperExtensao.capacidadeListaDeObservacao - App.SniperExtensao.quantidadeDisponivelListaDeObservacao).toString() + "/" + App.SniperExtensao.capacidadeListaDeObservacao);
    }
    private incrementarQuantidadeDisponivelListaDeTransferencia() {
      App.SniperExtensao.quantidadeDisponivelListaDeTransferencia++;
      $('#infoListaTransferencia, .info-lista-transferencia').html((App.SniperExtensao.capacidadeListaDeTransferencia - App.SniperExtensao.quantidadeDisponivelListaDeTransferencia).toString() + "/" + App.SniperExtensao.capacidadeListaDeTransferencia);
    }
    private decrementarQuantidadeDisponivelListaDeTransferencia() {
      App.SniperExtensao.quantidadeDisponivelListaDeTransferencia--;
      var quantidadeListaTransf = (App.SniperExtensao.capacidadeListaDeTransferencia - App.SniperExtensao.quantidadeDisponivelListaDeTransferencia);
      $('#infoListaTransferencia, .info-lista-transferencia').html((quantidadeListaTransf > 100 ? "100" : quantidadeListaTransf.toString()) + "/" + App.SniperExtensao.capacidadeListaDeTransferencia);
    }

    private inicializarQuantidadeCompraDiaria() {
      $('#infoComprasDia, .info-compras-dia').html(App.Util.usuario.quantidadeComprasDoDia.toString());
    }
    private incrementarQuantidadeCompraDiaria() {
      App.Util.usuario.quantidadeComprasDoDia++;
      $('#infoComprasDia, .info-compras-dia').html(App.Util.usuario.quantidadeComprasDoDia.toString());
      if (!App.Util.config.naoValidarPlano && App.Util.usuario.quantidadeComprasDoDia >= App.Util.usuario.plano.configuracoes.quantidadeLimiteComprasDiarias) {
        this.pararTudo();
        $("#espacoLogs").prepend(App.SniperExtensao.getConteudoLogQuantidadeComprasDiariasAtingida());
      }
    }

    private modoHumanoAtivo(): boolean {
      return App.Util.usuario.configuracao.modo_humano;
    }


    private modoManterNoCemiterio(): boolean {
      return App.Util.usuario.configuracaoConta.manter_no_cemiterio;
    }
    private modoLanceInfinito(): boolean {
      return App.Util.usuario.configuracaoConta.lance_infinito;
    }

    private uso3HorasHabilitado(): boolean {
      return App.Util.usuario.configuracao.uso_3_horas;
    }

    private aoClicarLinkFiltrosIndisponiveis() {
      this.exibirMensagemAlertaSwal("Serviço indisponível", "Os serviços salvar ou aplicar filtro não estão disponíveis no <b>" + this.elSniperPage.data('nomePlano') + "</b>, Esse serviço está disponível para assinantes do <b>Plano Prata ou Ouro</b>.", "warning", "Ver Planos", "Fechar", '#2dce89', true, this.elSniperPage.data('urlPlanos'));
    }

    public static exibirLoadingSniperApp(iconeLoading: string = null, atualizarIconeSomente: boolean = false, textoInfo: string = null) {
      if (iconeLoading) {
        $("#spinnerSniper .cronometro").hide()
        $('.tentativas').html(iconeLoading);
      } else {
        $("#spinnerSniper .cronometro").show()
      }
      if (textoInfo) {
        $('.info-text-loading').html(textoInfo)
        $(".info-text-loading").show()
      } else {
        $('.info-text-loading').html('')
        $(".info-text-loading").hide()
      }

      if (!atualizarIconeSomente) {
        App.SniperExtensao.elSpinner.show();
      }
    }

    public static ocultarLoadingSniperApp() {
      App.SniperExtensao.elSpinner.hide();
    }

    public static loadingSniperAppVisivel() {
      return App.SniperExtensao.elSpinner.is(":visible");
    }

    public static cronometroVisivel() {
      return $('.cronometro').is(":visible");
    }

    public static ehLoadListaVisivel() {
      return $('.loading-processamento-sniper').is(":visible");
    }

    private revincularContaEa(contaEa: any) {
      this.ajax = new App.Ajax();
      this.ajax.postAcaoSemCabecalhoGlobal(App.Util.config.urlRevincularConta, { id: contaEa.id });
    }

    private atualizarDadosWebApp(request: any) {
      App.SniperExtensao.comunicacaoEstabelecidaComWebApp = true;
      // Verificar aqui navamente se o cara trocou de conta, não podemos permitir com sniper funcionando
      if (App.SniperExtensao.dadosContaEa && request.hasOwnProperty('tipo') && request.tipo == "completouauthconta" && request.conta.id != App.SniperExtensao.dadosContaEa.id) {
        App.SniperExtensao.dadosContaEa.id = request.conta.id;
        $("#infoClube").html(request.conta.clube);
        this.pararCompra(false);
        this.validarPlano(null);
      }

      switch (request.tipo) {
        case "usermassinfo":
          this.atualizarListaObservacao(request.dados);
          break;
        case "item":
          if (App.Util.isset(request.dados.itemData) && $.isArray(request.dados.itemData)) {
            $.each(request.dados.itemData, (posicao, item) => {
              if (item.pile == "trade") {
                this.decrementarQuantidadeDisponivelListaDeTransferencia();
                if (request.listaObservacao) {
                  this.incrementarQuantidadeDisponivelListaDeObservacao();
                }
              }
            });
          }
          break;
        case "removevendido":
          this.incrementarQuantidadeDisponivelListaDeTransferencia();
          break;
        case "credits":
          this.atualizarCreditos(request.dados);
          break;
        case "carregamentocompleto":
        case "completouauthconta":
          console.log("Comunicação Estabelecida com WebApp, carregamento");
          this.continuarAposCaptcha();
          this.continuarAposCarregamentoWebApp();
          if (request.hasOwnProperty('conta') && request.conta) {
            App.SniperExtensao.dadosContaEa = request.conta;
            App.SniperExtensao.dadosContaEa.ptf = App.Util.getNomePlataforma(App.SniperExtensao.dadosContaEa.ptf);
            this.inicializarArrayListaClube();
            this.atualizarExibicaoClubeAtual();
            this.atualizarConfiguracoesDeConta()
            if (App.SniperExtensao.ehVendaCoins) {
              this.obterContasEa(App.SniperExtensao.dadosContaEa, this.calcularCoinsTotais);
            }
          }

          if (request) {
            this.tratarRespostaAtualizarListagens(request);
            this.tratarRespostPartidas(request);
            this.tratarDadosExportados(request);
          }

          break;
        case "errosincronizacao":
          if (App.SniperExtensao.sniperAtivo && !App.SniperExtensao.resolvendoCaptcha && !App.SniperExtensao.recarregandoWebApp) {
            this.pararTudo();
            this.exibirLogErroProblemaSincronizacao();
          }
          break;
        case "lucroupdate":
          if (request.creditos && $.isNumeric(request.creditos)) {
            this.updateLucro(request.creditos)
          }
          break;
        case "resposta":
          this.receberResposta(request.resposta);
          break;
        case "recarregandowebapp":
          if (App.SniperExtensao.sniperAtivo && !App.SniperExtensao.recarregandoWebApp) {
            App.SniperExtensao.recarregandoWebApp = true
          }
          break;
        case "autodme":
          if (this.autoDme && typeof this.autoDme.processarMensagensAutoDme === "function") {
            this.autoDme.processarMensagensAutoDme(request.resposta);
          } else {
            console.warn("Mensagem AutoDME ignorada: componente AutoDme não inicializado.", request.resposta);
          }
          break;
      }
    }

    private corrigirDuplicacaoWebApp() {
      try {
        chrome.runtime.sendMessage(this.idExtensao, { evento: "exdupwpp" }, (resp: any) => { });
      } catch (e) {
      }

    }
    private resolvedorCaptchaAtivo(): boolean {
      try {
        App.Util.usuario.configuracaoConta.anticaptcha = this.objConfiguracoesConta.getObjDadosSolucaoAntiCaptcha()
        return (App.Util.usuario.configuracaoConta.resolver_captcha_automaticamente && App.Util.usuario.configuracaoConta.anticaptcha && !App.Util.empty(App.Util.usuario.configuracaoConta.anticaptcha.api_key));
      } catch (e) {
        console.log("ERROR::", e)
        return false;
      }
    }

    private exibirAlertaErroConexao() {
      if (App.SniperExtensao.recarregandoWebApp) {
        return
      }

      this.alertaErroConexao = true;
      App.SniperExtensao.recarregandoWebApp = true
      App.SniperExtensao.runAudio(5);
      this.exibirMensagemAlertaSwal("Erro de Conexão!", "Ocorreu um erro de conexão com internet no seu WebApp, estamos tentando reestabelecer a conexão recarregando o WebApp...", "warning", "OK", "Fechar", "#2dce89", false);
      this.exibirLog("danger", "Erro de Conexão", "Ocorreu um erro de conexão com internet no seu WebApp, ele será recarregado, é importante manter visível a tela do WebApp em primeiro plano para o carregamento completo", "log-webapp-erro-conexao");
      setTimeout(() => {
        this.alterarParaAbaWebApp()
      }, 4000);

      App.SniperExtensao.timeoutTempoEsperaRecarregandoWebApp = setTimeout(() => {
        if (App.SniperExtensao.recarregandoWebApp) {
          this.exibirMensagemAlertaSwal("Não Foi Possível Recarregar WebApp!", "Não foi possível recarregar o WebApp automaticamente para continuidade da tarefa atual.", "warning", "OK", "Fechar", "#2dce89", false);
          this.pararTudo()
          App.SniperExtensao.recarregandoWebApp = false
        }
      }, 150000);
    }

    private ocultarAlertaErroConexao() {
      if (this.alertaErroConexao) {
        swal.close();
        this.alertaErroConexao = false;
      }
    }

    private receberResposta(resposta: IRespostaAcaoInternaWebApp) {
      // console.log("RECEBIMENTO::", resposta.tipo, resposta)
      switch (resposta.codigo) {
        case 458:
          var resolvedorCaptchaAtivado = this.resolvedorCaptchaAtivo();

          //Se Já Estiver na Tela de captcha
          if (resposta.hasOwnProperty('ehTelaDeCaptcha') && resposta.ehTelaDeCaptcha) {
            App.SniperExtensao.runAudio(3);
            $("#espacoLogs").prepend(App.SniperExtensao.getConteudoLogCaptcha());
          } else {
            //Se for um pedido de captcha da EA
            this.informarSobreCaptcha();
            if (this.testeAtivo) {
              App.SniperExtensao.testeSniper.captcha = true;
            } else {
              //Se resolvedor de captcha automatico
              if (resolvedorCaptchaAtivado) {
                this.resolverCaptcha();
              } else {
                this.fecharWebApp();
              }
            }
          }
          if (!resolvedorCaptchaAtivado) {
            this.pararTudo();
          }
          return;
        case 1000:
          this.exibirAlertaErroConexao()
          return
        case 426:
          if (resposta.tipo != "lance") {
            this.exibirLog("danger", "Softban", "Aparentemente seu WebApp está com um banimento temporário, aguarde a EA liberar para poder continuar usando o sistema.");
            this.pararTudo();
          }

          if (resposta.hasOwnProperty('fecharWebApp') && resposta.fecharWebApp) {
            this.fecharWebApp();
          }
          break
        case 401:
          //Se erro conexao e mandar fechar webapp
          if (resposta.hasOwnProperty('fecharWebApp') && resposta.fecharWebApp) {
            this.fecharWebApp();
            $("#espacoLogs").prepend(App.SniperExtensao.getConteudoLogBloqueado());
            this.pararTudo();
          }

          if (resposta.hasOwnProperty('ehTelaDeCaptcha') && resposta.ehTelaDeCaptcha) {
            App.SniperExtensao.runAudio(3);
            $("#espacoLogs").prepend(App.SniperExtensao.getConteudoLogCaptcha());
          }
      }

      switch (resposta.tipo) {
        case "busca":
          this.incrementarTentativa();
          //Se buscou corretamente
          if (resposta.status) {
            App.SniperExtensao.errorsSequencia = 0;
          } else {
            App.SniperExtensao.errorsSequencia++;
            if (!this.testeAtivo && App.SniperExtensao.errorsSequencia <= 3 && !App.Util.inArray(resposta.codigo, [401, 403, 458])) {
              return;
            }
            App.SniperExtensao.processarTrava();
            if (!this.testeAtivo) {
              App.SniperExtensao.exibirMensagemSnipeTravado();
            }

            this.pararTudo();
            if (this.testeAtivo && App.Util.inArray(resposta.codigo, [401, 403])) {
              App.SniperExtensao.testeSniper.naoAutenticado = true;
            }

            if (this.testeAtivo && App.Util.inArray(resposta.codigo, [512, 521, 426, 429])) {
              App.SniperExtensao.testeSniper.softbanBusca = true;
            }
          }
          if (this.testeAtivo) {
            this.testeAtivo = false;
            this.continuarTeste();
          }
          break;
        case "lance":
          //Se buscou corretamente
          if (resposta.status) {
            if (App.Util.inArray(resposta.codigo, [512, 521, 426, 429])) {
              this.exibirLog("danger", "Softban Lance", "Aparentemente seus lances estão bloqueados temporariamente nos servidores da EA, aguarde a EA liberar para pode dar mais lances.");
              this.pararTudo();
            }
            App.SniperExtensao.errorsSequencia = 0;
          } else {
            if (resposta.hasOwnProperty('parar') && resposta.parar) {
              this.pararTudo();
            }

            App.SniperExtensao.errorsSequencia++;
            if (!this.testeAtivo && App.SniperExtensao.errorsSequencia <= 10 && !App.Util.inArray(resposta.codigo, [401, 403, 458])) {
              return;
            }

            App.SniperExtensao.processarTrava();
            if (!this.testeAtivo) {
              App.SniperExtensao.exibirMensagemSnipeTravado();
            }

            this.pararTudo();
            if (this.testeAtivo && App.Util.inArray(resposta.codigo, [401, 403])) {
              App.SniperExtensao.testeSniper.naoAutenticado = true;
            }

            if (this.testeAtivo && App.Util.inArray(resposta.codigo, [512, 521, 426, 429])) {
              App.SniperExtensao.testeSniper.softbanBusca = true;
            }
          }
          if (this.testeAtivo) {
            this.testeAtivo = false;
            this.continuarTeste();
          }

          if (resposta.hasOwnProperty('mensagem')) {
            console.log("MENSAGEM_LANCE", resposta.mensagem, resposta, this.quantidadeLancesganhosAtuais)
            switch (resposta.mensagem) {
              case '1':
                if (this.quantidadeLancesganhosAtuais === null) {
                  this.quantidadeLancesganhosAtuais = resposta.quantidade_itens_ganhos_lista_observacao_lance;
                  if (resposta.quantidade_itens_ganhos_lista_observacao_lance > 0) {
                    this.exibirLog("success", "Lances ganhos", "Nesse momento você tem <b>" + resposta.quantidade_itens_ganhos_lista_observacao_lance.toString() + " item(s) ganho(s)</b> na lista de lance");
                  }
                }

                if (this.quantidadeLancesganhosAtuais != resposta.quantidade_itens_ganhos_lista_observacao_lance) {
                  if (this.quantidadeLancesganhosAtuais && resposta.quantidade_itens_ganhos_lista_observacao_lance > this.quantidadeLancesganhosAtuais) {
                    let quantidadeNovosItemsGanhos = resposta.quantidade_itens_ganhos_lista_observacao_lance - this.quantidadeLancesganhosAtuais;
                    this.addQuantidadeComprasLance(quantidadeNovosItemsGanhos);
                    this.exibirLog("success", "Lances ganhos", "<b>" + quantidadeNovosItemsGanhos.toString() + " novo(s) item(s) ganho(s)</b>, total de <b>" + resposta.quantidade_itens_ganhos_lista_observacao_lance + " item(s) ganho(s)</b>");
                    if (quantidadeNovosItemsGanhos >= App.SniperExtensao.quantidadeMaximaCompras) {
                      $("#espacoLogs").prepend(App.SniperExtensao.getConteudoLogLimiteCompraAtingido(App.SniperExtensao.quantidadeMaximaCompras));
                    }
                  }
                }

                this.exibirLog("danger", "Lista cheia", "Capacidade da Lista de lances foi alcançada");
                this.pararTudo();
                break;
              case '2':
                if (this.quantidadeLancesganhosAtuais == null) {
                  this.quantidadeLancesganhosAtuais = resposta.quantidade_itens_ganhos_lista_observacao_lance;
                  if (resposta.quantidade_itens_ganhos_lista_observacao_lance > 0) {
                    this.exibirLog("success", "Lances ganhos", "Nesse momento você tem <b>" + resposta.quantidade_itens_ganhos_lista_observacao_lance.toString() + " item(s) ganho(s)</b> na lista de lance");
                  }
                }


                if (this.quantidadeLancesganhosAtuais != resposta.quantidade_itens_ganhos_lista_observacao_lance) {
                  if (this.quantidadeLancesganhosAtuais != null && resposta.quantidade_itens_ganhos_lista_observacao_lance > this.quantidadeLancesganhosAtuais) {
                    let quantidadeNovosItemsGanhos = resposta.quantidade_itens_ganhos_lista_observacao_lance - this.quantidadeLancesganhosAtuais;
                    this.addQuantidadeComprasLance(quantidadeNovosItemsGanhos);
                    this.exibirLog("success", "Lances ganhos", "<b>" + quantidadeNovosItemsGanhos.toString() + " novo(s) item(s) ganho(s)</b>, total de <b>" + resposta.quantidade_itens_ganhos_lista_observacao_lance + " item(s) ganho(s)</b>");
                    if (quantidadeNovosItemsGanhos >= App.SniperExtensao.quantidadeMaximaCompras) {
                      $("#espacoLogs").prepend(App.SniperExtensao.getConteudoLogLimiteCompraAtingido(App.SniperExtensao.quantidadeMaximaCompras));
                      this.pararTudo();
                    }
                  }
                }
                break;
              case '3':
                this.exibirLog("info badge-lista-lance-liberada ", "Liberando Lista", "<b>item(s) perdidos</b> foram removidos da lista de lance", "liberar-lista-lance", true);
                break;
              case '4':
                this.incrementarTentativa();
                if (resposta.status) {
                  $('.quantidade-lances').html((App.Util.obterInteiroDaString($('.quantidade-lances').html()) + 1).toString());
                }
                break;
            }
          }
          break;
        case "compra":
          if (resposta.status) {
            if (!this.testeAtivo) {
              try {
                this.salvarSnipada(resposta);
              }
              catch (err) {
              }
            }
            var stepDesansoCompra = this.modoHumanoAtivo() ? 4 : 3;
            App.SniperExtensao.descansoDeCompra = stepDesansoCompra - parseInt((this.getMilesegundos()).toString()[0]);
            this.addQuantidadeCompras(resposta.item);
            this.processarDisponibilidadesDeListas(resposta.quantidade_itens_lista_transferencia, resposta.quantidade_itens_lista_observacao);
            App.SniperExtensao.itensExpiradosOuComprados.push(resposta.item.tradeId);

            if (!this.testeAtivo) {
              //                            this.atualizarListagemClube(resposta.item.itemData);
              this.atualizarDadosAposCompraModoCompraDme(resposta);
            }

            this.atualizarCreditos(resposta);

          } else {
            //Se perder a disputa
            if (resposta.codigo == 461) {
              App.SniperExtensao.errorsCompraSequencia = 0;
              if (!App.Util.inArray(resposta.item.tradeId, App.SniperExtensao.itensExpiradosOuComprados)) {
                App.SniperExtensao.salvarLogDisputaPerdida($("#espacoLogs"), resposta.item);
                App.SniperExtensao.itensExpiradosOuComprados.push(resposta.item.tradeId);
              }
            } else {
              App.SniperExtensao.errorsCompraSequencia++;
              if (!this.testeAtivo && App.SniperExtensao.errorsCompraSequencia <= 3 && !App.Util.inArray(resposta.codigo, [401, 403, 458])) {
                return;
              }

              App.SniperExtensao.processarTrava();
              if (!this.testeAtivo) {
                App.SniperExtensao.exibirMensagemSnipeTravado("Sistema travado por segurança, aparentemente o seu WEB APP está pesquisando jogador mas não consegue comprar, pode ser um bloqueio temporário, verique no seu WEB APP.");
              }
              this.pararTudo();
              if (this.testeAtivo && App.Util.inArray(resposta.codigo, [512, 521, 426, 429])) {
                App.SniperExtensao.testeSniper.softbanCompra = true;
              }
            }

            this.salvarEstatisticasDaConta()
          }
          if (this.testeAtivo) {
            this.testeAtivo = false;
            this.continuarTeste();
          }
          break;
        case "venda":
          //Se buscou corretamente
          if (resposta.status) {
            App.SniperExtensao.errorsSequenciaVenda = 0;
            App.SniperExtensao.salvarLogColocouaVenda($("#espacoLogs"), resposta.item, resposta.venda);
            // CHAMA METODO QUE CALCULA O LUCRO SE A CARTA TIVER SIDO COMPRADA E VENDIDA NO MESMO FILTRO
            if (resposta.item.currentBid) {
              this.calcularLucroFiltroAtual(resposta.item, resposta.venda)
            }
          } else {
            if (resposta.codigo == 473) {
              App.SniperExtensao.errorsSequenciaVenda++;
              this.exibirLog("info", "lista cheia", "Lista de transfêrencia cheia");
            }

            App.SniperExtensao.errorsSequenciaVenda++;
            if (!this.testeAtivo && App.SniperExtensao.errorsSequenciaVenda <= 3 && !App.Util.inArray(resposta.codigo, [401, 403, 458])) {
              return;
            }
            App.SniperExtensao.processarTrava();
            if (!this.testeAtivo) {
              App.SniperExtensao.exibirMensagemSnipeTravado();
            }

            this.pararTudo();
            if (this.testeAtivo && App.Util.inArray(resposta.codigo, [401, 403])) {
              App.SniperExtensao.testeSniper.naoAutenticado = true;
            }

            if (this.testeAtivo && App.Util.inArray(resposta.codigo, [512, 521, 426, 429])) {
              App.SniperExtensao.testeSniper.softbanBusca = true;
            }
          }
          if (this.testeAtivo) {
            this.testeAtivo = false;
            this.continuarTeste();
          }
          break;
        case "movido_transferencia_da_observacao":
          this.exibirLog("info", "Lista Não atribuídos liberada", "<b>" + resposta.item + "</b> Itens enviado para lista de transferência");
          break;
        case "movendo_items":
          this.atualizarIconeLoadingTentativasSniper("fas fa-list", 'Movimentando itens na lista');
          break;
        case "movido_transferencia":
          if (resposta.item.itemData && resposta.item.itemData.hasOwnProperty('itemType') && resposta.item.itemData.itemType != "player") {
            if (resposta.lista == 7) {
              this.exibirLog("info info-enviou-clube", "Enviou para o Clube", "Item enviado para o clube");
            } else {
              this.exibirLog("info", "Enviou para transferência", "Item enviado para transferência");
            }
          } else {
            var player = App.Util.getItemArrayById(App.SniperExtensao.players, resposta.item.itemData.assetId, App.SniperExtensao.objJogadorDefault);
            var nomeJogador = (player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l);
            if (resposta.lista == 5) {
              let infoItemDuplicado = resposta.duplicado ? ", <b>já existe um item igual na sua lista de Clube</b>" : "";
              this.exibirLog("info", "Enviou para transferência", "<b>" + nomeJogador + " (" + resposta.item.itemData.rating + ") </b> enviado para transferência" + infoItemDuplicado);
            }
            if (resposta.lista == 7) {
              this.exibirLog("info info-enviou-clube", "Enviou para o Clube", "<b>" + nomeJogador + " (" + resposta.item.itemData.rating + ") </b> enviado para o clube");
            }
          }
          break;
        case "lista_transferencia_cheia":
          this.exibirLog("danger", "Lista transferência cheia", "Sua Lista de transferência está cheia");
          if (resposta && resposta.hasOwnProperty('parar') && resposta.parar) {
            this.pararTudo();
          }
          break;
        case "lista_nao_atribuidos_cheia":
          this.exibirLog("danger", "Lista não atribuídos cheia", "Lista de itens não atribuídos cheia, atualmente sua capacidade nessa lista é de <b>" + App.SniperExtensao.capacidadeListaDeObservacao + " itens</b>, libere espaço para continuar");
          if (resposta && resposta.hasOwnProperty('parar') && resposta.parar) {
            this.pararTudo();
          }
          break;
        case "listas_cheia":
          this.pararTudo();
          this.exibirLog("danger", "Listas cheias", "Suas listas estão cheias, libere espaço em suas listas para continuar");
          break;
        case "saldo_insuficiente":
          this.pararTudo();
          this.exibirLog("danger", "Saldo Insuficiente", `Você não tem uma quantidade de coins suficientes, seu saldo é de <b>${resposta.coins} coins</b>`);
          break;
        case "saldo_insuficiente_momentaneo":
          this.exibirLog("primary", "Saldo Bloqueado", `Aguardando saldo para poder dar mais lances, saldo em uso nos itens ativos no lance`, 'saldo-insuficiente-momentaneo', true);
          break;
        case "acao_de_listagem":
          this.tratarRespostaListagemVenda(resposta);
          break;
        case "tela":
          this.tratarRespostaTela(resposta);
          break;
        case "webapp_click":
          this.tratarRespostaClickWebApp(resposta);
          break;
        case "webapp_filtro":
          this.tratarRespostaFiltroWebApp(resposta);
          break;
        case "atualizar_listagem":
          this.tratarRespostaAtualizarListagens(resposta);
          break;
        case "tempo_espera_lance":
          this.tratarRespostaTempoEsperaLance(resposta);
          break;
        case "experar_expirar_itens_anteriores":
          this.exibirLog("primary ", "Aguardando Expirar", `Aguardando os itens dos lances anteriores expirarem para não ocorrer nenhum conflito`, "aguardar-expiracao-anterior", true);
          break;
        case "filtro_invalido_lance":
          this.tratarRespostaFiltroInvalidoLance(resposta);
          break;
        case "rscaptcha":
          this.tratarRespostaSolucaoCaptcha(resposta);
          break;
        case "verificar_preco_jogador":
          let itemHaValidar: IItemListagem = resposta.item;
          let variacao: string = itemHaValidar.assetId != itemHaValidar.resourceId ? "|(Variação)" : "";
          this.exibirLog("default badge-bgcinzaclaro-corlaranjaescuro", "Verificar preço", "<b>" + itemHaValidar.name + "(" + itemHaValidar.rating + ")</b> |ID: " + itemHaValidar.assetId + " |UNI.ID: " + itemHaValidar.resourceId + variacao);
          break;
        case "venda_nao_informada":
          let itemVenda: any = resposta.item;
          this.exibirLog("primary badge-bgcinzaclaro-corlaranjaescuro", "Não Colocado à Venda", "Valor de venda não encontrado para <b>" + itemVenda.itemData.name + "</b>");
          break;
        case "venda_limite_temporario":
          let itemVendaLimite: any = resposta.item;
          this.exibirLog("primary badge-bgcinzaclaro-corlaranjaescuro", "Venda Limitada Na Lista", "Ainda é uma funcionalidade <b>BETA</b>, por enquanto estamos limitando a venda na listagem para cartas com limite máximo de <b>" + resposta.limiteTemorarioPrecoVendaListagem + " coins</b>, <b>" + itemVendaLimite.itemData.name + "</b> não foi colocado à venda");
          break;
        case "validacao_de_preco":
          this.exibirLog("primary badge-bgcinzaclaro-corlaranjaescuro", "Preços validados", "O processo de validação de preços foi concluído");
          this.modo_listagem_status = 0;
          // Recarregar listagem lance novamente
          setTimeout(() => {
            App.SniperExtensao.elBtSnipar.prop('disabled', false);
            App.SniperExtensao.ocultarLoadingSniperApp();
          }, 5000);
          break;
        case "resultado_transferencia_coins":
          this.transferenciaDeCoinsEmExecucao = false;
          App.VendaCoins.transferindo = false;
          App.SniperExtensao.ocultarLoadingSniperApp();
          if (resposta.status) {
            let btnCurrentTransferencia = $("#itemCardTransferencia").find('button.btn-transferir-coins');
            this.ajax.postAcaoSemCabecalhoGlobal(btnCurrentTransferencia.data("url"), { id: btnCurrentTransferencia.data("id") });
            this.vendaCoins.addCarimboItemComprado(btnCurrentTransferencia);
            $("#espacoLogs").prepend(this.vendaCoins.getConteudoLogTransferenciaConcluida(App.VendaCoins.itemTransferenciaAtual));
            this.vendaCoins.incrementarTotalCoins(App.VendaCoins.itemTransferenciaAtual.buyNowPrice);
            this.vendaCoins.decrementarTotalCoinsGeral(App.VendaCoins.itemTransferenciaAtual.buyNowPrice);
          } else {
            $("#espacoLogs").prepend(App.VendaCoins.getConteudoLogItemNaoEncontrado());
          }
          break;
        case "item_detalhes":
          this.exibirItemDetalhes(resposta, resposta.item)
          break;
        case "relistagem":
          this.exibirLog("info badge-acoes", "Relistagem Automática", "Os itens expirados em sua lista foram relistados");
          break;
        case "retirou_vendidos":
          this.exibirLog("info badge-acoes", "Retirou Itens Vendidos", "Os itens vendidos foram removidos de sua lista de transferência", "retirou-vendidos", true);
          break;
        case "montagem_dme":
          this.tratarRespostaMontagemDme(resposta);
          break;
        case "evitar_prejuizo_venda":
          var itemVendaPrejuizo: any = resposta.item;
          var nomeItem = itemVendaPrejuizo.itemData.hasOwnProperty('knownAs') && itemVendaPrejuizo.itemData.knownAs && itemVendaPrejuizo.itemData.knownAs != "---" ? itemVendaPrejuizo.itemData.knownAs : (itemVendaPrejuizo.itemData.hasOwnProperty('firstName') ? itemVendaPrejuizo.itemData.firstName + " " + itemVendaPrejuizo.itemData.lastName : itemVendaPrejuizo.itemData.name)
          this.exibirLog("info badge-venda-bloqueada", "Venda Bloqueada", `<b>${nomeItem} (${itemVendaPrejuizo.itemData.rating})</b> não pode ser vendido por <b>${resposta.valorVenda} coins</b>, esse valor é <b>inferior ao comprado ou listado</b> anteriormente, para desativar essa trava de segurança vá para <b>preferências em seu menu configurações</b>`);
          if (resposta && resposta.hasOwnProperty('parar') && resposta.parar) {
            this.exibirLog("danger", "Evitar Prejuízo", "o sniper será encerrado para evitar prejuízo.");
            this.pararTudo();
          }
          break;
        case "mercado_transferencia":
          if (!resposta.status) {
            this.exibirLog("danger", "Sem Mercado", "Seu WebApp não está com mercado de transferência liberado");
            this.mercadoTranferencia = false;
          }
          break
        case "lucro_impossivel":
          this.exibirLog("info badge-alerta-amarelo", "Lucro Impossível", "Impossivel ter lucro no filtro informado.", "lucro-impossivel", true);
          if (resposta && resposta.hasOwnProperty('parar') && resposta.parar) {
            this.pararTudo();
          }
          break;
        case "preco_filtro_lucro_nao_identificado":
          this.exibirLog("info badge-alerta-amarelo", "Preço não identificado", "Não foi possível identificar o preço do filtro com precisão.", "preco-filtro-nao-identificado", true);
          if (resposta && resposta.hasOwnProperty('parar') && resposta.parar) {
            this.pararTudo();
          }
          break;
        case "lucro_incompativel":
          let { lucroInformado, novoLucro } = resposta.dados;
          let descricao = `O lucro de <b>${lucroInformado}%</b> não é compatível com o filtro nesse momento, portanto o sistema modificou o lucro para uma valor aproximado de <b>${parseInt(novoLucro)}%</b>, esse é o lucro máximo compatível nesse momento.`
          this.exibirLog("info badge-alerta-amarelo", "Lucro Incompatível", "Lucro será ajustado para o lucro máximo possível para esse filtro.", "lucro-incompativel", true);
          break;
        case "lucro_baixo":
          this.exibirLog("info badge-alerta-amarelo", "Lucro Baixo", "Esse filtro no momento está obtendo lucro muito baixo.", "lucro-baixo", true);
          break;
        case "filtro_lucro_variacao_preco_compra":
          const precosBusca = Array.isArray(resposta.dados)
            ? resposta.dados.map(p => p.precoCompra).join(', ')
            : '';
          this.exibirLog("info badge-bgcinzaclaro-corlaranjaescuro", "Lucro Variado", `Você está usando o filtro por lucro variado: Buscando por:<b>${precosBusca}</b>`, "lucro-variacao", true);
          break;
        case "lucro_estimado":
          let { lucroEstimado, precoCompra, precoVenda } = resposta.dados;
          // this.exibirLog(parseInt(lucroEstimado) <= 0 ? 'danger' : 'success', "Lucro Estimado", desc, "lucro-estimado", true, "position: fixed;bottom: 80px;right: 62px;max-width: 24%;");
          let htmlLucroEstimado = `
          <li class="list-group-item px-1 py-1 mt-0 mb-1 lucro-estimado" style="background-color: #fbf8ff;">
            <button onclick="$(this).parents('li').remove()" type="button" class="close"><span>×</span></button>
            <div class="row align-items-center">
                <div class="col" style="line-height: 13px;">
                    <small  style="font-size: 66%;">Comprando Até:</small>
                    <h5 class="mb-0 mt-2">${precoCompra} Coins</h5>
                </div>
                <div class="col" style="line-height: 13px;">
                    <small style="font-size: 66%;">Venda Mínima:</small>
                    <h5 class="mb-0 mt-2">${precoVenda} Coins</h5>
                </div>
                <div class="col" style="line-height: 13px;">
                    <small  style="font-size: 66%;">Lucro por Carta:</small>
                    <h5 class="mb-0 mt-2 text-success">${lucroEstimado} Coins</h5>
                </div>
            </div>
            <p class="m-0 font-size-11 mt-1" style="text-align: center;">última atualização: ${new Date().toLocaleString()}</p>
          </li>`
          this.exibirLogFixo(htmlLucroEstimado, "lucro-estimado", true);
          this.exibirPrecoCompraEncontradoBotaoSniperLucro(precoCompra)
          break;
        case "carregando_webapp":
          App.SniperExtensao.exibirLoadingSniperApp('<i class="fas fa-sync-alt" style="font-size: 34px;" title="Carregando WebApp"></i>', false, "Carregando WebApp...");
          break;
        case "executando_tarefas_iniciais":
          App.SniperExtensao.exibirLoadingSniperApp('<i class="fa-solid fa-list-check" style="font-size: 34px;" title="Executando tarefas iniciais"></i>', false, "Executando tarefas iniciais...");
          break;
        case "inicializacao_completa":
          if (!App.SniperExtensao.sniperAtivo) {
            App.SniperExtensao.ocultarLoadingSniperApp()
          }
          break;
        case "parou_tarefas_webapp":
          if (App.SniperExtensao.loadingSniperAppVisivel() && !App.SniperExtensao.sniperAtivo) {
            App.SniperExtensao.ocultarLoadingSniperApp()
          }
          break;
        case "estimar_lucro_iniciado":
          App.SniperExtensao.exibirLoadingSniperApp('<i class="fa-solid fa-percent" style="font-size: 34px;" title="Estimando lucro"></i>', false, "Estimando lucro...");
          break;
        case "estimar_lucro_finalizado":
          if (App.SniperExtensao.loadingSniperAppVisivel() && !App.SniperExtensao.sniperAtivo) {
            App.SniperExtensao.ocultarLoadingSniperApp()
          }
          break;
        case "limite_venda_ativa_atingido":
          if (resposta.capacidadeVendaAtiva >= 100) {
            this.exibirLog("warning", "Limite de Venda Ativa Atingido!", `Impossível listar em venda, você atingiu o limite máximo de <b>${resposta.capacidadeVendaAtiva} itens</b> em venda ativa`, "limite-venda-ativa-atingido", true);
          } else {
            this.exibirLog("warning", "Limite de Venda Ativa Atingido!", `Só é permitido colocar até <b>${resposta.capacidadeVendaAtiva} itens</b> em venda ativa no WebApp, essa é uma nova regra da EA, caso queira burlar esse limite e assumir os riscos, vá em <a class="btn btn-sm btn-link" data-config="config" data-id-conta-ea="" data-toggle="modal" data-target="#modalConfigExtensao" href=""><i class="fa fa-cog" style="margin-right: 0.5rem;"></i>Preferências</a> e ative a opção "Aumentar Capacidade de Venda Ativa"`, "limite-venda-ativa-atingido", true);
          }
          if (resposta && resposta.hasOwnProperty('parar') && resposta.parar) {
            this.pararTudo();
          }
          break;
        case "stistic":
          this.registrarEstatisticas(resposta.evento)
          break;
        case "inforvals":
          this.atualizarInformacoesInfoRivals((resposta as any))
          break;
        case "filtro_travado_conferencia":
          this.exibirLog("info badge-alerta-amarelo", "Sniper Interrompido", "o filtro não passou na conferência, para evitar prejuízo o sniper será interrompido.", "filtro-conferencia", true);
          if (resposta && resposta.hasOwnProperty('parar') && resposta.parar) {
            this.pararTudo();
          }
          break;
        case "trava_seguranca":
          this.exibirLog("danger", "Sniper Interrompido", "Por segurança o sistema foi interrompido, muitas buscas foram feitas e estavam causando erros no WebApp, verifique se seu WebApp está <b>funcionando corretamente buscas e compras</b>, confira a <b>velocidade de busca</b> se não está muito rápida.", "trava-seguranca");
          this.pararTudo();
          break;
        case "seguranca_mercado_liberado_importar_conceitos":
          toastr.warning("Por segurança o sistema foi interrompido, a conta tem mercado liberado, não é possível gerar conceitos.", "Atenção!");
          break;
        case "importar_conceitos_iniciado":
          App.SniperExtensao.exibirLoadingSniperApp('<i class="fas fa-sync-alt" style="font-size: 34px;" title="Gerando conceitos"></i>', false, "Gerando conceitos...");
          break;
        case "importar_conceitos_finalizado":
          if (App.SniperExtensao.loadingSniperAppVisivel() && !App.SniperExtensao.sniperAtivo) {
            App.SniperExtensao.ocultarLoadingSniperApp()
          }
          break;
      }
      App.SniperExtensao.tentando = false;
    }

    private exibirPrecoCompraEncontradoBotaoSniperLucro(precoCompra: any) {
      $('#botaoSnipar .info-oferta').html(precoCompra);
      $('#botaoSnipar .info-oferta').show();
      $('#botaoSnipar .bt-text-coins').show();
      $('#botaoSnipar .bt-text-lucro').hide();
    }

    private ocultarPrecoCompraEncontradoBotaoSniperLucro() {
      $('#botaoSnipar .info-oferta').hide();
      $('#botaoSnipar .info-oferta').html('200');
      $('#botaoSnipar .bt-text-coins').hide();
      $('#botaoSnipar .bt-text-lucro').show();
    }

    private limparViewLogLucroEstimado() {
      if ($("#espacoLogs").parents('.card-body').find('.lucro-estimado').length) {
        $("#espacoLogs").parents('.card-body').find('.lucro-estimado').remove()
      }
    }

    private exibirItemDetalhes(resposta: any, itemDetalhe: IItemTransferDetalhe) {
      try {
        var modalItemDetalhe: JQuery = $("#modalItemDetalhes");
        if (itemDetalhe) {
          var currentBid: any = itemDetalhe.currentBid ? itemDetalhe.currentBid : '---';
          var calcExpires: any = itemDetalhe.expires * 1000;
          calcExpires = App.Util.formatDuration(calcExpires);
          var seletorRaridade: JQuery = $(".playercard-s");
          var $urlRaridade: string = App.Util.tratarTipoRaridade(itemDetalhe.itemData.rareflag);
          if (itemDetalhe.itemData.rareflag == 12 || itemDetalhe.itemData.rareflag == 84) {
            $(".playercard-name").attr('style', 'color: #4c4948 !important;');
            $(".playercard-rating").attr('style', 'color: #4c4948 !important;');
            $(".playercard-position").attr('style', 'color: #4c4948 !important;');
          }
          seletorRaridade.attr('style', `background-image: url(${$urlRaridade})`);
          modalItemDetalhe.find('.playercard-name').html(itemDetalhe.itemData.name)
          modalItemDetalhe.find('.playercard-rating').html(itemDetalhe.itemData.rating.toString())
          modalItemDetalhe.find('.playercard-position').html(itemDetalhe.preferredPositionNameTraduzido)
          modalItemDetalhe.find('.playercard-nation').html(`<img src="https://cdn.futnext.com/nation/${itemDetalhe.itemData.nation.toString()}.png" alt="nation">`)
          modalItemDetalhe.find('.playercard-club').html(`<img src="https://cdn.futnext.com/club/${itemDetalhe.itemData.teamId.toString()}.png" alt="club">`)
          modalItemDetalhe.find('.playercard-picture').html(`<img src="https://cdn.futnext.com/player/${itemDetalhe.itemData.assetId.toString()}.png" alt="player">`)
          modalItemDetalhe.find('.playercard-style').html(`<img src="/fut21/Images/Styles/${itemDetalhe.playStyle.toString()}.png" alt="${itemDetalhe.estiloEntrosamento}">`)
          modalItemDetalhe.find('.d-startingBid').html(itemDetalhe.startingBid.toString())
          modalItemDetalhe.find('.d-buyNowPrice').html(itemDetalhe.buyNowPrice.toString())
          modalItemDetalhe.find('.d-currentBid').html(currentBid)
          modalItemDetalhe.find('.d-expiracao').html(calcExpires)
          modalItemDetalhe.find('.d-estilo').html(itemDetalhe.estiloEntrosamento)
          modalItemDetalhe.find('.d-contratos').html(itemDetalhe.contract.toString())
          modalItemDetalhe.find('.d-proprietarios').html(itemDetalhe.owners.toString())
          modalItemDetalhe.find('.d-nomeRaridade').html(itemDetalhe.raridadeName)
          modalItemDetalhe.find('#btnJaCompreiCartaMyDGN').html("Já Comprei a Carta");
          modalItemDetalhe.find('#btnJaCompreiCartaMyDGN').removeAttr("disabled");
          var seletorMinuto = document.querySelector(".minuto");
          var seletorSegundo = document.querySelector(".segundo");

          if (App.VendaCoins.itemTransferenciaAtual.paymentInUsd) {
            modalItemDetalhe.find('.valorGanhoVendaCoins').html(`| $: ${App.VendaCoins.itemTransferenciaAtual.paymentInUsd}`);
            if (seletorMinuto.textContent == "3") {
              this.vendaCoins.enviarConfirmacaoCompraSemAcaoUsuarioMyDgn(true);
            }
          }
          if (seletorMinuto.textContent == "0" && seletorSegundo.textContent == "00") {
            seletorMinuto.textContent = "3";
          }
          this.contagemRegressiva();
        } else if (resposta.codigo == 494) {
          modalItemDetalhe.find('.card-body').html(`<i class="fa fa-frown text-center" aria-hidden="true" style="color: #dc3545;font-size: 50px;margin-bottom: 5%;"></i><p class="nao-encontrado">Essa conta EA logada não possui o mercado liberado no WebApp, por essa razão não é possível mostrar os detalhes da carta. Por favor, efetue login em uma conta EA com o Mercado Liberado no WebApp.</p>`)
          modalItemDetalhe.find('.card-body').addClass("text-center");
        } else {
          modalItemDetalhe.find('.card-body').html(`<i class="fa fa-frown text-center" aria-hidden="true" style="color: white;font-size: 50px;margin-bottom: 5%;"></i><p class="nao-encontrado">Não foi possível localizar a carta ou ela já foi comprada, faça o processo de busca novamente daqui a alguns minutos!</p>`)
          modalItemDetalhe.find('.card-body').addClass("text-center");
        }
        modalItemDetalhe.modal("show")
      } catch (e) {
        // console.log("ERRO ITEM DETALHES", e, itemDetalhe)
      }
    }

    private exibirLogFixo(html: string, classDiv: string = '', remover: boolean = false) {
      if (remover) {
        $("#espacoLogs").parents('.card-body').find(`.${classDiv}`).remove();
      }

      $("#espacoLogs").parents('.card-body').prepend(`${html}`);
    }

    private exibirLog(tipoMsg: string, tituloMsg: string, msg: string, classDiv: string = '', remover: boolean = false, estilo: string = '') {
      if (remover) {
        $("#espacoLogs").find(`.${classDiv}`).remove();
      }

      $("#espacoLogs").prepend('<div class="' + classDiv + '" style="' + estilo + '"><span class="badge badge-pill badge-' + tipoMsg + ' text-uppercase">' + tituloMsg + '</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">' + msg + '</p></div>');
    }
    private informarSobreCaptcha(captchaCerteza: boolean = true) {
      // console.log("informarSobreCaptcha chegou ", captchaCerteza, this.informandoCaptcha);
      if (this.informandoCaptcha) {
        return;
      }

      this.informandoCaptcha = true;
      App.SniperExtensao.runAudio(3);
      $("#espacoLogs").prepend(App.SniperExtensao.getConteudoLogCaptcha());
      var dados: any = { id: App.Util.usuario.id, nome_conta: $("#infoClube").html(), captcha_certeza: captchaCerteza };
      // console.log("informarSobreCaptcha chegou 2", dados, App.Util.usuario.notificacao_telegram);
      if (App.Util.usuario.notificacao_telegram && App.Util.usuario.notificacao_telegram.chat_id) {
        App.SniperExtensao.notificarCaptchaPorTelegram(captchaCerteza);
      } else {
        this.ajax.postAcaoSemResposta(App.Util.config.urlNotificacaoCaptcha, dados);
      }
      setTimeout(() => {
        this.informandoCaptcha = false;
      }, 10000);
    }

    public static notificarCaptchaPorTelegram(captchaCerteza: boolean = true) {
      let telegram_token = App.Util.usuario.notificacao_telegram.token;
      let telegram_chat_id = App.Util.usuario.notificacao_telegram.chat_id;
      let message = "Olá, você recebeu um captcha na conta EA **" + App.SniperExtensao.dadosContaEa.clube + "**, é aconselhável resolve-lo o mais rápido que puder.";
      if (!captchaCerteza) {
        message = "Olá, O sniper parou na sua conta EA **" + App.SniperExtensao.dadosContaEa.clube + "**, verifique se sua conta precisa de uma solução de Captcha ou apenas uma nova autenticação.";
      }
      if (telegram_token && telegram_chat_id) {
        let url = 'https://api.telegram.org/bot' + telegram_token +
          '/sendMessage?chat_id=' + telegram_chat_id + '&parse_mode=Markdown&text=' + message;
        var xhttp = new XMLHttpRequest();
        xhttp.open("GET", url, true);
        xhttp.send();
      }
    }

    private exibirLogErroProblemaSincronizacao() {
      $("#espacoLogs").prepend('<span class="badge badge-pill badge-warning text-uppercase">Problema</span><span class="text-muted pull-right mt-1 font-size-10">' + new Date().toLocaleString() + '</span><p class="description border-bottom">Houve um problema na sincronização da conta, Faça login novamente na sua conta EA e depois recarregue essa página</p>');
    }


    private atualizarExibicaoClubeAtual() {
      if (App.SniperExtensao.dadosContaEa) {
        $(".info-nome-clube").html(App.SniperExtensao.dadosContaEa.clube);
        $('#infoCoins, .info-coins').html(App.SniperExtensao.dadosContaEa.coins ? App.SniperExtensao.dadosContaEa.coins.toLocaleString('pt-BR') : null);
        $('#infoPlataforma, .info-plataforma').html(App.SniperExtensao.dadosContaEa.ptf.toString());
        $('#imgEscudoClube').attr('src', (App.SniperExtensao.dadosContaEa.url_img_clube ? App.SniperExtensao.dadosContaEa.url_img_clube.toString() : "/img/escudo-default.png"));
        $('.img-scudo-clube-atual').attr('src', (App.SniperExtensao.dadosContaEa.url_img_clube ? App.SniperExtensao.dadosContaEa.url_img_clube.toString() : "/img/escudo-default.png"));
      }
    }

    private atualizarListagemClube(itensOuItem: any) {
      if (Array.isArray(itensOuItem)) {
        App.SniperExtensao.arrayListaClube = this.atualizarArrayListagemComCacheFutbin(itensOuItem);
      } else if (typeof itensOuItem === 'object' && itensOuItem !== null) {
        App.SniperExtensao.arrayListaClube = App.Util.arrayRemoveByResourceId(App.SniperExtensao.arrayListaClube, itensOuItem.resourceId);
        itensOuItem = this.atualizarItemListagemComCacheFutbin(itensOuItem);
        App.SniperExtensao.arrayListaClube.push(itensOuItem);
      }

      App.Util.setArrayStorage(App.SniperExtensao.keyStorageListagemClube, App.SniperExtensao.arrayListaClube);
      $('.info-quantidade-lista-clube').html(App.SniperExtensao.arrayListaClube.length.toString());
      let elementoListagemContexto: IContextoListagem = this.getObjListagemContexto(null, this.idListagemClube);
      this.atualizarDadosDataTable(elementoListagemContexto, this.inicializarLista);
      App.SniperExtensao.desabilitarBotaoItensSelecionadosListagem(elementoListagemContexto);
    }

    private atualizarCreditos(dados: any) {
      if (dados.hasOwnProperty('coins')) {
        $('#infoCoins, .info-coins').html(dados.coins.toLocaleString('pt-BR'));
      }
    }
    private atualizarListaTransferencia(dadosLista: any) {
      App.SniperExtensao.arrayListaTransferencia = this.atualizarArrayListagemComCacheFutbin(dadosLista);
      App.SniperExtensao.quantidadeAtualListaDeTransferencia = dadosLista.hasOwnProperty('auctionInfo') ? dadosLista.auctionInfo.length : dadosLista.length;
      $('#infoListaTransferencia, .info-lista-transferencia').html(App.SniperExtensao.quantidadeAtualListaDeTransferencia + "/" + App.SniperExtensao.capacidadeListaDeTransferencia);
      $('.info-quantidade-lista-transferencia').html(App.SniperExtensao.quantidadeAtualListaDeTransferencia.toString());
      App.SniperExtensao.quantidadeDisponivelListaDeTransferencia = App.SniperExtensao.capacidadeListaDeTransferencia - App.SniperExtensao.quantidadeAtualListaDeTransferencia;

      let elementoListagemContexto: IContextoListagem = this.getObjListagemContexto(null, this.idListagemTransferencia);
      this.atualizarDadosDataTable(elementoListagemContexto, this.inicializarLista);
      App.SniperExtensao.desabilitarBotaoItensSelecionadosListagem(elementoListagemContexto);
    }

    private atualizarListaObservacao(dadosLista: any) {
      if (dadosLista.hasOwnProperty('userInfo')) {
        App.SniperExtensao.dadosUserInfoEa.usermassinfo = dadosLista;
        $('#infoCoins, .info-coins').html(dadosLista.userInfo.credits.toLocaleString('pt-BR'));
      }
      App.SniperExtensao.quantidadeAtualListaDeObservacao = dadosLista.hasOwnProperty('purchasedItems') ? dadosLista.purchasedItems.itemData.length : dadosLista.length;
      $('#infoListaObservacao, .info-lista-observacao').html(App.SniperExtensao.quantidadeAtualListaDeObservacao + "/" + App.SniperExtensao.capacidadeListaDeObservacao);
      App.SniperExtensao.quantidadeDisponivelListaDeObservacao = App.SniperExtensao.capacidadeListaDeObservacao - App.SniperExtensao.quantidadeAtualListaDeObservacao;
    }

    /**
     * Soluções de problemas
     */
    private inicializarSolucoesDeProblemas() {
      this.elementoBotaoTesteProblemas.on('click', (e) => { this.iniciarAnalise(e); });
    }


    private removerLinkCarregamentoIncompletoScripts() {
      $('#problemaCarregamentoScripts').hide();
    }

    private inicializarLimpezaCache() {
      this.elementoBotaoLimparCache.on('click', (e) => {
        chrome.runtime.sendMessage(this.idExtensao, { evento: "lpcache" },
          (resposta: any) => {
            $("#modalSolucaoproblemas").modal('hide');
            this.exibirMensagemAlertaSwal("Limpeza completa!", "Você será redirecionado para fazer uma nova autenticação e sincronizar sua conta EA com FutSniperExtension novamente.", "warning", "Sincronizar novamente", "Fechar", '#3740FF', false, resposta.urlWebApp);
            setTimeout(() => {
              window.location.href = resposta.urlWebApp;
            }, 7000);
          });
      });
    }

    private iniciarAnalise(e: JQueryEventObject) {
      this.inicializarConfiguracoes();
      App.SniperExtensao.testeSniper.softbanBusca = false;
      App.SniperExtensao.testeSniper.softbanCompra = false;
      App.SniperExtensao.testeSniper.captcha = false;
      App.SniperExtensao.testeSniper.naoAutenticado = false;
      // App.SniperExtensao.elCampoNoUiSliderVelocidade.noUiSlider.set(2000);
      App.SniperExtensao.objSelect2.setSelectTag(App.SniperExtensao.selectVelocidade, { id: '2000', text: `2000 ${App.SniperExtensao.selectVelocidade.data('sufixDesc')}` })
      App.SniperExtensao.contexto = this;

      this.proximaVerificacao(this.elementoPassoExtensaoInstalada, this.verificarExtensaoInstalada,
        () => {
          this.proximaVerificacao(this.elementoPassoExtensaoAtualizada, this.verificarExtensaoAtualizada,
            () => {
              $(this.elementoPassoAutenticacao).find('.badge-aguardando').hide();
              $(this.elementoPassoAutenticacao).find('.badge-loading').show();
              this.testarSniper();
            });
        });
    }
    private proximaVerificacao(e: JQuery, validar: any, proximaVerificacao: any = null): any {
      $(e).find('.badge-aguardando').hide();
      $(e).find('.badge-loading').show();
      setTimeout(() => {
        if (!validar()) {
          $(e).find('.badge-loading').hide();
          $(e).find('.badge-erro').show();
          $(e).find('.texto-erro').show();
          return false;
        } else {
          $(e).find('.badge-loading').hide();
          $(e).find('.badge-sucesso').show();
          if (proximaVerificacao) {
            proximaVerificacao();
          }
        }
      }, 1000);
    }
    private verificarExtensaoInstalada(): boolean {
      return $('#idExtensao').val() != "";
    }
    private verificarExtensaoAtualizada(): boolean {
      return !App.SniperExtensao.ehVersaoDesatualizadaExtensao();
    }
    private testarSniper() {
      try {
        if (App.SniperExtensao.sniperTravado != 1 && App.SniperExtensao.dadosContaEa.autenticada) {
          this.testeAtivo = true;
          App.SniperExtensao.loopIntervaloSniparEmTeste = setInterval(() => {
            if (this.testeAtivo) {
              App.SniperExtensao.contexto.snipar($.Event("submit"), false, true);
            } else {
              clearInterval(App.SniperExtensao.loopIntervaloSniparEmTeste);
            }
          }, 4000);
          App.SniperExtensao.arrayLoopIntervalos.push(App.SniperExtensao.loopIntervaloSniparEmTeste);

        } else {
          App.SniperExtensao.testeSniper.naoAutenticado = true;
          this.continuarTeste();
        }
      } catch (e) {
        this.testeAtivo = false;
      }
    }

    private continuarTeste() {
      this.proximaVerificacao(this.elementoPassoAutenticacao, this.verificarSeEstaAutenticado,
        () => {
          this.proximaVerificacao(this.elementoPassoBuscaDeItem, this.verificarSeEstaBuscando,
            () => {
              this.proximaVerificacao(this.elementoPassoCompraDeItem, this.verificarSeEstaComprando,
                () => {
                  this.finalizarTeste();
                });
            });
        });
    }

    private verificarSeEstaAutenticado(): boolean {

      return !App.SniperExtensao.testeSniper.naoAutenticado;
    }

    private verificarSeEstaBuscando(): boolean {
      return !App.SniperExtensao.testeSniper.softbanBusca;
    }

    private verificarSeEstaComprando(): boolean {
      return !App.SniperExtensao.testeSniper.softbanCompra;
    }

    private finalizarTeste(): void {
      $("#testeCompleto").show();
    }

    private existeJogadorEmTodoClube(item: IElencoDme): boolean {
      return App.Util.arrayExistByResourceId(App.SniperExtensao.arrayListaLance, item.id.toString()) ||
        App.Util.arrayExistByResourceId(App.SniperExtensao.arrayListaTransferencia, item.id.toString()) ||
        App.Util.arrayExistByResourceId(App.SniperExtensao.arrayListaClube, item.id.toString());
    }

    private adicionarInfoElencoDeDme(dme: IRetornoElencoDme) {
      if (dme.nomeSbc) {
        $("#nomeDme").html(dme.nomeSbc)
        $("#imgDme").attr('src', dme.imgSbc)
        $("#tituloInfoDme").show()
      }

      $("#espacoInfoDme").show()
    }

    private adicionarElencoDeDme(elenco: IElencoDme[]) {
      if (elenco.length > 1) {
        var preenchido = false;
        var quantidadeJogadoresExistentes = 0;
        var temTodosOsjogadores = true;
        $("#searchclear").click();

        this.arrayForEachVelocidadeRandomica(elenco, this.arrayLoopAddJogadoresCompraDme, (item: IElencoDme, index: number) => {
          let ultimoItem = index == (elenco.length - 1);
          if (this.existeJogadorEmTodoClube(item)) {
            if (!$('#abaLog').hasClass('active')) {
              $('#abaLog').click();
            }
            quantidadeJogadoresExistentes++;
            App.SniperExtensao.salvarLogJogadorJaExiste($("#espacoLogs"), item);
            if (ultimoItem) {
              preenchido = true;
              this.addInfoPrecoSelectJogadores(elenco);
            }
          } else if (item.preco <= 0) {
            if (!$('#abaLog').hasClass('active')) {
              $('#abaLog').click();
            }
            App.SniperExtensao.salvarLogJogadorNaoTemNoMercado($("#espacoLogs"), item);
            if (ultimoItem) {
              preenchido = true;
              this.addInfoPrecoSelectJogadores(elenco);
            }
          } else {

            if (item.id != item.assetId && item.rarityId <= 3) {
              if (!$('#abaLog').hasClass('active')) {
                $('#abaLog').click();
              }
              App.SniperExtensao.salvarLogJogadorEspecialObservar($("#espacoLogs"), item);
            }

            var player = App.Util.getItemArrayById(App.SniperExtensao.players, parseInt(item.assetId.toString()));
            if (!App.Util.empty(player)) {
              if (!$('#espacoCampojogadores').is(':visible')) {
                $("#espacoCampojogadores").show()
              }
              temTodosOsjogadores = false
              var option = new Option(JSON.stringify(player), player.id, true, true);
              option.title = player.hasOwnProperty('c') ? player.c : player.f + ' ' + player.l;
              $("#jogador").append(option).trigger('change').trigger('select2:select');
              if (ultimoItem) {
                preenchido = true;
                this.addInfoPrecoSelectJogadores(elenco);
              }
            }
          }

          if (ultimoItem) {
            App.SniperExtensao.ocultarLoadingSniperApp()
            this.habilitarCamposAposProcessarUrlDme(quantidadeJogadoresExistentes == 11);
          } else {
            App.SniperExtensao.exibirLoadingSniperApp('<i class="fas fa-file-download" style="color: #cecce4;"></i>', false, "Importando Jogadores...");
          }
        }, { min: 1000, max: 1000 });
      }
    }
    private habilitarCamposAposProcessarUrlDme(temTodosOsjogadores = true): void {
      if (temTodosOsjogadores) {
        $("#espacoCampojogadores").hide()
        $("#espacoConfiguracaoPrecoDme").hide()
        $("#jogadoresEncontrados").show()
        $("#jogadoresNaoEncontrados").hide()
        $("#avisoMontagemDme").show()
        $("#avisoComprarJogadores").hide()
        $("#espacoConfiguracoesSniper").hide()
        $("#botaoMontarDme").show()
        $("#botaoMontarDmeConceito").hide()
      } else {
        $("#espacoCampojogadores").show()
        $("#espacoConfiguracaoPrecoDme").show()
        $("#espacoConfiguracoesSniper").show()
        $("#avisoMontagemDme").hide()
        $("#jogadoresEncontrados").hide()
        $("#botaoMontarDme").hide()
        if (App.Util.elencoDme.idCategoriaSbc) {
          $("#jogadoresNaoEncontrados").show()
          $("#avisoComprarJogadores").show()
          $("#botaoMontarDmeConceito").show()
        } else {
          $("#tituloInfoElenco").show()
          $("#tituloInfoDme").hide()
          $("#labelImcompleto").hide()
          $("#labelConcluido").hide()
        }
      }
      App.SniperExtensao.ocultarLoadingSniperApp();
    }

    private async delay(ms: number) {
      return new Promise((resolve: any) => setTimeout(resolve, ms));
    }

    private async addInfoPrecoSelectJogadores(elenco: IElencoDme[]) {
      $(".corpo-info-precos-dme").remove();
      let valorCampoPorcentageMaisBarato = parseInt(App.SniperExtensao.elCampoNoUiSliderPorcentagemMaisBarato.noUiSlider.get());

      let index = 0;
      for await (const itemElencoDme of elenco) {
        await this.delay(Util.getRandomInt(10, 100));
        console.log("addInfoPrecoSelectJogadores itemElencoDme", itemElencoDme)
        valorCampoPorcentageMaisBarato = valorCampoPorcentageMaisBarato ? valorCampoPorcentageMaisBarato : itemElencoDme.porcentagemMaisBarato;
        var precoMaisBarato = this.obterValorMaisBaratoPorPorcentagem(itemElencoDme, valorCampoPorcentageMaisBarato);
        let spanEspecial = "";
        var spans = `<span title="Preço mais barato" id="span" class="nav-item badge badge-pill text-muted badge-success" style="color: #0a9b3d !important;padding: 0.15rem 0.2rem;">
                    <span class="description" style="font-size: 9px;">${precoMaisBarato} coins</span>
                    </span>
                    <span title="Preço no DME" id="span" class="nav-item badge badge-pill text-muted badge-primary" style="color: #497499 !important;padding: 0.15rem 0.2rem;">
                    <span class="description" style="font-size: 9px;">${itemElencoDme.preco} coins</span>
                    </span>`;
        let classItem = `item-resource-${itemElencoDme.resourceId}-${itemElencoDme.teamId}-${itemElencoDme.rating}`;
        let idItem = "#item" + itemElencoDme.assetId.toString();
        $(idItem).addClass(classItem);
        $(`.${classItem}`).find('.player-info-rating').html(itemElencoDme.rating.toString());
        if (itemElencoDme.assetId != itemElencoDme.resourceId) {
          spanEspecial = '<span class="badge badge-pill badge-default text-uppercase" style="color: #ffffff;background-color: #506086;font-size: 8px;margin-right: 2px;">Especial</span>'
          $(idItem).parents('li').css('background-color', '#d4d4d4');
        }
        let corpoSpan = `<span class="corpo-info-precos-dme" style="position: absolute;top: -22px;left: 39px;">${spanEspecial}${spans}</span>`
        $(`.${classItem}`).find('a.ui-menu-item-wrapper').append(corpoSpan);
        if (index == (elenco.length - 1)) {
          $(".select2-search, .select2-focusser, .select2-results__options").remove();
        }
        index++;
      }
    }

    private exibirDetalhesLoadJogador(itemElencoDme: IElencoDme) {
      let descEspecial = itemElencoDme.assetId != itemElencoDme.resourceId ? '<span class="badge badge-pill badge-default text-uppercase" style="color: #ffffff;background-color: #506086;">Especial</span>' : "";
      let descRating = `(${itemElencoDme.rating}) `;
      $('#cardLoadDetalhesOferta').html(itemElencoDme.preco.toString());
      $('#cardLoadDetalhesNomeJogador').html(itemElencoDme.nome.toString() + descRating + descEspecial);
      $('#cardLoadDetalhesImgJogador').attr('src', $('#item' + itemElencoDme.assetId).find('.playerpicture').attr('src'));
      $('#cardLoadDetalhesPrecoInicial').html(itemElencoDme.precoInicial.toString() + " coins");
      $('#cardLoadDetalhesPrecoPocentagem').html(itemElencoDme.porcentagemMaisBarato.toString() + "%");
      $('#cardLoadDetalhesJogador').show();
    }

    private aoSelecionarCampoQualidade(e: any) {
      var qualidadeSelecionada = $(e.target).val();
      if (qualidadeSelecionada == "bronze" || qualidadeSelecionada == "silver" || qualidadeSelecionada == "gold") {
        $('#raridade').find('option.categoria2').attr('disabled', 'disabled');
        $('#raridade').find('option.categoria1').removeAttr('disabled');
      } else if (qualidadeSelecionada == "SP") {
        $('#raridade').find('option.categoria1').attr('disabled', 'disabled');
        $('#raridade').find('option.categoria2').removeAttr('disabled');
      } else {
        $('#raridade').find('option.categoria1').removeAttr('disabled');
        $('#raridade').find('option.categoria2').removeAttr('disabled');
      }

      $("#raridade").select2("destroy");
      $("#raridade").select2({
        width: '100%',
        templateResult: formatOptionsSelect,
        templateSelection: formatOptionsSelect
      });
      $('#raridade').val('').trigger('change').trigger('select2:select');
    }

    private aoExibirModoCompraElenco(e: JQueryEventObject) {
      if (App.SniperExtensao.ehModoCompraDme) {
        $("input[name=id_conta_ea]").val(App.SniperExtensao.dadosContaEa.id);
        $("#limparFiltro").click();
        this.desabilitarVendaAutomatica();
        $("#espacoConteudoComposFiltros").hide();
        $("#conteudoGeralVendaAutomatica").hide();
        $('#conteudoOfertaCompra').hide();
        $("#btExibirModoCompraElenco").find('.text-modo-compra-elenco').show();
        $("#btExibirModoCompraElenco").find('.text-modo-compra-jogador').hide();
      }
    }

    private aoOcultarModoCompraElenco(e: JQueryEventObject) {
      document.location.reload();
    }

    private inicializarVendaDeCoins() {
      this.obterContasEa();
      if (App.SniperExtensao.ehVendaCoins) {
        this.vendaCoins = new App.VendaCoins();
        this.vendaCoins.inicializarEventos(this.idExtensao, this);
      }
    }

    private obterContasEa(contaAtualAutenticada: IContaEa = null, metodoCallback: any = null) {
      chrome.runtime.sendMessage(this.idExtensao, { evento: "ctsaut" },
        (resultado: any) => {
          App.SniperExtensao.contasEa = resultado.contas;
          this.verificarProcessarContas(contaAtualAutenticada, metodoCallback);
        });
    }

    private verificarProcessarContas(contaAtualAutenticada: IContaEa = null, metodoCallback: any = null) {
      if (contaAtualAutenticada) {
        if (contaAtualAutenticada.autenticada) {
          this.exibirContaAutenticada(contaAtualAutenticada);
          this.autenticando = false;
          this.exibirMensagemAlertaSwal("Conta Autenticada!", "Sua conta <b>" + contaAtualAutenticada.clube + "</b> foi autenticada.", "success", "OK", "Fechar", "#2dce89", false);
        } else {
          this.exibirContaNaoAutenticada(contaAtualAutenticada);
        }
        $("#simboloClube" + contaAtualAutenticada.id).attr('src', contaAtualAutenticada.url_img_clube.toString());
        if (metodoCallback) {
          metodoCallback();
        }
      } else {
        App.SniperExtensao.coinsTotal = 0;
        $.each(App.SniperExtensao.contasEa, (index: any, conta: IContaEa) => {
          if (conta.coins) {
            App.SniperExtensao.coinsTotal += conta.coins;
          }

          if (conta.autenticada) {
            this.exibirContaAutenticada(conta);
          } else {
            this.exibirContaNaoAutenticada(conta);
          }
          $("#simboloClube" + conta.id).attr('src', conta.url_img_clube.toString());
        });
      }
      this.vendaCoins.ordenarContaAtivaPrimeiro();
    }

    private calcularCoinsTotais() {
      App.SniperExtensao.coinsTotal = 0;
      $.each(App.SniperExtensao.contasEa, (index: any, conta: any) => {
        App.SniperExtensao.coinsTotal += conta.coins;
        $("#infoCoinsTotais").html(App.SniperExtensao.coinsTotal.toLocaleString('pt-BR'));
      });
    }

    private exibirContaAutenticada(conta: IContaEa) {
      $('#conta' + conta.id).find('.info-autenticada').html('Autenticada');
      $('#conta' + conta.id).find('.checklist-item').removeClass('checklist-item-warning').addClass('checklist-item-success');
      $('#conta' + conta.id).find('.status-autenticada').removeClass('text-warning').addClass('text-success');
      $('#conta' + conta.id).find('.btn-autenticar-conta').hide();
      $('#conta' + conta.id).find('.coins-conta').show();
      $('#conta' + conta.id).find('.coins').html(conta.coins.toLocaleString('pt-BR'));
      $("#infoCoinsTotais").html(App.SniperExtensao.coinsTotal.toLocaleString('pt-BR'));
    }

    private exibirContaNaoAutenticada(conta: IContaEa) {
      $('#conta' + conta.id).find('.info-autenticada').html('Não autenticada');
      $('#conta' + conta.id).find('.checklist-item').removeClass('checklist-item-success').addClass('checklist-item-warning');
      $('#conta' + conta.id).find('.status-autenticada').removeClass('text-success').addClass('text-warning');
      $('#conta' + conta.id).find('.btn-autenticar-conta').show();
      $('#conta' + conta.id).find('.coins-conta').hide();
      $('#conta' + conta.id).find('.coins').html('0');
    }

    private aoClicarEmAutenticarConta(e: JQueryEventObject) {
      chrome.runtime.sendMessage(this.idExtensao, { evento: "lcarwp" },
        (resposta: any) => {
          this.autenticando = true;
        });
    }

    private aoSelecionarTipoPrecoCompra(e: JQueryEventObject) {
      if ($(e.target).val() == '1') {
        this.habilitarPrecoFixo(e);
        this.desabilitarPrecoLucro(e);
      } else {
        this.desabilitarPrecoFixo(e);
        this.habilitarPrecoLucro(e);
      }
    }

    private habilitarPrecoFixo(e: JQueryEventObject) {
      this.ehSniperPorPrecoCompra = true
      if (App.SniperExtensao.ehPadrao) {
        App.Util.editarPrecoJogadoresSelecionados = true;
      }
      if (App.Util.editarPrecoJogadoresSelecionados) {
        this.limparCampoJogadores()
      }
      var parent = $(e.target).parents('#conteudoOfertaCompra');
      parent.find('.campo-oferta-preco-min').show();
      parent.find('.campo-oferta-preco-max').show();
      $('#botaoSnipar .bt-text-coins').show();
      $('#botaoSnipar .info-oferta').show();
      $('#botaoSnipar .bt-text-lucro').hide();
      $("#botaoSnipar .bt-text-jogador").hide()
    }

    private desabilitarPrecoFixo(e: JQueryEventObject) {
      this.ehSniperPorPrecoCompra = false
      var parent = $(e.target).parents('#conteudoOfertaCompra');
      parent.find('.campo-oferta-preco-min').hide();
      parent.find('.campo-oferta-preco-max').hide();
      parent.find('input[name=max]').val(200);
      $('#botaoSnipar .info-oferta').html('200');
      $('#botaoSnipar .bt-text-coins').hide();
      $('#botaoSnipar .info-oferta').hide();
      $('#botaoSnipar .bt-text-lucro').show();
    }

    private habilitarPrecoLucro(e: JQueryEventObject) {
      this.ehSniperPorLucro = true
      if (App.Util.editarPrecoJogadoresSelecionados) {
        this.limparCampoJogadores()
      }
      App.Util.editarPrecoJogadoresSelecionados = false
      var parent = $(e.target).parents('#conteudoOfertaCompra');
      parent.find('.conteudo-ofertas-por-lucro').show();
      $('#botaoSnipar .bt-text-coins').hide();
      $('#botaoSnipar .info-oferta').hide();
      $('#botaoSnipar .bt-text-lucro').show();
    }

    private desabilitarPrecoLucro(e: JQueryEventObject) {
      this.ehSniperPorLucro = false
      var parent = $(e.target).parents('#conteudoOfertaCompra');
      parent.find('.conteudo-ofertas-por-lucro').hide();
      $('#botaoSnipar .bt-text-coins').show();
      $('#botaoSnipar .info-oferta').show();
      $('#botaoSnipar .bt-text-lucro').hide();
    }

    private limparCampoJogadores() {
      $("#searchclear").click();
    }

    public comprarItemTransferindoCoins(item: IItemTransferenciaCoins, metodoCallback: any) {
      this.transferenciaDeCoinsEmExecucao = true;
      App.SniperExtensao.exibirLoadingSniperApp('<i class="ni ni-money-coins" title="Transferindo coins"></i>', false, "Comprando...");
      chrome.runtime.sendMessage(this.idExtensao, { evento: "spr", filtro: this.getObjetoFiltroTransferenciaCoins(item), configuracoes: this.getConfiguracoes(), tradeId: item.tradeID, venda: null },
        (resultado: any) => { });
      App.SniperExtensao.arrayLoopIntervalos.push(this.loopBuscarItemTransferenciaCoins = setInterval(() => {
        if (!this.transferenciaDeCoinsEmExecucao) {
          clearInterval(this.loopBuscarItemTransferenciaCoins);
          return;
        }

        chrome.runtime.sendMessage(this.idExtensao, { evento: "spr", filtro: this.getObjetoFiltroTransferenciaCoins(item), configuracoes: this.getConfiguracoes(), tradeId: item.tradeID, venda: null },
          (resultado: any) => { });
      }, 5000));
    }

    private getPlayers(metodoCallback: any) {
      const hoje = new Date();
      const parametroCache = `${hoje.getFullYear()}-${hoje.getMonth() + 1}-${hoje.getDate()}`; // Gera o parâmetro baseado na data atual
      $.getJSON("/players.json", { _: parametroCache }, (data) => {
        App.SniperExtensao.players = data.Players;
        metodoCallback();
      });
    }
    private aoAbrirModalUso(e: JQueryEventObject) {
      $("#infoRisco #gauge").remove();
      $("#gauge").clone().appendTo("#infoRisco");
    }

    private tratarRespostaListagemVenda(resposta: any) {
      if (resposta.hasOwnProperty('mensagem')) {
        switch (resposta.mensagem) {
          case '1':
            this.modo_listagem_status = 2;
            App.Util.ocultarLoadingProcessamento($(".loading-processamento-sniper"));
            break;
          case '2':
            // Recarregar listagem lance novamente
            setTimeout(() => {
              this.modo_listagem_status = 0;
              App.SniperExtensao.elBtSnipar.prop('disabled', false);
              this.exibirLog("info badge-lista-lance-venda", "Finalizou vendas na lista", "<b>" + resposta.quantidade_itens_movidos + " item(s)</b> foram colocados à venda");
              this.atualizarListagens();
              App.SniperExtensao.ocultarLoadingSniperApp();
              App.Util.ocultarLoadingProcessamento($(".loading-processamento-sniper"));
            }, 4000);

            setTimeout(() => {
              this.atualizarListagens();
            }, 10000);
            break;
          case '3':
            this.modo_listagem_status = 0;
            // Recarregar listagem lance novamente
            setTimeout(() => {
              App.SniperExtensao.elBtSnipar.prop('disabled', false);
              this.exibirLog("info badge-lista-lance-venda", "Finalizou vendas na lista", "Algum problema impediu a listagem completa, <b>" + resposta.quantidade_itens_movidos + " item(s)</b> foram colocados à venda");
              this.atualizarListagens();
              App.SniperExtensao.ocultarLoadingSniperApp();
              App.Util.ocultarLoadingProcessamento($(".loading-processamento-sniper"));
            }, 4000);

            setTimeout(() => {
              this.atualizarListagens();
            }, 10000);
            break;
          case '4':
            this.modo_listagem_status = 0;
            this.atualizarListagemClube(resposta.jogadoresClube);

            var datahora = new Date();
            $(".espaco-ultima-informacao-jogadores").show();
            $(".espaco-ultima-informacao-jogadores .datahora-info-jogadores").html(datahora.toLocaleDateString() + " " + datahora.toLocaleTimeString());
            localStorage.setItem(App.SniperExtensao.keyStorageUltimaAtualizacaoJogadoresClube, datahora.toISOString());
            if (resposta.hasOwnProperty('naoAvisar') && resposta.naoAvisar) {
              return;
            }

            toastr.success("A listagem de clube do sistema foi atualizada com itens atuais encontrados em seu clube.", "Escaneamento Concluído!");
            // this.exibirMensagemAlertaSwal("Escaneamento Concluído!", "A listagem de clube do sistema foi atualizada com itens atuais encontrados em seu clube.", "success", "OK", "Fechar", "#2dce89", false);
            setTimeout(() => {
              if (!this.esperandoEscanearElenco) {
                App.SniperExtensao.ocultarLoadingSniperApp();
              }

              $("#botaoIniciarInformacaoJogadoresElenco").html($("#botaoIniciarInformacaoJogadoresElenco").data('textInit'));
              $("#botaoIniciarInformacaoJogadoresElenco").prop('disabled', false);
              App.SniperExtensao.elBtSnipar.prop('disabled', false);
              this.exibirLog("info badge-lista-lance-venda", "Escaneamento Concluído", "Agora a listagem de clube do sistema está atualizada com itens atuais encontrados em seu clube");
              this.esperandoEscanearElenco = false
              // this.inicializarModoCompraElencoDme(false);
            }, 3000);
            break;
          case '5':
            if (resposta.contador <= 0) {
              App.SniperExtensao.ocultarLoadingSniperApp();
              App.Util.exibirLoadingProcessamento($(".loading-processamento-sniper"), 0);
            } else {
              App.Util.alterarLoadingProcessamento($(".loading-processamento-sniper"), Math.round(resposta.contador * 100 / resposta.quantidade_movimentos_possiveis));
            }
            break;
          case '6':
            var item = resposta.item && resposta.item.hasOwnProperty('name') ? resposta.item : null;
            if (item) {
              this.exibirLog("info badge-lista-item-nao-encontrado", "Não encontrado!", `O sistema não conseguiu encontrar <b>${item.name}</b> na lista`);
            } else {
              this.exibirLog("info badge-lista-item-nao-encontrado", "Não encontrado!", "O sistema não conseguiu encontrar seu item na lista");
            }
            break;
        }
      }
    }

    private escanearItensDoClube() {
      let dadosListagem: IListagem = { tipo: 1, acao: 3, venda: null, itens: [] };
      if (this.esperandoEscanearElenco) {
        App.SniperExtensao.exibirLoadingSniperApp('<i class="fas fa-search" title="Escaneando listagem de clube no WebApp"></i>', false, "Escaneando Clube...");
      }
      chrome.runtime.sendMessage(this.idExtensao, { evento: "lstgm", configuracoes: this.getConfiguracoes(), listagem: dadosListagem },
        (resultado: any) => {
          if (resultado.status) {
            $("#botaoIniciarInformacaoJogadoresElenco").prop('disabled', true);
            App.Util.setArrayStorage(App.SniperExtensao.keyStorageListagemClube, []);
            App.SniperExtensao.arrayListaClube = [];
            this.exibirLog("info badge-lista-lance-venda", "Escaneando Itens do Clube", "O Sistema irá escanear e identificar os itens que você possui no clube para listagem de clube do sistema");

            // Fechar modal Lista de Clube

            this.modo_listagem_status = 1;
            App.SniperExtensao.elBtSnipar.prop('disabled', true);
            setTimeout(() => {
              if (this.modo_listagem_status < 2) {
                App.SniperExtensao.ocultarLoadingSniperApp();
                App.SniperExtensao.elBtSnipar.prop('disabled', false);
              }
            }, 7000);
          }
        });
    }

    private exibirAlertaTelaInvisivel() {
      // console.log("ehAppDesktop", App.SniperExtensao.ehAppDesktop);
      // if (App.SniperExtensao.ehAppDesktop || !App.SniperExtensao.sniperAtivo || (App.Util.usuario.configuracao.modo_background && !App.Util.usuario.configuracao.modo_lance)) {
      //     clearInterval(this.loopTelaWebAppInvisivel);
      //     return;
      // }

      // App.SniperExtensao.arrayLoopIntervalos.push(this.loopTelaWebAppInvisivel = setInterval(() => {
      //     App.SniperExtensao.runAudio(5);
      //     if (!swal.isVisible()) {
      //         this.exibirMensagemAlertaSwal("WebApp Minimizado!", "Deixe a tela do seu WebApp <b>visível em primeiro plano</b> para o correto funcionamento do sistema", "warning", "OK", "Fechar", "#2dce89", false);
      //     }
      //     $('.log-webapp-minimizado').remove();
      //     this.exibirLog("danger", "WebApp Minimizado", "Deixe a tela do seu WebApp <b>visível em primeiro plano</b> para o correto funcionamento do sistema", "log-webapp-minimizado");
      // }, 15000));
    }

    private tratarRespostaTela(resposta: any) {
      App.SniperExtensao.webAppVisivel = resposta.status;
      if (resposta.status) {
        clearInterval(this.loopTelaWebAppInvisivel);
        swal.close();
      } else {
        this.exibirAlertaTelaInvisivel();
      }

      this.corrigirDuplicacaoWebApp();
      this.eliminarDuplicacaoPaginaFSW();
    }

    private tratarRespostaClickWebApp(resposta: any) {
      if (this.modo_listagem_status > 0 && !swal.isVisible()) {
        this.pararProcessoDeListagem();
        this.exibirMensagemAlertaSwal("Interação com WEBAPP", "Clicar ou interagir de alguma forma com WEBAPP pode interromper o processo de listagem", "warning", "OK", "Fechar", "#2dce89", false);
      }
    }
    private tratarRespostaFiltroWebApp(resposta: any) {
      if (resposta.hasOwnProperty('filtro')) {
        SalvarFiltro.aplicarFiltroExterno(resposta.filtro);
      }
    }

    private atualizarListagens() {
      let dadosListagem: IListagem = { tipo: 1, acao: 2, venda: null, itens: [] };
      chrome.runtime.sendMessage(this.idExtensao, { evento: "lstgm", configuracoes: this.getConfiguracoes(), listagem: dadosListagem },
        (resultado: any) => {
        });
    }

    private tratarRespostaAtualizarListagens(resposta: any) {
      if (resposta.status) {
        this.atualizarCreditos(resposta);
        if (resposta.hasOwnProperty('itens_lista_nao_atribuidos')) {
          this.atualizarListaObservacao(resposta.itens_lista_nao_atribuidos);
        }
        if (resposta.hasOwnProperty('itens_lista_transferencia')) {
          this.atualizarListaTransferencia(resposta.itens_lista_transferencia);
        }
        if (resposta.hasOwnProperty('itens_lista_observacao_lance')) {
          this.atualizarListaLance(resposta.itens_lista_observacao_lance);
        }
      }
    }

    private tratarRespostPartidas(request: any) {
      if (request.hasOwnProperty('partidas') && request.partidas) {
        this.partidas = request.partidas
        let strpartidas = `${this.partidas.won}-${this.partidas.draw}-${this.partidas.loss}`
        $('.info-partidas').show()
        $('.info-partidas').html(strpartidas)
      }
    }

    private atualizarListaLance(dadosLista: any) {
      App.SniperExtensao.arrayListaLance = this.atualizarArrayListagemComCacheFutbin(dadosLista);
      App.SniperExtensao.quantidadeAtualListaLance = dadosLista.length;
      $('.info-quantidade-lista-lance').html(App.SniperExtensao.quantidadeAtualListaLance.toString());

      let elementoListagemContexto: IContextoListagem = this.getObjListagemContexto(null, this.idListagemLance);
      this.atualizarDadosDataTable(elementoListagemContexto, this.inicializarLista);
      App.SniperExtensao.desabilitarBotaoItensSelecionadosListagem(elementoListagemContexto);

    }

    private atualizarObjetoFutbin(respostaFutBin: IFutbin, itemDataTable: IItemListagem, arrayLista: IItemListagem[]) {
      itemDataTable.futbin = { id: null, preco: null, ultimaAtualizacao: null, dataUltimaBusca: null };
      itemDataTable.futbin.id = respostaFutBin.id;
      itemDataTable.futbin.preco = respostaFutBin.preco;
      itemDataTable.futbin.ultimaAtualizacao = respostaFutBin.ultimaAtualizacao;
      itemDataTable.futbin.dataUltimaBusca = new Date().toISOString();
      itemDataTable.futbin.lucro = respostaFutBin.preco > 0 ? respostaFutBin.preco - ((5 * respostaFutBin.preco) / 100) - itemDataTable.lastSalePrice : 0;
      if (respostaFutBin.preco > 0) {
        itemDataTable.vendaRapida = this.obterVendaRapida(respostaFutBin);
      }
      let indiceArrayLista = App.Util.getIndiceArrayById(arrayLista, itemDataTable.id);
      arrayLista[indiceArrayLista] = itemDataTable;
    }

    private obterVendaRapida(respostaFutBin: IFutbin): IVenda {
      let precoRapido = App.Util.decrementarValorDeFiltro(respostaFutBin.preco);
      precoRapido = App.Util.tratarValorDeFiltro(precoRapido);
      return {
        duracao: 3600,
        valorLanceMinimo: App.Util.tratarValorDeFiltro(App.Util.decrementarValorDeFiltro(precoRapido)),
        valorVenda: precoRapido,
        precoFutbin: false,
        porcentagemMaisBarato: 0,
        precoInteligente: null
      };

    }

    private finalizarBuscaPreco(elementoListagemContexto: IContextoListagem) {
      clearInterval(this.loopBuscaPreco);
      App.SniperExtensao.analisePrecoAtiva = false;
      this.tentandoEncontrarPreco = false;
      App.Util.botaoProcessando(elementoListagemContexto.el.find(".btn-buscar-precos-futbin"), false);
      App.Util.ocultarLoadingProcessamento(elementoListagemContexto.el.find(".loading-processamento"));
    }

    private addItemEmCacheStorageArrayListagem(itemCache: IItemListagem) {
      this.objStorageListagemFutbin = App.Util.getArrayStorage(this.keyStorageListagemFutbin);
      if (this.objStorageListagemFutbin && this.objStorageListagemFutbin.hasOwnProperty('lista') && this.objStorageListagemFutbin.lista.length) {
        this.objStorageListagemFutbin.update_at = new Date().toISOString();
        if (App.Util.arrayExistByResourceId(this.objStorageListagemFutbin.lista, itemCache.resourceId)) {
          let index = App.Util.getIndiceArrayByResourceId(this.objStorageListagemFutbin.lista, itemCache.resourceId);
          this.objStorageListagemFutbin.lista[index] = itemCache;
        } else {
          this.objStorageListagemFutbin.lista.push(itemCache);
        }
      } else {
        this.objStorageListagemFutbin = { update_at: null, lista: [] };
        //para comparar minutos a partir da data inicial
        //getMinutosPassadosPartirDaDataInicial(new Date('2021-01-23T18:51:29.031Z'), new Date());
        this.objStorageListagemFutbin.update_at = new Date().toISOString();
        this.objStorageListagemFutbin.lista.push(itemCache);
      }

      App.Util.setArrayStorage(this.keyStorageListagemFutbin, this.objStorageListagemFutbin);
    }

    private atualizarArrayListagemComCacheFutbin(arrayLista: IItemListagem[]): IItemListagem[] {
      $.each(arrayLista, (index: any, item: IItemListagem) => {
        let objStorageLista: IStorageLista = App.Util.getArrayStorage(this.keyStorageListagemFutbin);
        let itemCache: IItemListagem = null;
        let itemTemCache = objStorageLista && objStorageLista.lista.length > 0 && (itemCache = App.Util.getItemArraySeExistResourceId(objStorageLista.lista, item.resourceId));
        if (itemTemCache) {
          arrayLista[index].futbin = itemCache.futbin;
          arrayLista[index].vendaRapida = itemCache.vendaRapida;
        }
      });

      return arrayLista;
    }
    private atualizarItemListagemComCacheFutbin(itemListagem: IItemListagem): IItemListagem {
      let objStorageLista: IStorageLista = App.Util.getArrayStorage(this.keyStorageListagemFutbin);
      let itemCache: IItemListagem = null;
      let itemTemCache = objStorageLista && objStorageLista.lista.length > 0 && (itemCache = App.Util.getItemArraySeExistResourceId(objStorageLista.lista, itemListagem.resourceId));
      if (itemTemCache) {
        itemListagem.futbin = itemCache.futbin;
        itemListagem.vendaRapida = itemCache.vendaRapida;
      }

      return itemListagem;
    }

    private enviarComandoDeParadaImediata() {
      chrome.runtime.sendMessage(this.idExtensao, { evento: "parimd" }, (resultado: any) => { });
    }

    private copiarFiltroWebApp(e: JQueryEventObject) {
      chrome.runtime.sendMessage(this.idExtensao, { evento: "copfilwpp" }, (resultado: any) => { });
    }

    private static habilitarBotaoItensSelecionadosListagem(elementoListagemContexto: IContextoListagem) {
      elementoListagemContexto.el.find(".btn-venda-listagem").prop('disabled', false);
      elementoListagemContexto.el.find(".btn-venda-rapida").prop('disabled', false);
      elementoListagemContexto.el.find(".btn-vender-selecionados-lista").prop('disabled', false);
      if (elementoListagemContexto.dataTable) {
        elementoListagemContexto.el.find('.itens-selected').html(elementoListagemContexto.dataTable.rows('.selected').data().length);
      } else {
        elementoListagemContexto.el.find('.itens-selected').html('0');
      }
    }

    private static desabilitarBotaoItensSelecionadosListagem(elementoListagemContexto: IContextoListagem) {
      elementoListagemContexto.el.find(".btn-venda-listagem").prop('disabled', true);
      elementoListagemContexto.el.find(".btn-venda-rapida").prop('disabled', true);
      elementoListagemContexto.el.find(".btn-vender-selecionados-lista").prop('disabled', true);
      elementoListagemContexto.el.find('.itens-selected').html('0');
      elementoListagemContexto.el.find('.collapse-venda-lista').collapse('hide');
      if (elementoListagemContexto.dataTable) {
        elementoListagemContexto.dataTable.search('').draw();
      }
    }

    private aoSelecionarDeselecionarTudoListagem(e: JQueryEventObject) {
      let elementoListagemContexto: IContextoListagem = this.getObjListagemContexto(e);
      this.selecionarDescelecionarTudoListagem(elementoListagemContexto);


    }
    private selecionarDescelecionarTudoListagem(elementoListagemContexto: IContextoListagem) {
      if (!elementoListagemContexto.dataTable) {
        return;
      }

      let selecionados = elementoListagemContexto.dataTable.rows('.selected').data().length > 0;
      let filter = selecionados ? null : { filter: 'applied' };
      elementoListagemContexto.dataTable.rows(filter).nodes().toArray().forEach(function (element: any, index: number) {
        if (selecionados) {
          $(element).removeClass('selected');
        } else {
          $(element).toggleClass('selected');
        }
      });

      App.SniperExtensao.processarItensSelecionados(elementoListagemContexto);
    }

    private static processarItensSelecionados(elementoListagemContexto: IContextoListagem) {
      var quantidadeSelecionada = elementoListagemContexto.dataTable.rows('.selected').data().length;
      if (quantidadeSelecionada > 0) {
        App.SniperExtensao.habilitarBotaoItensSelecionadosListagem(elementoListagemContexto);
      } else {
        App.SniperExtensao.desabilitarBotaoItensSelecionadosListagem(elementoListagemContexto);
      }
    }

    private tratarRespostaTempoEsperaLance(resposta: any) {
      if (resposta.status) {
        App.SniperExtensao.exibirLoadingSniperApp('<i class="fas fa-clock"></i>', false, "Aguardando...");
        if (resposta.disputa) {
          this.exibirLog("primary ", "Aguardando Expiração", `Aguardando itens chegar próximo da expiração para iniciar novas disputas. Tempo de espera: ${App.Util.formatDuration(resposta.tempo)}`, "aguardar-expiracao", true);
        } else {
          this.exibirLog("primary ", "Aguardando Expiração", `Aguardando itens ter o tempo de expiração maximo configurado na opção: Tempo expiração Lance. Tempo de espera: ${App.Util.formatDuration(resposta.tempo)}`, "aguardar-expiracao", true);
        }
      }
    }

    private tratarRespostaFiltroInvalidoLance(resposta: any) {
      if (resposta.status) {
        if (!swal.isVisible()) {
          App.SniperExtensao.runAudio(5);
          this.exibirMensagemAlertaSwal("Nenhum resultado!", "O filtro não apresentou resultados, considere aumentar o valor de oferta do lance", "warning", "OK", "Fechar", "#2dce89", false);
        }
      }
    }

    /**
     * Listagens
     */
    private inicializarEventosDataTables() {
      this.elementoBotaoVenderSelecionadosLista.on('click', (e) => { this.aoVenderItensNaLista(e); });
      this.elementoBotaoBtnVendaRapidaLista.on('click', (e) => { this.aoVenderItensNaLista(e, true); });

      this.elementoBotaoBuscarPrecosFutbin.on('click', (e) => { this.aoBuscarPrecosNaLista(e); });
      this.elementoBotaoSelecionarDeselecionarTudoListagem.on('click', (e) => { this.aoSelecionarDeselecionarTudoListagem(e); });
    }

    private inicializarLista(elementoListagemContexto: IContextoListagem, contexto: any): any {
      let listagemDataTable: any = null;
      elementoListagemContexto.el.find(".btn-venda-listagem").prop('disabled', true);
      elementoListagemContexto.el.find(".btn-venda-rapida").prop('disabled', true);
      elementoListagemContexto.el.find(".btn-vender-selecionados-lista").prop('disabled', true);
      if (elementoListagemContexto.arrayListagem.length > 0) {
        listagemDataTable = elementoListagemContexto.elTabela.DataTable({
          language: {
            url: "/datatable-pt-br.json",
            searchPanes: {
              collapse: { 0: 'Filtros', _: 'Filtros Aplicados (%d)' }
            }
          },
          bLengthChange: false,
          bInfo: false,
          searchPanes: {
            viewTotal: true,
            cascadePanes: true,
            columns: [0, 1, 2, 3, 4]
          },
          buttons: [
            'searchPanes'
          ],
          dom: 'Bfrtip',
          data: elementoListagemContexto.arrayListagem,
          createdRow: function (row: any, data: IItemListagem, dataIndex: any) {
            $(row).addClass('type-' + data.type.toString());
          },
          columnDefs: [
            {
              targets: 0,
              searchPanes: {
                show: true,
                header: 'Qualidade',
                options: [
                  {
                    label: 'Bronze',
                    value: function (obj: IItemListagem, rowIdx: any) {
                      return obj.rating < 65;
                    }
                  },
                  {
                    label: 'Prata',
                    value: function (obj: IItemListagem, rowIdx: any) {
                      return obj.rating >= 65 && obj.rating < 75;
                    }
                  },
                  {
                    label: 'Ouro',
                    value: function (obj: IItemListagem, rowIdx: any) {
                      return obj.rating >= 75;
                    }
                  },
                  {
                    label: 'Especial',
                    value: function (obj: IItemListagem, rowIdx: any) {
                      return obj.assetId != obj.resourceId && obj.rareflag >= 3;
                    }
                  },
                  {
                    label: 'Variação',
                    value: function (obj: IItemListagem, rowIdx: any) {
                      return obj.assetId != obj.resourceId;
                    }
                  }
                ]
              },
              render: function (data: any, tipo: any, obj: IItemListagem, meta: any) {
                var qualidade = obj.rating < 65 ? '_1' : (obj.rating < 75 ? '_2' : '_3');
                var ehEspecialRaro = obj.rareflag > 3;
                qualidade = ehEspecialRaro ? '_0' : qualidade;
                var bgCard = "e_" + obj.rareflag + qualidade + ".png";
                var urlFutbin = "";
                var untradeable = obj.untradeable ? '<img src="/img/icons/untradeabled.png" title="inegociável" alt="" style="position:absolute;width: 20px;right: -38px;top: -5px;"/>' : '';
                var divImg = `<div class="playercard-picture"><img src="https://cdn.futnext.com/player/${obj.assetId}.png" /></div>`

                var hidePais = ''
                var hideClube = ''
                if (obj.type != "player") {
                  obj.rating = ""
                  hideClube = 'd-none'
                  hidePais = 'd-none'
                  if (obj._assetId == UtilsEA.ItemCardAssetId.PLAYSTYLE_PLAYER) {
                    divImg = `<div class="playercard-picture" style="left: 24px !important;"><img src="/fut21/Images/Styles/${obj.subtype}.png" /></div>`
                  } else if (obj._assetId == UtilsEA.ItemCardAssetId.POSITION_MODIFIER) {
                    divImg = `<div class="playercard-picture" style="left: 24px !important;"><img src="/images/ico-troca-posicao.png" /></div>`
                  } else if (obj._assetId == UtilsEA.ItemCardAssetId.CONTRACT_PLAYER) {
                    divImg = `<div class="playercard-picture" style="left: 24px !important;"><img src="/fut21/Images/Various/contratos-player.png" /></div>`
                  } else if (obj._assetId == UtilsEA.ItemCardAssetId.CONTRACT_MANAGER) {
                    divImg = `<div class="playercard-picture" style="left: 24px !important;"><img src="/fut21/Images/Various/contratos-manage.png" /></div>`
                  } else {
                    divImg = `<div class="playercard-picture d-none"><img src="/fut21/Images/Styles/${obj.assetId}.png" /></div>`
                  }
                }

                data = '<div data-toggle="tooltip" data-placement="top" title="' + obj.name + '" class="playercard fut21 playercard-s" style="background-image: url(' + "'https://cdn.futnext.com/rarity/" + bgCard + "'" + ');">' +
                  '<div class="playercard-rating">' + obj.rating + ' ' + untradeable + '</div>\n\
                                <div class="playercard-position">' + (obj.hasOwnProperty("preferredPositionNameTraduzido") && obj.preferredPositionNameTraduzido ? obj.preferredPositionNameTraduzido : '') + '</div>\n\
                                <div class="playercard-nation '+ hidePais + '">\n\
                                <img src="https://cdn.futnext.com/nation/'+ obj.nationId + '.png" alt=""></div>\n\
                                <div class="playercard-club '+ hideClube + '"><img src="https://cdn.futnext.com/club/' + obj.teamId + '.png" alt=""></div>\n\
                                <div class="playercard-name"><span class="">' + obj.name + '</span></div>\n\
                                '+ divImg + '\n\
                                <div class="playercard-line playercard-line1"></div><div class="playercard-line playercard-line2">\n\
                                </div><div class="playercard-line playercard-line3"></div>\n\
                                <div class="playercard-line playercard-line4"></div>\n\
                                <div class="playercard-line playercard-line5"></div></div>';
                return data;
              }
            },
            {
              targets: 1,
              searchPanes: {
                show: true,
                header: 'Status',
                options: [
                  {
                    label: 'Negociáveis',
                    value: function (obj: IItemListagem, rowIdx: any) {
                      return !obj.untradeable;
                    }
                  },
                  {
                    label: 'Inegociáveis',
                    value: function (obj: IItemListagem, rowIdx: any) {
                      return obj.untradeable;
                    }
                  },
                  {
                    label: 'Venda Expirada',
                    value: function (obj: IItemListagem, rowIdx: any) {
                      return obj.tradeState == "expired";
                    }
                  },
                  {
                    label: 'Inativo',
                    value: function (obj: IItemListagem, rowIdx: any) {
                      return obj.tradeState == "inactive";
                    }
                  },
                  {
                    label: 'Venda Ativa',
                    value: function (obj: IItemListagem, rowIdx: any) {
                      return obj.tradeState == "active" && obj.bidState == "none";
                    }
                  },
                  {
                    label: 'Lance Ativo',
                    value: function (obj: IItemListagem, rowIdx: any) {
                      return obj.tradeState == "active" && obj.bidState != "none";
                    }
                  },
                  {
                    label: 'Lance Perdido',
                    value: function (obj: IItemListagem, rowIdx: any) {
                      return obj.tradeState == "closed" && obj.bidState == "outbid";
                    }

                  },
                  {
                    label: 'Lance Ganho',
                    value: function (obj: IItemListagem, rowIdx: any) {
                      return obj.tradeState == "closed" && obj.bidState == "highest";
                    }
                  },
                  {
                    label: 'Vendido',
                    value: function (obj: IItemListagem, rowIdx: any) {
                      return obj.tradeState == "closed" && obj.bidState == "none" && obj.state == "invalid";
                    }
                  }
                ],
                preSelect: ['Negociáveis']
              },
              className: "status text-center",
              render: function (data: any, tipo: any, obj: IItemListagem, meta: any) {
                var ehStatusVendido = obj.bidState == "none" && obj.state == "invalid";
                data = App.Util.obterStatusItemNaLista(obj);
                data += '<br /><span style="font-size: 15px;font-weight: 500;"><i class="ni ni-money-coins mr-1" style="color: #f4df76;"></i>' + (ehStatusVendido ? obj.currentBid : obj.lastSalePrice) + '</span>';
                return data;
              }
            },
            {
              targets: 2,
              searchPanes: {
                show: true,
                header: 'Posicao',
                options: UtilsEA.getPosicoesFiltrosDataTable()
              },
              className: "valor_compra text-center",
              render: function (data: any, tipo: any, obj: IItemListagem, meta: any) {
                let precoFutbin = obj.hasOwnProperty('futbin') && obj.futbin && obj.futbin.preco;
                data = precoFutbin ? '<br /><span style="font-size: 15px;font-weight: 500;"><img src="/img/icons/futbin.png" style="width: 15px;"/>&nbsp;' + obj.futbin.preco + '</span>' : '';
                if (precoFutbin) {
                  data += '<br /><span class="text-muted font-size-10" style="">' + obj.futbin.ultimaAtualizacao + '</span>';
                }

                return tipo === 'display' ? data : precoFutbin ? obj.futbin.preco : '-'
              }
            },
            {
              targets: 3,
              searchPanes: {
                show: true,
                header: 'Países',
                options: UtilsEA.getPaisesFiltrosDataTable()
              },
              className: "lucro text-center",
              render: function (data: any, tipo: any, obj: IItemListagem, meta: any) {
                data = '-';
                if (obj.hasOwnProperty('futbin') && obj.futbin && obj.futbin.preco && $.isNumeric(obj.futbin.lucro)) {
                  if (obj.futbin.lucro > 0) {
                    data = '<span class="status bold-600 text-success font-size-16">+' + Math.round(obj.futbin.lucro) + '</span>';
                  } else if (obj.futbin.lucro < 0) {
                    data = '<span class="status bold-600 text-warning font-size-16">' + Math.round(obj.futbin.lucro) + '</span>';
                  } else {
                    data = '<span class="status bold-600">' + Math.round(obj.futbin.lucro) + '</span>';
                  }
                }
                return data;
              }
            },
            {
              targets: 4,
              searchPanes: {
                show: true,
                header: 'Tipo',
                options: [
                  {
                    label: 'Players (Jogadores)',
                    value: function (obj: IItemListagem, rowIdx: any) {
                      return obj.type == "player";
                    }
                  },
                  {
                    label: 'Consumables (Consumíveis)',
                    value: function (obj: IItemListagem, rowIdx: any) {
                      return obj.type == "training";
                    }
                  },
                  {
                    label: 'Contract (Contratos)',
                    value: function (obj: IItemListagem, rowIdx: any) {
                      return obj.type == "contract";
                    }
                  }
                ]
              },
              render: function (data: any, tipo: any, obj: IItemListagem, meta: any) {
                data = '-';
                if (!App.Util.ehItemVendaPermitida(obj)) {
                  return data;
                }

                if (obj.hasOwnProperty('vendaRapida') && obj.hasOwnProperty('futbin') && obj.vendaRapida && obj.futbin && obj.vendaRapida.valorVenda && obj.futbin.preco) {
                  let lucroRapido = $.isNumeric(obj.futbin.lucro) ? obj.vendaRapida.valorVenda - ((5 * obj.vendaRapida.valorVenda) / 100) - obj.lastSalePrice : 0;
                  let strLucro = '';
                  if (lucroRapido > 0) {
                    strLucro = '<span class="btn-inner--icon" style="color: #00ff08;font-size: 10px;">+' + Math.round(lucroRapido) + '</span>';
                  } else if (lucroRapido < 0) {
                    strLucro = '<span class="btn-inner--icon" style="color: #ffb2b2;font-size: 10px;">' + Math.round(lucroRapido) + '</span>';
                  } else {
                    strLucro = '<span class="btn-inner--icon">' + Math.round(lucroRapido) + '</span>';
                  }
                  data = '<button class="btn btn-icon btn-sm btn-primary btn-venda-rapida-row-data-table" data-id-item="' + obj.id + '" type="button">\n\
                                        <i class="ni ni-money-coins mr-0" style="vertical-align: inherit;"></i>\n\
                                        <span class="">'+ obj.vendaRapida.valorVenda + '</span>\n\
                                        '+ strLucro + '\n\
                                        </button>';
                }

                return data;
              }
            },
          ],

        });

        elementoListagemContexto.el.find('.tabela-itens-listagem tbody').on('click', 'td button.btn-venda-rapida-row-data-table', (e) => {
          swal({
            title: "Você confirma a venda?",
            text: "Se confirmar, o sistema colocará esse item em venda pelo preço sugerido de venda rápida",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#deb07e",
            confirmButtonText: "Sim, continuar",
            cancelButtonText: "cancelar",
            closeOnConfirm: true
          }).then((result: any) => {
            if (result.value) {
              contexto.venderItensNaLista(e);
            }
          });
        });

        elementoListagemContexto.el.find('.tabela-itens-listagem tbody').on('click', 'tr', function (e) {
          if ((elementoListagemContexto.dataTable.row(this).data().type == "player" || elementoListagemContexto.dataTable.row(this).data().type == "training" || elementoListagemContexto.dataTable.row(this).data().type == "contract") && !elementoListagemContexto.dataTable.row(this).data().untradeable) {
            if (App.SniperExtensao.analisePrecoAtiva) {
              return;
            }

            $(this).toggleClass('selected');
            App.SniperExtensao.processarItensSelecionados(elementoListagemContexto);
          }
        });
      }

      return listagemDataTable;
    }

    private aoVenderItensNaLista(e: JQueryEventObject, vendaRapidaSelecionados: boolean = false) {
      App.Util.exebirSweetConfirmacao({ evento: e, configuracoes: this.getConfiguracoes(), vendaRapidaSelecionados: vendaRapidaSelecionados, contexto: this }, "Você confirma a venda?", "Se confirmar, o sistema colocará em venda os itens selecionados", "Sim, continuar", this.venderItensNaLista, "#deb07e");
    }

    private venderItensNaLista(e: JQueryEventObject | any, vendaRapidaSelecionados: boolean = false) {
      let contexto = this;
      if (e.hasOwnProperty('evento')) {
        vendaRapidaSelecionados = e.vendaRapidaSelecionados;
        contexto = e.contexto;
        e = e.evento;
      }


      let elementoListagemContexto: IContextoListagem = contexto.getObjListagemContexto(e);

      let dadosListagem: IListagem = null;
      let idItem: any = null;
      /**
       * TEMP
       */
      let vendalimiteValorMaximoItem: number = App.Util.usuario.ehUserTester ? null : 1000000;
      if ($.isNumeric($(e.currentTarget).data('idItem'))) {
        idItem = $(e.currentTarget).data('idItem');
      } else if ($.isNumeric($(e.target).data('idItem'))) {
        idItem = $(e.target).data('idItem');
      } else if ($.isNumeric($(e.currentTarget).find('button.btn-venda-rapida-row-data-table').data('idItem'))) {
        idItem = $(e.currentTarget).find('button.btn-venda-rapida-row-data-table').data('idItem');
      }

      if (vendaRapidaSelecionados) {
        dadosListagem = { tipo: elementoListagemContexto.tipo, acao: 1, venda: null, itens: contexto.getItensListagemVenda(elementoListagemContexto.dataTable), vendalimiteValorMaximoItem: vendalimiteValorMaximoItem };
      } else if (idItem) {
        dadosListagem = { tipo: elementoListagemContexto.tipo, acao: 1, venda: null, itens: [], vendalimiteValorMaximoItem: vendalimiteValorMaximoItem };
        let itemVendaRapida = App.Util.getRowsDataTableByPropriedadeObjeto(elementoListagemContexto.dataTable, "id", idItem);
        dadosListagem.itens.push(itemVendaRapida[0]);
      } else {
        dadosListagem = { tipo: elementoListagemContexto.tipo, acao: 1, venda: contexto.getVendaLista(elementoListagemContexto.el), itens: contexto.getItensListagemVenda(elementoListagemContexto.dataTable), vendalimiteValorMaximoItem: vendalimiteValorMaximoItem };
      }

      chrome.runtime.sendMessage(contexto.idExtensao, { evento: "lstgm", configuracoes: contexto.getConfiguracoes(), listagem: dadosListagem },
        (resultado: any) => {
          if (resultado.status) {
            contexto.exibirLog("info badge-lista-lance-venda", "Iniciou vendas na lista", "Colocando em venda itens da sua <b>lista</b>");

            elementoListagemContexto.el.modal('hide');
            App.SniperExtensao.exibirLoadingSniperApp('<i class="ni ni-cart" title="Vendendo itens na listagem"></i>', false, "Listando...");
            contexto.modo_listagem_status = 1;
            App.SniperExtensao.elBtSnipar.prop('disabled', true);
            setTimeout(() => {
              if (contexto.modo_listagem_status < 2) {
                App.SniperExtensao.ocultarLoadingSniperApp();
                App.SniperExtensao.elBtSnipar.prop('disabled', false);
              }
            }, 7000);
          }
        });
    }

    private atualizarDadosDataTable(elementoListagemContexto: IContextoListagem, metodoInicializacao: any = null) {
      if (elementoListagemContexto.dataTable instanceof $.fn.dataTable.Api) {
        elementoListagemContexto.dataTable.clear().draw();
        elementoListagemContexto.dataTable.rows.add(elementoListagemContexto.arrayListagem); // Add new data
        elementoListagemContexto.dataTable.columns.adjust().draw(); // Redraw the DataTable
      } else if (metodoInicializacao) {
        if (elementoListagemContexto.tipo == this.idListagemLance) {
          App.SniperExtensao.elementoListagemLanceContexto.dataTable = elementoListagemContexto.dataTable = metodoInicializacao(elementoListagemContexto, this);
        }

        if (elementoListagemContexto.tipo == this.idListagemTransferencia) {
          App.SniperExtensao.elementoListagemTransferenciaContexto.dataTable = elementoListagemContexto.dataTable = metodoInicializacao(elementoListagemContexto, this);
        }

        if (elementoListagemContexto.tipo == this.idListagemClube) {
          App.SniperExtensao.elementoListagemClubeContexto.dataTable = elementoListagemContexto.dataTable = metodoInicializacao(elementoListagemContexto, this);
        }
      }
    }

    private aoBuscarPrecosNaLista(e: JQueryEventObject) {
      let elementoListagemContexto: IContextoListagem = this.getObjListagemContexto(e);
      if (!elementoListagemContexto.dataTable) {
        return;
      }
      App.Util.exibirLoadingProcessamento(elementoListagemContexto.el.find(".loading-processamento"), 0);
      App.SniperExtensao.analisePrecoAtiva = true;
      App.Util.botaoProcessando(elementoListagemContexto.el.find(".btn-buscar-precos-futbin"), true);
      var contador = 0;
      var index = 0;
      var quantidadeItens = 0;
      var itensSelecionados = elementoListagemContexto.dataTable.rows('.selected').count() > 0;
      var itensFiltrados = elementoListagemContexto.dataTable.rows({ filter: 'applied' }).count() > 0;
      if (itensSelecionados) {
        quantidadeItens = elementoListagemContexto.dataTable.rows('.selected').count();
      } else if (itensFiltrados) {
        quantidadeItens = elementoListagemContexto.dataTable.rows({ filter: 'applied' }).count();
      } else {
        quantidadeItens = elementoListagemContexto.dataTable.rows().count();

      }
      this.loopBuscaPreco = setInterval(() => {
        try {
          if (this.tentandoEncontrarPreco) {
            return;
          }

          this.tentandoEncontrarPreco = true;

          if (contador == quantidadeItens) {
            this.finalizarBuscaPreco(elementoListagemContexto);
            return;
          }
          index = itensSelecionados ? elementoListagemContexto.dataTable.rows('.selected').indexes()[contador] : (itensFiltrados ? elementoListagemContexto.dataTable.rows({ filter: 'applied' }).indexes()[contador] : contador);
          var item: IItemListagem = elementoListagemContexto.dataTable.row(index).data();
          if (item.type != "player" || item.untradeable) {
            contador++;
            this.tentandoEncontrarPreco = false;
            return;
          }

          this.executarBuscaFutBin(elementoListagemContexto.dataTable, index, item, elementoListagemContexto.arrayListagem);
          App.Util.alterarLoadingProcessamento(elementoListagemContexto.el.find(".loading-processamento"), Math.round((contador + 1) * 100 / quantidadeItens));
          contador++;
        } catch (e) {
          this.finalizarBuscaPreco(elementoListagemContexto);
          console.log(e);
        }
      }, 2000);

      App.SniperExtensao.arrayLoopTentativas.push(this.loopBuscaPreco);
    }

    private executarBuscaFutBin(dataTable: any, index: number, itemDataTable: IItemListagem, arrayLista: IItemListagem[]) {
      let contextoDataTableRow = App.Util.getRowsDataTableByPropriedadeObjeto(dataTable, "id", itemDataTable.id)

      if (contextoDataTableRow.length <= 0) {
        this.tentandoEncontrarPreco = false;
        return;
      }

      $(dataTable.row(index).node()).addClass('loading');
      itemDataTable.statusListagem = "busca";
      dataTable.row(index).data(itemDataTable).draw();
      try {
        let objStorageLista: IStorageLista = App.Util.getArrayStorage(this.keyStorageListagemFutbin);
        let item: IItemListagem = objStorageLista && objStorageLista.lista.length > 0 ? App.Util.getItemArraySeExistResourceId(objStorageLista.lista, itemDataTable.resourceId) : null;
        let itemTemCacheValido = item && item.futbin && item.futbin.preco && item.futbin.dataUltimaBusca && (App.Util.getMinutosPassadosPartirDaDataInicial(new Date(item.futbin.dataUltimaBusca), new Date()) < 5);
        if (itemTemCacheValido) {
          this.atualizarObjetoFutbin(item.futbin, itemDataTable, arrayLista);
          itemDataTable.statusListagem = null;
          dataTable.row(index).data(itemDataTable).draw();
          this.tentandoEncontrarPreco = false;
          $(dataTable.row(index).node()).removeClass('loading');
        } else {
          let nomeJogador = itemDataTable && itemDataTable.name ? itemDataTable.name : null;
          chrome.runtime.sendMessage(this.idExtensao, {
            evento: "bpftb",
            idJogador: itemDataTable.resourceId,
            platform: App.SniperExtensao.dadosContaEa.ptf,
            nomeJogador: nomeJogador,
            termo: nomeJogador,
            filtroBusca: {
              name: nomeJogador,
              termo: nomeJogador,
              rating: itemDataTable.rating,
              rareflag: itemDataTable.rareflag,
              teamId: itemDataTable.teamId,
              assetId: itemDataTable.assetId,
              resourceId: itemDataTable.resourceId
            }
          },
            (resultado: any) => {
              let respostaPreco = resultado && resultado.response ? resultado.response : null;
              if (resultado && resultado.status && respostaPreco && respostaPreco.preco) {
                this.atualizarObjetoFutbin(respostaPreco, itemDataTable, arrayLista);
                this.addItemEmCacheStorageArrayListagem(itemDataTable);
              } else {
                itemDataTable.futbin = null
              }
              itemDataTable.statusListagem = null;
              dataTable.row(index).data(itemDataTable).draw();
              this.tentandoEncontrarPreco = false;
              $(dataTable.row(index).node()).removeClass('loading');
            });
        }
      } catch (e) {
        console.log(e);
        this.tentandoEncontrarPreco = false;
        itemDataTable.statusListagem = null;
        dataTable.row(index).data(itemDataTable).draw();
        $(dataTable.row(index).node()).removeClass('loading');
      }
    }
    private atualizarIconeLoadingTentativasSniper(classe: string, info: string = '') {
      $('.tentativas').html('<i class="' + classe + '" title="' + info + '"></i>');
    }

    private arrayForEachVelocidadeRandomica(array: any, arrayLoopTimeout: any, metodoCallback: any, objRangeMilisecRand = { min: 500, max: 4000 }) {
      let milisecAnterior = 0;
      array.forEach((element: any, index: number) => {
        arrayLoopTimeout.push(setTimeout(() => {
          metodoCallback(element, index);
          if (index == (array.length - 1)) {
            arrayLoopTimeout = this.clearArrayLoopTimeout(arrayLoopTimeout);
          }
        }, milisecAnterior = (milisecAnterior + App.Util.getRandomInt(objRangeMilisecRand.min, objRangeMilisecRand.max))));
      });
    }

    private clearArrayLoopTimeout(arrayLoopTimeout: any): any {
      for (var i = 0; i < arrayLoopTimeout.length; i++) {
        clearTimeout(arrayLoopTimeout[i]);
      }
      return [];
    }



    private resolverCaptcha() {
      if (App.SniperExtensao.resolvendoCaptcha) {
        return;
      }
      App.SniperExtensao.resolvendoCaptcha = true;
      this.exibirLog("primary badge-resolvedor-captcha", "Resolvedor de Captcha Iniciado!", "O sistema iniciou a tentativa de resolução de captcha automático");

      chrome.runtime.sendMessage(this.idExtensao, { evento: "rsvcptch", configuracoes: this.getConfiguracoes(), dadosSolucaoCaptcha: App.Util.usuario.configuracaoConta.anticaptcha },
        (resultado: any) => {
        });
    }

    private tratarRespostaSolucaoCaptcha(resposta: any) {
      if (resposta.status) {
        switch (resposta.mensagem) {
          case "3":
            this.exibirLog("success", "Captcha resolvido!", "O sistema resolveu seu captcha automaticamente");
            break;
        }
      } else {
        this.pararTudo();
        if (resposta.fecharWebApp) {
          this.fecharWebApp();
        }
        switch (resposta.mensagem) {
          case "1":
            this.exibirLog("danger", "Captcha não resolvido!", "Os dados de sua API de resolução de captcha parecem incorretos");
            break;
          case "2":
          case "4":
            this.exibirLog("danger", "Captcha não resolvido!", "Um erro ocorreu e o captcha não será resolvido automaticamente");
            break;
        }
      }
    }

    private continuarAposCaptcha() {
      // Continuar Snipando
      if (App.SniperExtensao.resolvendoCaptcha) {
        setTimeout(() => {
          App.SniperExtensao.resolvendoCaptcha = false;
        }, 8000)
      }
    }

    private continuarAposCarregamentoWebApp() {
      // Continuar Snipando
      if (App.SniperExtensao.recarregandoWebApp) {
        clearTimeout(App.SniperExtensao.timeoutTempoEsperaRecarregandoWebApp)
        setTimeout(() => {
          App.SniperExtensao.recarregandoWebApp = false;
          if (this.alertaErroConexao) {
            this.ocultarAlertaErroConexao()
          }

          if (App.SniperExtensao.sniperAtivo) {
            this.exibirLog("primary", "Continuando", "Continuando o sniper após carregamento do WebApp", "log-webapp-erro-conexao");
          }

        }, 4000)
      }
    }

    private getConfiguracoes() {
      App.Util.usuario.configuracaoConta.modo_lance = App.SniperExtensao.ehLance;
      App.Util.usuario.configuracaoConta.transferencia_coins = App.SniperExtensao.ehVendaCoins;
      return App.Util.usuario.configuracaoConta
    }

    private calcularLucroFiltroAtual(compra: any, venda: any) {
      var imposto = venda.valorVenda * 0.05;
      var valorNaTela = this.seletorLucroAtual.innerHTML.replace(".", "").replace(".", "");
      var lucroTela = parseFloat(valorNaTela);
      var lucro = (venda.valorVenda - imposto) - compra.currentBid;
      var lucroAcumulado = lucro + lucroTela;
      this.seletorLucroAtual.textContent = "";
      this.seletorEspacoLucro.prepend("" + lucroAcumulado.toFixed(0).replace(".", "").replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'));
    }

    private aoAtivarVendaLucroEstimado(mostrar: boolean) {
      if (mostrar) {
        $("#areaLucroEstimado").show();
      }
      this.seletorLucroAtual.textContent = "";
      this.seletorEspacoLucro.prepend("0");
    }

    private limparHistoricoLucro() {
      let limit = 7;
      let historico: any = {};
      for (const index of Object.keys(this.historicoLucro).reverse()) {
        if (Object.keys(historico).length < limit) {
          historico[index] = this.historicoLucro[index];
        }
      }
      this.historicoLucro = {};
      for (const index of Object.keys(historico).reverse()) {
        this.historicoLucro[index] = historico[index];
      }

      App.Util.setArrayStorage('historico_Lucro' + "_" + this.objConfiguracoesConta.idContaEa, this.historicoLucro);
    }

    private iniciarFuncionalidadeLucro() {
      let keyDataDiaConta = new Date().toLocaleDateString();
      this.historicoLucro = this.getHistoricoLucro();
      let objLucroDia = null;
      if (this.historicoLucro) {
        this.limparHistoricoLucro();
        objLucroDia = this.historicoLucro[keyDataDiaConta];
      }
      let temObjLucroDiario = objLucroDia != null && objLucroDia.hasOwnProperty('saldo');

      //Atualizando os creditos salvos localStorage na extensao
      chrome.runtime.sendMessage(this.idExtensao, { evento: "setsaldo", update: temObjLucroDiario, saldo: temObjLucroDiario ? objLucroDia.saldo : null, idConta: this.objConfiguracoesConta.idContaEa },
        (resposta: any) => {
          if (resposta.creditos == null) {
            resposta.creditos = App.SniperExtensao.dadosContaEa.coins;
          }

          this.iniciarHistoricoLucro((resposta.saldo ? resposta.saldo : resposta.creditos), 0)
          this.updateLucro(resposta.creditos);
          this.iniciarEstatisticasLucro();
        })
    }

    private iniciarHistoricoLucro(creditos: number, lucro: number) {
      let keyDataDiaConta = new Date().toLocaleDateString();
      this.historicoLucro[keyDataDiaConta] = { saldo: creditos, lucro: lucro };
      App.Util.setArrayStorage('historico_Lucro' + "_" + this.objConfiguracoesConta.idContaEa, this.historicoLucro);
    }



    private getHistoricoLucro() {
      let historico = App.Util.getArrayStorage('historico_Lucro' + "_" + this.objConfiguracoesConta.idContaEa);
      return historico ? historico : {};
    }

    private updateLucro(creditos: number) {
      let lucro = 0;
      let keyDataDiaConta = new Date().toLocaleDateString();
      this.historicoLucro = this.getHistoricoLucro();
      let objLucroDia = this.historicoLucro[keyDataDiaConta];
      lucro = creditos - objLucroDia.saldo;

      this.historicoLucro[keyDataDiaConta].lucro = lucro;
      App.Util.setArrayStorage('historico_Lucro' + "_" + this.objConfiguracoesConta.idContaEa, this.historicoLucro);

      this.updateViewLucro(lucro);
    }
    private updateViewLucro(lucro: number, el: JQuery = $(".info-lucro")) {
      let simbolo = '<i class="fas fa-arrow-up text-success mr-1"></i>'
      if (lucro == 0) {
        simbolo = '<i class="fas fa-arrow-up text-white mr-1"></i>'
      } else if (lucro < 0) {
        simbolo = '<i class="fas fa-arrow-down text-danger mr-1"></i>'
      }
      el.html(simbolo + lucro.toLocaleString('pt-BR'))
    }
    private iniciarEstatisticasLucro() {
      this.historicoLucro = this.getHistoricoLucro();
      if (!Object.keys(this.historicoLucro).length) {
        return;
      }

      let labels = [];
      let dados = [];
      let backgroundColors = [];
      let total: any = 0;
      let media: any = 0;
      for (const key in this.historicoLucro) {
        let lucroHist = this.historicoLucro[key].lucro;
        total += lucroHist
        labels.push(key)
        dados.push(this.historicoLucro[key].lucro)
        if (lucroHist < 0) {
          backgroundColors.push("#f7446a94")
        } else {
          backgroundColors.push("#55f1cd9c")
        }
      }
      media = total / Object.keys(this.historicoLucro).length
      this.updateViewLucro(parseInt(total), $('.info-total-lucro'));
      this.updateViewLucro(parseInt(media), $('.info-media-lucro'));

      var chartJsLucro = new ChartJs();
      const data = {
        labels: labels,
        datasets: [{
          label: 'Lucro',
          data: dados,
          backgroundColor: backgroundColors,
          borderColor: backgroundColors,
          borderWidth: 0
        }]
      };


      chartJsLucro.inicializarCampo("graficoEstatisticasLucro", data, "Lucro Diário");
    }

    private montarElencoDme() {
      if (!App.Util.elencoDme.idCategoriaSbc) {
        return;
      }

      App.SniperExtensao.exibirLoadingSniperApp('<i class="far fa-clone"></i>', false, "Montando Elenco...");
      this.exibirLog("info info-enviou-clube", "Montagem de Elenco Inciada", "Os jogadores serão adicionados em suas respectivas posições no DME, em caso de jogador não encontrado, o jogador de conceito será utilizado.");
      let objMontarDme = { evento: 'mteldme', idCategoria: App.Util.elencoDme.idCategoriaSbc, id: App.Util.elencoDme.idSbc, elenco: App.Util.elencoDme.elenco };
      chrome.runtime.sendMessage(this.idExtensao, objMontarDme,
        (resultado: any) => {
          this.loopTimeoutMontarDme = setTimeout(() => {
            App.SniperExtensao.ocultarLoadingSniperApp();
            this.exibirMensagemAlertaSwal("Não Concluído!", "DME não encontrado, recarregue o WebApp e confira se o DME ainda está ativo ou já foi resolvido e tente novamente, se não for esses os motivos, entre em contato com nossa equipe por e-mail: contato@futsniperweb.com.br", "warning", "OK", "Fechar", "#2dce89", false);
          }, 30000)
        });
    }

    private tratarRespostaMontagemDme(resposta: any) {
      if (resposta.status) {
        if (resposta.hasOwnProperty('mensagem')) {
          switch (resposta.mensagem) {
            case '1':
              App.SniperExtensao.ocultarLoadingSniperApp();
              this.exibirMensagemAlertaSwal("Montagem Concluída!", "Seu Dme foi montado com sucesso, talvez seja necessário ajustar alguma posição caso o requisito de entrosamento esteja insuficiente.", "success", "OK", "Fechar", "#2dce89", false);
              this.exibirLog("success", "Montagem Concluída!", "Seu Dme foi montado com sucesso, talvez seja necessário ajustar alguma posição caso o requisito de entrosamento esteja insuficiente.", "montagem-concluida", true);
              break;
            case '2':
              App.SniperExtensao.ocultarLoadingSniperApp();
              this.exibirMensagemAlertaSwal("Montagem Concluída!", "Seu Dme foi montado com sucesso, a utilização de jogadores de conceito foi necessária e talvez seja necessário ajustar alguma posição caso o requisito de entrosamento esteja insuficiente.", "success", "OK", "Fechar", "#2dce89", false);
              this.exibirLog("success", "Montagem Concluída!", "Seu Dme foi montado com sucesso, a utilização de jogadores de conceito foi necessária e talvez seja necessário ajustar alguma posição caso o requisito de entrosamento esteja insuficiente.", "montagem-concluida", true);
              break;
            case '3':
              clearTimeout(this.loopTimeoutMontarDme)
              this.loopTimeoutMontarDme = null;
              break;
          }
        }
      } else {

        if (resposta.hasOwnProperty('mensagem')) {
          switch (resposta.mensagem) {
            case '4':
              App.SniperExtensao.ocultarLoadingSniperApp();
              this.exibirMensagemAlertaSwal("SBC/DME não encontrado!", "Não encontramos o SBC/DME correspondente ao link de elenco informado em seu WebApp, tente recarregar o WebApp e verifique diretamente se esse DME/SBC está disponível para soluciona-lo no momento, se estiver disponível, tente novamente.", "warning", "OK", "Fechar", "#2dce89", false);
              this.exibirLog("warning", "SBC/DME não encontrado!", "Não encontramos o SBC/DME correspondente ao link de elenco informado em seu WebApp, tente recarregar o WebApp e verifique diretamente se esse DME/SBC está disponível para soluciona-lo no momento, se estiver disponível, tente novamente.", "montagem-nao-concluida", true);
              break;
            default:
              App.SniperExtensao.ocultarLoadingSniperApp();
              this.exibirMensagemAlertaSwal("Montagem não Concluída!", "Um problema ocorreu e a montagem do DME não pode ser concluída, tente novamente, se o problema continuar entre em contato com nossa equipe por e-mail: contato@futsniperweb.com.br", "warning", "OK", "Fechar", "#2dce89", false);
              this.exibirLog("warning", "Montagem não Concluída!", "Um problema ocorreu e a montagem do DME não pode ser concluída, tente novamente, se o problema continuar entre em contato com nossa equipe por e-mail: contato@futsniperweb.com.br", "montagem-nao-concluida", true);
              break;
          }
        } else {
          App.SniperExtensao.ocultarLoadingSniperApp();
          this.exibirMensagemAlertaSwal("Montagem não Concluída!", "Um problema ocorreu e a montagem do DME não pode ser concluída, tente novamente, se o problema continuar entre em contato com nossa equipe por e-mail: contato@futsniperweb.com.br", "warning", "OK", "Fechar", "#2dce89", false);
          this.exibirLog("warning", "Montagem não Concluída!", "Um problema ocorreu e a montagem do DME não pode ser concluída, tente novamente, se o problema continuar entre em contato com nossa equipe por e-mail: contato@futsniperweb.com.br", "montagem-nao-concluida", true);
        }

      }
    }


    private getHistoricoDmesImportados() {
      return this.storageLocal.getArrayItensOrItem(this.chaveStorageHistoricoDme)
    }

    private addItemHistoricoDmesImportados(ItensOuItem: any) {
      this.storageLocal.updateOrCreateArrayItens(this.chaveStorageHistoricoDme, ItensOuItem, "idSbc")
    }

    private carregarListaHistoricoImportacaoDme() {
      let arrHist = this.getHistoricoDmesImportados();

      if (arrHist.length) {
        let spanHistorico = "";
        arrHist = arrHist.slice(-5);
        this.storageLocal.updateOrCreateArrayItens(this.chaveStorageHistoricoDme, arrHist, "idSbc")
        arrHist.reverse().forEach((dme: IItemDmeImportado, index: number) => {
          let virgula = index > 0 ? ', ' : '';
          spanHistorico += `${virgula}<a class="text-link font-size-10" title="${dme.idSbc}" target="_blank" href="${dme.url}">${dme.nomeSbc}</a>`
        });
        $('.label-historico-dme-import').show()
        $('.historico-dme-import').html(spanHistorico)
      } else {
        $('.label-historico-dme-import').hide()
        $('.historico-dme-import').html('')
      }

    }

    private intercalarTelaWebAppSniper(delay: number = 2000) {
      if (!$(".sniper-page").hasClass('sniper-mobile')) {
        return;
      }
      // “pulso único” opcional (compat com seu request.delay antigo)
      chrome.runtime.sendMessage(this.idExtensao, { type: 'tabs:intercalar:pulse', delay: 2000 }, (r: any) => console.log('pulse intercalarTelaWebAppSniper', r));
    }

    private ligarRotinaIntercalarAbaChrome(delay: number = 2000) {
      try {
        if (!$(".sniper-page").hasClass('sniper-mobile')) {
          return;
        }
        chrome.runtime.sendMessage(this.idExtensao, { type: 'tabs:intercalar:start' }, (r: any) => console.log('start intercalar abas', r));
      } catch (error) {
        console.log(error);
      }
    }

    private desligarRotinaIntercalarAbaChrome(delay: number = 2000) {
      try {
        chrome.runtime.sendMessage(this.idExtensao, { type: 'tabs:intercalar:stop' }, (r: any) => console.log('stop intercalar abas', r));
      } catch (error) {
        console.log(error);
      }
    }

    public contagemRegressiva() {
      var minuto = $(".minuto")
      var segundo = $(".segundo")
      if (parseInt(minuto.text()) == 3) {
        var intervalo = setInterval(function () {
          var minuto_atual = parseInt(minuto.text());
          var segundo_atual = parseInt(segundo.text());
          if (segundo_atual == 0) {
            segundo.text("59")
            if (minuto_atual == 0) {
              minuto.text("0")
              segundo.text("00")
              clearInterval(intervalo);
            } else {
              minuto.text(minuto_atual - 1);
            }

          } else {
            if (segundo_atual <= 10) {
              segundo.text("0" + (segundo_atual - 1));
            } else {
              segundo.text(segundo_atual - 1);
            }
          }
        }, 1000);
      }
    }

    private calculadora(e: JQueryEventObject) {
      let taxaEA = this.calcValor.val() * 0.05;
      let compreAte = this.calcValor.val() - this.calcValorDesejadoPorCarta.val() - taxaEA;
      let taxaEAFormatado = taxaEA.toLocaleString('pt-BR').toString();
      let compreAteFormatado = compreAte.toLocaleString('pt-BR').toString();
      $("#calcTaxaEa").html(taxaEAFormatado);
      $("#calcCompreAte").html(compreAteFormatado);
      compreAte > 0 ? $("#calcCompreAte").css('background-color', '#77f397') : $("#calcCompreAte").css('background-color', '#f37790');
      compreAte == 0 ? $("#calcCompreAte").css('background-color', '') : "";
    }

    private estimarLucro() {
      if (this.ehSniperPorLucro && !App.Util.ehCampoTextoVazio(this.elCampoJogador) && $.isArray(this.elCampoJogador.val()) && this.elCampoJogador.val().length > 1) {
        swal("Obrigatório!", "No filtro por lucro por enquanto é permitido no máximo 1 jogador no campo de jogadores.", "warning");
        return;
      }

      chrome.runtime.sendMessage(this.idExtensao, {
        evento: "slucro",
        filtro: this.getObjetoFiltros(null, App.SniperExtensao.elFormCompra),
        sniperPorLucro: parseInt(App.SniperExtensao.elFormCompra.find('input[name=lucro]').val())
      }, (resultado: any) => { });
    }

    private closeAlertCookieBrowser() {
      this.ajax = new App.Ajax();
      this.ajax.postAcaoSemResposta(App.Util.config.urlSaveCookie, { cookie: 'fsw_cookie_alert_browser' });
    }

    private getPrecoOfertaJogador(id: number, pegarAtualizadoDoStorage: boolean = true): { id: number, oferta: number } {
      if (!App.Util.editarPrecoJogadoresSelecionados) {
        return null;
      }
      if (pegarAtualizadoDoStorage) {
        this.arrayJogadoresOfertaCompra = JSON.parse(window.localStorage.getItem('jogadores_oferta_compra')) || [];
      }

      return App.Util.getItemArrayById(this.arrayJogadoresOfertaCompra, id, null);
    }

    private addPrecoOfertaJogador(id: number, oferta: number): { id: number, oferta: number } {
      if (!App.Util.editarPrecoJogadoresSelecionados) {
        return null;
      }

      this.arrayJogadoresOfertaCompra = JSON.parse(window.localStorage.getItem('jogadores_oferta_compra')) || [];
      let objJogador = { id: id, oferta: oferta }
      this.arrayJogadoresOfertaCompra = App.Util.updateOrCreateItemArrayById(this.arrayJogadoresOfertaCompra, id, objJogador);
      window.localStorage.setItem('jogadores_oferta_compra', JSON.stringify(this.arrayJogadoresOfertaCompra));
      return objJogador;
    }

    public static aoEditarOfertaCompraJogador(e: JQueryEventObject) {
      let modalEditPrecoCompraJogador = $('#modalEditValorOfertaJogador')
      let elementoContainerJogador = $(e.currentTarget).parents('.container-jogador')
      let id = elementoContainerJogador.data('idItem')
      let precoCompra = elementoContainerJogador.find(`input[name=oferta_jogador_${id}]`).val()
      let campoPrecoCompra = modalEditPrecoCompraJogador.find('input[name=valor_oferta_jogador]')
      campoPrecoCompra.data('id', id)
      campoPrecoCompra.attr('data-id', id)
      campoPrecoCompra.val(precoCompra)
      modalEditPrecoCompraJogador.find('.espaco-nome-jogador').html('')
      let cloneContainerJogador = elementoContainerJogador.clone()
      cloneContainerJogador.find('.btn-edit-valor-oferta-jogador').remove()
      modalEditPrecoCompraJogador.find('.espaco-nome-jogador').append(cloneContainerJogador)
      modalEditPrecoCompraJogador.modal('show')
    }

    private aoAlterarIputOfertaCompraJogador(e: JQueryEventObject) {
      let ofertaCompra = App.Util.obterInteiroDaString($(e.currentTarget).val())
      ofertaCompra = ofertaCompra && ofertaCompra >= 200 ? App.Util.tratarValorDeFiltro(ofertaCompra) : 200
      let id = $(e.currentTarget).data('id')
      let elementoItemJogador = $(`#item${id}`)

      let objOfertaCompraJogador = this.addPrecoOfertaJogador(id, ofertaCompra)
      elementoItemJogador.find('.label-valor-oferta-jogador').html(objOfertaCompraJogador.oferta.toString())
      elementoItemJogador.find(`input[name=oferta_jogador_${id}]`).val(objOfertaCompraJogador.oferta)

    }

    private getValorCampoInputPrecoSeExistir(maskedDefId: number, ofertaAtual: number) {
      let inputValorOfertaJogador = $(`input[name=oferta_jogador_${maskedDefId}]`)
      if (inputValorOfertaJogador.length) {
        let ofertaCompra = App.Util.obterInteiroDaString(inputValorOfertaJogador.val())
        ofertaCompra = ofertaCompra && ofertaCompra >= 200 ? App.Util.tratarValorDeFiltro(ofertaCompra) : 200
        return ofertaCompra
      } else {
        return ofertaAtual;
      }
    }

    private getValorOfertaPersonalizadoDoJogador(maskedDefId: number, ofertaAtual: number) {
      if (App.Util.editarPrecoJogadoresSelecionados && maskedDefId) {
        let precoOfertaJogador = this.getPrecoOfertaJogador(maskedDefId)
        if (precoOfertaJogador && precoOfertaJogador.oferta && $.isNumeric(precoOfertaJogador.oferta)) {
          return precoOfertaJogador.oferta;
        } else {
          return this.getValorCampoInputPrecoSeExistir(maskedDefId, ofertaAtual)
        }
      }

      return ofertaAtual;
    }

    private aoAlterarLimiteCompra(e: JQueryEventObject) {
      $('.info-limite-compra').html($(e.target).val());
    }

    private getObjEstatisticaTempoUso(tempoExecucaoSegundos: number): { label?: string, labelAbreviado?: string, limite?: number, tempo?: number, percent?: number, color: string } {
      var estatisticasTempoExecucao: { label?: string, labelAbreviado?: string, limite?: number, tempo?: number, percent?: number, color: string } = { color: '#00e673' }
      if (tempoExecucaoSegundos < 3600) {
        estatisticasTempoExecucao.labelAbreviado = "min";
        estatisticasTempoExecucao.label = "minutos";
        estatisticasTempoExecucao.limite = this.gerenciamentoRiscoInfos.limiteUsoEmMinutos;
        estatisticasTempoExecucao.tempo = App.Util.parseSegundosParaMinutos(tempoExecucaoSegundos);
      } else {
        estatisticasTempoExecucao.labelAbreviado = "h";
        estatisticasTempoExecucao.label = "horas";
        estatisticasTempoExecucao.limite = this.gerenciamentoRiscoInfos.limiteUsoEmHoras;
        estatisticasTempoExecucao.tempo = App.Util.parseSegundosParaHoras(tempoExecucaoSegundos);
      }

      return estatisticasTempoExecucao;
    }

    private getInfoObjetivosRivals(callback: any = null) {
      chrome.runtime.sendMessage(this.idExtensao, { evento: 'getinfrvals', idConta: this.objConfiguracoesConta.idContaEa },
        (resultado: any) => {
          if (resultado.status) {
            this.ajustarLimitesGerenciamentoRisco(resultado)
          }
          if (callback) {
            callback()
          }
        })
    }

    private inicializarEstatisticas() {
      this.getInfoObjetivosRivals(() => {

        if (App.Util.existeElementoNaPagina($("#ggEstatisticaRequests"))) {
          this.estatisticasRequests = new TermometroJustGage().inicializarCampo("ggEstatisticaRequests", 0, "Solicit.", 0, 1000, (val: any) => { return val }, { percents: true, ranges: [{ color: "#00e673", lo: 0, hi: 75 }, { color: "#ffff00", lo: 76, hi: 95 }, { color: "#ff1a1a", lo: 96, hi: 100 }] });
        }
        if (App.Util.existeElementoNaPagina($("#ggEstatisticaTempoUso"))) {
          this.estatisticaTempoUso = new TermometroJustGage().inicializarCampo("ggEstatisticaTempoUso", 0, "Tempo", 0, 2, (val: any) => { return val }, { percents: true, ranges: [{ color: "#00e673", lo: 0, hi: 75 }, { color: "#ffff00", lo: 76, hi: 95 }, { color: "#ff1a1a", lo: 96, hi: 100 }] });
        }

        this.atualizarEstatisticas();
      })
    }

    private sincronizarEstatisticasContaComBaseDados(callback: any = null) {
      let chave = `${this.chaveStorageEstatisticasPrefix}${this.objConfiguracoesConta.idContaEa}`;
      App.Util.limparEstatisticas(chave)
      let keyDataDia = App.Util.getDateStringInternacional()
      this.ajax.get(App.Util.config.urlObterEstatisticasConta, { id_conta_ea: this.objConfiguracoesConta.idContaEa, dia: keyDataDia }, (resp: { dadosRetornados: { status: boolean, estatisticas: IEstatisticasContaDataBase } }) => {
        if (resp.dadosRetornados.status) {
          let baseEstatisticasAtuais: any = JSON.parse(localStorage.getItem(chave)) || null;
          if (!baseEstatisticasAtuais || !baseEstatisticasAtuais[keyDataDia] || baseEstatisticasAtuais[keyDataDia].requests < resp.dadosRetornados.estatisticas.requests) {
            baseEstatisticasAtuais = baseEstatisticasAtuais || {}
            baseEstatisticasAtuais[keyDataDia] = { compras: resp.dadosRetornados.estatisticas.compras, buscas: resp.dadosRetornados.estatisticas.buscas, captchas: resp.dadosRetornados.estatisticas.captchas, softbans: resp.dadosRetornados.estatisticas.softbans, requests: resp.dadosRetornados.estatisticas.requests, tempo: resp.dadosRetornados.estatisticas.tempo };
            localStorage.setItem(chave, JSON.stringify(baseEstatisticasAtuais));
          }
        }
        if (callback) {
          callback()
        }
      });
    }

    private getEstatisticasFormatada(): { compras: number, buscas: number, captchas: number, softbans: number, requests: number, tempo: number } {
      let objEstatisticas = App.Util.getEstatisticasDoDia(`${this.chaveStorageEstatisticasPrefix}${this.objConfiguracoesConta.idContaEa}`) || {}
      let estatisticasFormatada = { compras: objEstatisticas.compras || 0, buscas: objEstatisticas.buscas || 0, captchas: objEstatisticas.captchas || 0, softbans: objEstatisticas.softbans || 0, requests: objEstatisticas.requests || 0, tempo: objEstatisticas.tempo || 0 }
      return estatisticasFormatada;
    }

    private atualizarEstatisticas() {
      try {
        let objEstatisticas = this.getEstatisticasFormatada()
        this.estatisticasRequests.refresh(objEstatisticas.requests, this.gerenciamentoRiscoInfos.limiteRequests);
        let estatisticaTUso = this.getObjEstatisticaTempoUso(objEstatisticas.tempo || 0)
        this.estatisticaTempoUso.refresh(estatisticaTUso.tempo, estatisticaTUso.limite, 0, estatisticaTUso.labelAbreviado);
      } catch (e) {
        console.log("ERROR atualizarEstatisticas", e)
      }
    }

    private async salvarTempoExecucao() {
      try {
        let segundosCorridosExecucao = this.ultimaAtualizacaoTempoExecucao ? parseInt((Util.getSecondsBetweenDates(this.ultimaAtualizacaoTempoExecucao, new Date()) as any)) : 0;
        if (segundosCorridosExecucao > 0 && segundosCorridosExecucao <= 40) {
          return;
        }

        App.Util.incrementEstatisticas(`${this.chaveStorageEstatisticasPrefix}${this.objConfiguracoesConta.idContaEa}`, "tempo", segundosCorridosExecucao)
        this.ultimaAtualizacaoTempoExecucao = new Date();
        this.atualizarEstatisticas()
      } catch (e) {
        console.log("ERROR salvarTempoExecucao", e)
      }
    }

    private async salvarEstatisticasDaConta(forcar: boolean = false) {
      try {
        if (this.salvandoEstatisticas) {
          return
        }

        this.salvandoEstatisticas = true;
        let segundosUltimaAtualizacaoEstatistica = this.ultimoUpdateEstatisticaDaConta ? parseInt((Util.getSecondsBetweenDates(this.ultimoUpdateEstatisticaDaConta, new Date()) as any)) : 0;
        if (forcar || !segundosUltimaAtualizacaoEstatistica || segundosUltimaAtualizacaoEstatistica >= 300) {
          this.ultimoUpdateEstatisticaDaConta = new Date();
          let objEstatisticas = this.getEstatisticasFormatada()
          this.ajax.postAcao(App.Util.config.urlSalvarEstatisticasConta,
            {
              dia: App.Util.getDateStringInternacional(),
              id_conta_ea: this.objConfiguracoesConta.idContaEa,
              partidas: `${this.partidas.won}-${this.partidas.draw}-${this.partidas.loss}`,
              vitorias_validas: this.gerenciamentoRiscoInfos.vitoriasRivals,
              mercado: this.mercadoTranferencia,
              ...objEstatisticas
            }, (objResposta: any) => {
              this.salvandoEstatisticas = false;
            }, {}, false);
        } else {
          this.salvandoEstatisticas = false;
        }
      } catch (e) {
        this.salvandoEstatisticas = false;
        console.log("ERROR salvarEstatisticasDaConta", e)
      }
    }

    private ajustarLimitesGerenciamentoRisco(objVitorias: { v: number, vwl: number }) {
      this.gerenciamentoRiscoInfos.vitoriasRivals = objVitorias.v;
      this.gerenciamentoRiscoInfos.vitoriasWl = objVitorias.vwl;

      console.log("vitoriasRivasl:", this.gerenciamentoRiscoInfos.vitoriasRivals, "vitoriasWL:", this.gerenciamentoRiscoInfos.vitoriasWl);

      if (this.gerenciamentoRiscoInfos.vitoriasWl && this.gerenciamentoRiscoInfos.vitoriasRivals && this.gerenciamentoRiscoInfos.vitoriasWl >= 10 && this.gerenciamentoRiscoInfos.vitoriasRivals >= 25) {
        this.gerenciamentoRiscoInfos.limiteUsoEmHoras = 6
        this.gerenciamentoRiscoInfos.limiteUsoEmMinutos = 360
        this.gerenciamentoRiscoInfos.limiteRequests = 4000
      } else {
        this.gerenciamentoRiscoInfos.limiteUsoEmHoras = 2
        this.gerenciamentoRiscoInfos.limiteUsoEmMinutos = 120
        this.gerenciamentoRiscoInfos.limiteRequests = 1000
      }
    }

    private atualizarInformacoesInfoRivals(objVitorias: { v: number, vwl: number }) {
      this.ajustarLimitesGerenciamentoRisco(objVitorias)
      this.atualizarEstatisticas()
    }

    private registrarEstatisticas(evento: number) {
      switch (evento) {
        case App.SniperExtensao.EVENTO_BUSCA:
          App.Util.incrementEstatisticas(`${this.chaveStorageEstatisticasPrefix}${this.objConfiguracoesConta.idContaEa}`, "buscas")
          App.Util.incrementEstatisticas(`${this.chaveStorageEstatisticasPrefix}${this.objConfiguracoesConta.idContaEa}`, "requests")
          break;
        case App.SniperExtensao.EVENTO_COMPRA:
          App.Util.incrementEstatisticas(`${this.chaveStorageEstatisticasPrefix}${this.objConfiguracoesConta.idContaEa}`, "compras")
          App.Util.incrementEstatisticas(`${this.chaveStorageEstatisticasPrefix}${this.objConfiguracoesConta.idContaEa}`, "requests")
          break;
        case App.SniperExtensao.EVENTO_CAPTCHA:
          App.Util.incrementEstatisticas(`${this.chaveStorageEstatisticasPrefix}${this.objConfiguracoesConta.idContaEa}`, "captchas")
          break;
        case App.SniperExtensao.EVENTO_SOFTBAN:
          App.Util.incrementEstatisticas(`${this.chaveStorageEstatisticasPrefix}${this.objConfiguracoesConta.idContaEa}`, "softbans")
          break;
      }
    }

    private esperarAteQueSejaVerdade(condicao: () => boolean, acao: () => void, acaoTimeout: () => void, tempoLimite: number = 300000): void {
      const intervalo = setInterval(() => {
        if (condicao()) {
          clearInterval(intervalo);
          clearTimeout(timeout);
          acao();
        }
      }, 1000); // Verifica a condição a cada 100ms

      const timeout = setTimeout(() => {
        clearInterval(intervalo);
        acaoTimeout();
      }, tempoLimite); // Limpa o intervalo após o tempo limite
    }

    private aoEnviarUrlElencoFutbin(e: JQueryEventObject) {
      try {
        App.SniperExtensao.exibirLoadingSniperApp('<i class="fa-solid fa-link"></i>', false, "Processando URL Futbin...");
        let urlElenco = $(e.currentTarget).find("input[name=url_elenco_futbin]").val();
        let plataforma = App.Util.usuario.id_plataforma == 3 ? "PC" : 'PS';
        let porcentagemMaisBarato = $(e.currentTarget).find("input[name=porcentagemMaisBarato]").val();
        let request = { evento: "getinelcdme", url: urlElenco, plataforma: plataforma, dadosCompletos: true }
        chrome.runtime.sendMessage(this.idExtensao, request, async (resultado: { status: boolean, response: IRetornoElencoDme }) => {
          let respostaElencoFutbin: IRetornoElencoDme = resultado.response
          console.log("aoEnviarUrlElencoFutbin", respostaElencoFutbin)
          await this.obterElencoDme(respostaElencoFutbin, request, porcentagemMaisBarato);

          this.esperandoEscanearElenco = true;
          this.escanearItensDoClube();

          this.esperarAteQueSejaVerdade(() => !this.esperandoEscanearElenco, () => {
            this.inicializarModoCompraElencoDme(false);
          }, () => {
            this.esperandoEscanearElenco = false
            App.SniperExtensao.ocultarLoadingSniperApp();
            this.exibirLog("danger", "Não foi Possivel Continuar!", "Algum erro ocorreu com essa montagem de DME, se o problema continuar, entre em contato no email: contato@futsniperweb.com.br informando a url do elenco futbin e o problema.", "erro-montagem-dme", true);
          });
        });
      } catch (e) {
        console.log("ERROR aoEnviarUrlElencoFutbin", e)
        App.Util.ocultarModalPaginaCarregando();
      }
    }

    private async obterElencoDme(respostaElencoFutbin: IRetornoElencoDme, request: any, porcentagemMaisBarato: number) {

      App.Util.elencoDme = {
        id: this.getIdElencoSbcFtb(request.url) || null,
        idCategoriaSbc: respostaElencoFutbin.idCategoriaSbc,
        idSbc: respostaElencoFutbin.idSbc,
        imgSbc: respostaElencoFutbin.imgSbc,
        nomeSbc: respostaElencoFutbin.nomeSbc,
        toltalPrice: 0,
        url: request.url,
        elenco: [],
      };

      App.Util.elencoDme.elenco = respostaElencoFutbin.data.map((jogador: IRetornoElencoDmeData) => {
        App.Util.elencoDme.toltalPrice += jogador.price[request.plataforma.toLocaleLowerCase()].price;
        return {
          id: jogador.resourceId,
          assetId: jogador.assetId,
          resourceId: jogador.resourceId,
          teamId: jogador.clubId.value,
          rarityId: jogador.rareType,
          pos: jogador.position.value,
          posDme: jogador.position.value,
          rating: jogador.playerRating,
          nome: jogador.playerName,
          preco: jogador.price[request.plataforma.toLocaleLowerCase()].price,
          precoMin: jogador.precoMin,
          precoMax: jogador.precoMax,
          comprado: false,
          porcentagemMaisBarato: porcentagemMaisBarato ? porcentagemMaisBarato : 0
        }
      });

      console.log("dadosElencoSbc", App.Util.elencoDme)

      return App.Util.elencoDme;
    }


    private getIdElencoSbcFtb(urlElencoFutbin: string) {
      const arrUrl = urlElencoFutbin.split("squad/"); // Divide a URL após 'squad/'

      if (arrUrl[1]) {
        const idElencoSbcFtb = App.Util.obterSomenteNumerosDaString(arrUrl[1]); // Extrai apenas os números
        return idElencoSbcFtb;
      }

      return null; // Retorna null se o formato não for encontrado
    }

    private tratarDadosExportados(request: { exportados: { raridades: any[], paises: any[], ligas: any[], clubes: any[] } }) {
      if (App.SniperExtensao.dadosExportados || !App.Util.usuario.ehAdmin) {
        return
      }

      App.SniperExtensao.dadosExportados = request;
      console.log("📫 Exportar, obrigado Deus!", request.exportados);
      if (App.Util.usuario.ehAdmin && request.exportados.raridades.length) {
        this.ajax.postAcaoSemResposta(`${App.Util.config.urlSalvarFiltrosAtualizados.replace(/\?/g, App.Util.usuario.id.toString())}`, { id_tipo: Util.ID_TIPO_FILTRO_WEBAPP_RARIDADE, dados: request.exportados.raridades }, App.Util.usuario.api_token);
      }

    }

    public static exportar() {
      var paisesFormatados = App.SniperExtensao.dadosExportados.exportados.paises
        .map(pais => {
          return { id: pais.id, nome: pais.name, img: `https://cdn.futnext.com/nation/${pais.id}.png` }
        });

      var ligasFormatados = App.SniperExtensao.dadosExportados.exportados.ligas
        .map(liga => {
          return { id: liga.id, nome: liga.name, img: `https://cdn.futnext.com/league/${liga.id}.png` }
        });

      var clubesFormatados = App.SniperExtensao.dadosExportados.exportados.clubes
        .filter(club => !club.name.includes('teamabbr'))
        .map(club => ({
          id: club.id,
          nome: App.SniperExtensao.idsLigasFemininas.includes(club.league) ? `${club.name} [Woman]` : club.name,
          img: `https://cdn.futnext.com/club/${club.id}.png`
        }));


      // PARA Salvar nos repositorios
      console.log("📫------------------SALVAR NO SISTEMA REPO PAISES --------------------------");
      console.log(JSON.stringify(paisesFormatados).replace(/"/g, '\\"'));
      console.log("___________________________________________________________");

      console.log("📫------------------SALVAR NO SISTEMA REPO LIGAS --------------------------")
      console.log(JSON.stringify(ligasFormatados).replace(/"/g, '\\"'));
      console.log("___________________________________________________________");

      console.log("📫------------------SALVAR NO SISTEMA REPO CLUBES --------------------------");
      console.log(JSON.stringify(clubesFormatados).replace(/"/g, '\\"'));
      console.log("___________________________________________________________");

    }

    private monitorarSniperAtivo() {
      if (this.monitorarSniperAtivoInterval) return; // já monitorando

      this.ultimoSniperAtivo = App.SniperExtensao.sniperAtivo;
      this.monitorarSniperAtivoInterval = setInterval(() => {
        if (App.SniperExtensao.sniperAtivo !== this.ultimoSniperAtivo) {
          this.ultimoSniperAtivo = App.SniperExtensao.sniperAtivo;
          if (App.SniperExtensao.sniperAtivo) {
            this.ligarRotinaIntercalarAbaChrome();
          } else {
            this.desligarRotinaIntercalarAbaChrome();
          }
        }
      }, 5000); // verifica a cada 5 segundos
    }
  }
}
